import {globals, globalUser} from "../modules/globals.js"
import {
    commaSeparate, gameLimits,
    getCurrentGame,
    getMonthsWord,
    getRandomChoice, isPowerOfTwo,
    shuffle,
    toTitleCase
} from "../modules/helpers.js"
import {
    addTournamentParticipantsEditing,
    applySentenceCase,
    getChampionshipDisplayName, getChampionshipGimmickRestrictionInfoHtml, getChampionshipGimmickRestrictionText,
    getChampionshipPrestigeIconHtml, getGimmickDebutHtml, getGimmickMatchUnlockedBy,
    getOvernessLevelText,
    getPointsHtml,
    getRosterMemberFatigueClass,
    getRosterMemberMoraleClass,
    getRosterMemberMoraleText,
    getShortenedName,
    getStarRatingHtml,
    getSuperstarInjuredText,
    getSuperstarTraitHelpHtml, getTournamentGroupsHtml, hideContent,
    hideEventCardContent,
    makeGameRequest,
    replaceAll,
    runFuseElementsSearch, updateGamePointsAndFans
} from "./ui-helpers.js"
import {
    showChampionshipInformationGraphic,
    showFactionInformationGraphic,
    showTalentInformationGraphic
} from "./graphics.js"
import {playSoundEffect} from "./sounds.js";
import {getBookingData, getBookingSelectionInformation, getViewRosterMemberData} from "../modules/rosters.js";
import {getFactionSuperstarsHtml, showViewFactionDetailsPage, updateFactionLeaderSelect} from "./factions.js";
import {
    addFeudToMatchOrSegment, changeFeudBlowoff,
    getAvailableFeudsForMatch,
    getFeudSegmentsInformation,
    getFeudsForBooking, removeFeudFromMatchOrSegment
} from "../modules/feuds.js";
import {
    generateGimmickMatchLocation, generateGimmickMatchObject,
    getAddManagerRelationshipData,
    getBookingGimmickMatchesData,
    getCompanyProducers, getCompanyUniqueTournaments
} from "../modules/companies.js";
import {showGetAvailableSegmentItemsData} from "./segments.js";
import {
    addProducerToSegment,
    bookSegment,
    createCustomProductionPackage,
    deleteCompanySegment,
    getAvailableSegmentItems,
    getSegmentInputsData,
    removeProducerFromSegment
} from "../modules/segments.js";
import {customSegmentsData} from "./custom-segments.js";
import {
    getCompanyFactionsForSelection,
    getFactionSuperstarsRequest,
    getSuperstarsAvailableForFaction
} from "../modules/factions.js";
import {getBrandsDataForSegment} from "../modules/brands.js";
import {getManagedTalentForManager} from "../modules/managers.js";
import {
    getEventCardSegmentHtml,
    getMatchLimitsHtml,
    getEventCardMatchHtml,
    addEventCardMatchesAndSegments
} from "./event-card.js";
import {loadHomePage} from "./home-page.js";
import {
    addGimmickMatchToMatch,
    addManagerToMatch,
    addMatch, changeFactionTagTeamMembers,
    changeMatchChampionships,
    changeMatchOrSegmentOrder, changeTrioTagTeamMembers,
    deleteCompanyMatch,
    getAddMatchManagerSelections,
    getMatchChampionshipsForSelection,
    getRemoveMatchManagerSelections,
    removeChampionshipFromMatch, removeManagerFromMatch
} from "../modules/matches.js";
import {
    changeGameSettingRequest,
    getAvailableFeudItemHtml,
    getTournamentBracketHtml,
    getUnavailableFeudItemHtml
} from "./manage-sub-menu.js";
import {changeSuperstarAttire} from "../modules/superstars.js";
import {showViewRosterMemberPageData} from "./roster-sub-menu.js";
import {autoBookEventRequest, runSimulator} from "../modules/simulator.js";
import {createTournament, getTournamentDisplay} from "../modules/tournaments.js";
import {getNewsHtml} from "./events.js";
import {checkTutorialStepAction, disableTutorialPointerEvents} from "./tutorial.js";

const emptyTalentInfoHtml = '<div class="superstar-information-container font-bold medium-grey">' +
            'Participant Details' +
            '<div class="empty-superstar-info light-grey">' +
            '<div class="vertical-center">Hover over a Participant to display their details here</div>' +
            '</div>' +
            '</div>';
const tagMatchOptionsHtml = '<div class="tag-match-options margin-top-10">' +
    '<span class="tag-match-option selected">Tag</span>' +
    '<span class="tag-match-option">Trio</span>' +
    '<span class="tag-match-option">2v2</span>' +
    '<span class="tag-match-option">3v3</span>' +
    '<span class="tag-match-option">4v4</span>' +
    '<span class="tag-match-option">5v5</span>' +
    '<span class="tag-match-option">1v2</span>' +
    '<span class="tag-match-option">1v3</span>' +
    '<span class="tag-match-option">2v3</span>' +
    '<span class="tag-match-option">?v?</span>' +
    '</div>';
const customTeamSizeInput =
    '<div class="margin-top-10 custom-team-size-inputs">' +
    '<input type="number" class="custom-team-size-input custom-team-size-a styled-input" name="custom-team-size" value="' + 3 + '" max="10" min="1">' +
    '<input type="number" class="custom-team-size-input custom-team-size-b styled-input margin-left-5" name="custom-team-size" value="' + 4 + '" max="10" min="1">' +
    '</div>';
let randomizeFeudHintShown = false;

// Declare variables
let selectedParticipants = [];
let selectedElements = [];
let selectedChampionship;
let selectedGimmickMatch;
let teams = [];
let tagTeamSize = 2;
let tagVal = 2;
let handicapSize;
let segmentParticipants = [];

$(document).ready(function () {

    // Declare selectors
    const $game = $('#game');
    const $mainMenuRight = $('#main-menu-right');
    const $addSegmentItemMenu = $("#add-segment-item-menu");
    const $segmentItemsContainer = $("#segment-items-container");
    const $bookingContainer = $('#booking-container');
    const $selectGimmickMatchContainer = $('#select-gimmick-match-container');
    const $container = $('#container');
    const $matches = $('#matches');


    // ** MATCHES **


    // Book singles menu button
    $mainMenuRight.on('click', '#book-singles-menu-button', async function () {

        // Reset ui
        $('#booking-menu').find('li').removeClass('selected');
        $(this).addClass('selected');
        $('#booking-talent-container').removeClass('compact segments-selection');
        $('.match-participants-container').text('No participants selected');
        $("#multi-match-info").remove();
        $('.tooltip').remove();
        $(".tag-match-options").remove();
        $("#show-gimmick-matches-button").removeClass("selected").find('.fa').removeClass('fa-minus-circle').addClass('fa-plus-circle');
        $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
        $("#show-gimmick-matches-button").show();
        $('#add-tournament-menu-button').show();

        // Reset variables
        selectedChampionship = '';
        selectedParticipants = [];
        selectedElements = [];
        selectedGimmickMatch = '';

        // Show feuds
        let matchType = 'singles';
        const $bookMatchFeudsContainer = $('.book-match-feuds-container');
        await makeGameRequest(getFeudsForBooking, {matchType}, showGetFeudsForBookingData,
            {matchType, $el: $bookMatchFeudsContainer}, false, true);

        // Show singles booking data
        await makeGameRequest(getBookingData, {matchType}, showGetBookingData, {matchType});
    });

    // Book tag team menu button
    $mainMenuRight.on('click', '#book-tag-team-menu-button', async function () {

        // Reset ui
        $('#booking-menu').find('li').removeClass('selected');
        $(this).addClass('selected');
        $('#booking-talent-container').removeClass('compact segments-selection');
        $('.match-participants-container').text('No participants selected');
        $("#multi-match-info").remove();
        $('.tooltip').remove();
        $(".tag-match-options").remove();
        $("#show-gimmick-matches-button").removeClass("selected").find('.fa').removeClass('fa-minus-circle').addClass('fa-plus-circle');
        $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
        $("#show-gimmick-matches-button").show();
        $('#add-tournament-menu-button').show();

        // Reset variables
        selectedChampionship = '';
        selectedParticipants = [];
        selectedElements = [];
        selectedGimmickMatch = '';
        teams = [];
        teams[0] = [];
        teams[1] = [];
        tagTeamSize = 2;
        tagVal = 2;
        handicapSize = '';

        // Add tag team match options
        $("#booking-menu").append(tagMatchOptionsHtml);

        // Show feuds
        let matchType = 'tag';
        const $bookMatchFeudsContainer = $('.book-match-feuds-container');
        await makeGameRequest(getFeudsForBooking, {matchType}, showGetFeudsForBookingData,
            {matchType, $el: $bookMatchFeudsContainer}, false, true);

        // Show tag team booking data
        let tagTeamType = 'tag-team';
        await makeGameRequest(getBookingData, {matchType, tagTeamType}, showGetBookingData,
            {matchType: matchType, tagTeamType: tagTeamType});

        // Tag match option button
        $("#main-menu-right").off('click', '.tag-match-option');
        $("#main-menu-right").on('click', '.tag-match-option', async function () {

            // Reset ui
            $(".tag-match-option").removeClass('selected');
            $(this).addClass('selected');
            $("#multi-match-info").html('');
            $("#multi-match-info").remove();
            $('.match-participants-container').text('No participants selected');
            $("#show-gimmick-matches-button").removeClass("selected").find('.fa').removeClass('fa-minus-circle').addClass('fa-plus-circle');
            $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
            $('.custom-team-size-inputs').remove();
            $("#show-gimmick-matches-button").show();
            $("#add-tournament-menu-button").removeClass("selected");

            // Reset variables
            selectedParticipants = [];
            selectedElements = [];
            selectedGimmickMatch = '';
            selectedChampionship = '';
            tagVal = $(this).text();

            // Singles
            if (['2v2', '3v3', '4v4', '5v5', '1v2', '1v3', '2v3', '?v?'].indexOf(tagVal) >= 0) {

                // Show singles booking data
                matchType = 'singles';
                let getVacatedChampionships = true;
                if (tagVal === '2v2' || tagVal === '3v3') {
                    tagTeamType = (tagVal === '2v2') ? 'tag-team' : 'trio';
                }
                else {
                    tagTeamType = null;
                    // Don't show vacated titles for 4v4 and 5v5 matches
                    getVacatedChampionships = false;
                }
                await makeGameRequest(getBookingData, {
                    matchType, tagTeamType,
                    getVacatedChampionships: getVacatedChampionships
                }, showGetBookingData, {matchType});

                // Add handicap size
                if (['1v2', '1v3', '2v3'].indexOf(tagVal) >= 0) {
                    handicapSize = [parseInt(tagVal.charAt(0)), parseInt(tagVal.charAt(2))];
                }
                else if (tagVal === '?v?') {
                    // Show custom team size inputs
                    let teamASize = 3;
                    let teamBSize = 4;
                    handicapSize = [teamASize, teamBSize];
                    $('.tag-match-options').append(customTeamSizeInput);
                }
                // Add tag team size
                else {
                    tagTeamSize = parseInt(tagVal.charAt(0));
                    handicapSize = '';
                }

                // Select multi person button
                $("#multi-match-button").addClass('selected');
                $("#multi-match-button").find('.fa').removeClass('fa-circle-o').addClass('fa-check-circle-o');

                // Hide feuds
                $('.book-match-feuds-container').hide();
            }
            // Tag
            else {
                tagTeamType = (tagVal === 'Trio') ? 'trio' : 'tag-team';

                // Show feuds
                let feudMatchType = (tagTeamType === 'tag-team') ? 'tag' : 'trio';
                const $bookMatchFeudsContainer = $('.book-match-feuds-container');
                await makeGameRequest(getFeudsForBooking, {matchType: feudMatchType}, showGetFeudsForBookingData,
                    {matchType: feudMatchType, $el: $bookMatchFeudsContainer}, false, true);

                // Show tag team booking data
                matchType = 'tag';
                await makeGameRequest(getBookingData, {matchType, tagTeamType}, showGetBookingData,
                    {matchType: matchType, tagTeamType: tagTeamType});
            }
        });
    });

    // Change custom team size
    $mainMenuRight.on('change', '.custom-team-size-input', function () {
        let customTeamSizeInputA = $('.custom-team-size-a').val();
        let customTeamSizeInputB = $('.custom-team-size-b').val();
        handicapSize = [parseInt(customTeamSizeInputA), parseInt(customTeamSizeInputB)];
    });

    // Booking talent sort
    $('.superstar-sort').on('change', function () {
        let value = $(this).val();
        let tagMatch = ($('.tag-match-option.selected').text() === 'Tag' || $('.tag-match-option.selected').text() === 'Trio') ||
            ($('.book-segment-option.selected').text() === 'Tag' || $('.book-segment-option.selected').text() === 'Factions');
        if (tagMatch) {
            applyTeamSort(value)
        }
        else {
            applySuperstarSort(value)
        }
    });

    // Booking talent sort order
    $('.superstar-sort-order').on('click', function() {
        let icon = $(this).find('i');
        let tagMatch = ($('.tag-match-option.selected').text() === 'Tag' || $('.tag-match-option.selected').text() === 'Trio') ||
            ($('.book-segment-option.selected').text() === 'Tag' || $('.book-segment-option.selected').text() === 'Factions');

        if (tagMatch) {
            let tagTeamsContainer = $('#tag-teams');
            let triosContainer = $('#trios');
            let factionsContainer = $('#factions');
            // Reverse team elements
            if (icon.hasClass('fa-sort-up')) {
                icon.removeClass('fa-sort-up').addClass('fa-sort-down');
                tagTeamsContainer.append(tagTeamsContainer.find('.superstar-select').get().reverse());
                triosContainer.append(triosContainer.find('.superstar-select').get().reverse());
                factionsContainer.append(factionsContainer.find('.superstar-select').get().reverse());
            }
            else if (icon.hasClass('fa-sort-down')) {
                icon.removeClass('fa-sort-down').addClass('fa-sort-up');
                tagTeamsContainer.append(tagTeamsContainer.find('.superstar-select').get().reverse());
                triosContainer.append(triosContainer.find('.superstar-select').get().reverse());
                factionsContainer.append(factionsContainer.find('.superstar-select').get().reverse());
            }
        }
        else {
            let resultsContainer = $('#all-superstars');
            let retiredContainer = $('#retired');
            let notAvailableContainer = $('#not-available');
            let managersContainer = $('#managers');
            // Reverse superstar elements
            if (icon.hasClass('fa-sort-up')) {
                icon.removeClass('fa-sort-up').addClass('fa-sort-down');
                resultsContainer.append(resultsContainer.find('.superstar-select').get().reverse());
                retiredContainer.append(retiredContainer.find('.superstar-select').get().reverse());
                notAvailableContainer.append(notAvailableContainer.find('.superstar-select').get().reverse());
                managersContainer.append(managersContainer.find('.superstar-select').get().reverse());
            }
            else if (icon.hasClass('fa-sort-down')) {
                icon.removeClass('fa-sort-down').addClass('fa-sort-up');
                resultsContainer.append(resultsContainer.find('.superstar-select').get().reverse());
                retiredContainer.append(retiredContainer.find('.superstar-select').get().reverse());
                notAvailableContainer.append(notAvailableContainer.find('.superstar-select').get().reverse());
                managersContainer.append(managersContainer.find('.superstar-select').get().reverse());
            }
        }
    });

    // Booking talent search
    $(".superstar-search-input").on('input', function(){
        let tagMatch =
            ($('.tag-match-option.selected').text() === 'Tag' || $('.tag-match-option.selected').text() === 'Trio') ||
            ($('.book-segment-option.selected').is(":visible") &&
                ($('.book-segment-option.selected').text() === 'Tag' || $('.book-segment-option.selected').text() === 'Factions')
            );
        if (tagMatch) {
            runTeamSearch()
        }
        else {
            runSuperstarSearch()
        }
    });

    // Booking talent filter
    $("#booking-talent-menu").on('click', '.superstar-filter', function(){
        let filterName;
        let filterBrandName;

        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
        }
        else {
            $('.superstar-filter').removeClass('selected');
            $(this).addClass('selected');
            filterName = $(this).attr('data-value');
            filterBrandName = $(this).attr('data-brand-name');
        }

        let tagMatch = ($('.tag-match-option.selected').text() === 'Tag' || $('.tag-match-option.selected').text() === 'Trio') ||
            ($('.book-segment-option.selected').text() === 'Tag' || $('.book-segment-option.selected').text() === 'Factions');
        if (tagMatch) {
            applyTeamFilter(filterName, filterBrandName);
        }
        else {
            applySuperstarFilter(filterName, filterBrandName);
        }
    });

    // Booking talent click
    $('#booking-talent-container').on('click', '.superstar-select', async function() {
        let $this = $(this);
        let parentId = $this.parent().closest('div').attr('id');

        // Don't run for training, not available talent and segment booking
        if ($('#booking-talent-container').hasClass('segments-selection')) {
            return;
        }
        if (parentId === 'training' || parentId === 'not-available') {
            playSoundEffect('error');
            if (parentId === 'not-available') {
                notie.alert({type: 3, text: "That talent is not available for a match"});
            }
            return;
        }

        playSoundEffect('success');

        // Check for title selection
        if (parentId === 'vacated-titles') {
            $this.toggleClass('selected');
            if (!selectedChampionship) {
                selectedChampionship = $this;
            }
            else {
                if ($this.is(selectedChampionship)) {
                    selectedChampionship = '';
                }
                else {
                    selectedChampionship.removeClass('selected');
                    selectedChampionship = $this;
                }
            }

            // Add selected title to tournament award options
            if ($('#add-tournament-menu-button').hasClass('selected')) {
                if (selectedChampionship) {
                    let div =
                        '<label class="control control--radio margin-right-10 award-options-championship">' + selectedChampionship.text() +
                        '<input type="radio" name="radio-award-option" value="championship">' +
                        '<div class="control__indicator"></div></label>';
                    if (!$('.award-options-championship').length) {
                        $('.award-options').append(div);
                    }
                    else {
                        $('.award-options-championship').replaceWith(div)
                    }
                    $('.award-options-match-contract').hide();
                    $('input[name="radio-award-option"]').val(['championship']);
                }
                // Remove championship from tournament award options
                else {
                    $('.award-options-championship').remove()
                }
            }

            // Tutorial action check
            checkTutorialStepAction('click_title_select');
        }
        else {
            // Check if user is selecting an available talent
            if (parentId !== 'not-available' && parentId !== 'training') {

                let name = $this.data('name');
                let uid = $this.data('uid');
                let participantType = $this.attr('data-type');
                let tournament = $('#add-tournament-menu-button').hasClass('selected');
                let bookSingles = $('#book-singles-menu-button').hasClass('selected');

                if (bookSingles) {
                    await processMatchParticipantSelection(name, $this, participantType, uid, tournament);
                }
                else {
                    // Selecting team
                    if (parentId === 'tag-teams' || parentId === 'trios' || parentId === 'factions') {
                        if (tournament && parentId === 'factions') {
                            notie.alert({type: 3, text: "You cannot use factions in tournaments. Create a Tag Team or " +
                                    "Trio for them instead."});
                            return false;
                        }
                        await processMatchParticipantSelection(name, $this, participantType, uid, tournament);
                    }
                    // Selecting 4v4, 5v5 etc
                    else {
                        await processSinglesTagMatchParticipantSelection(name, $this, participantType, uid);
                    }
                }

                // Reset search, scroll to selected element
                if ($('.superstar-search-input').val()) {
                    $('.superstar-search-input').val('').focus().trigger('input');
                    let $container = $('#booking-talent-container');
                    $container.scrollTop($this.offset().top - $container.offset().top + $container.scrollTop());
                }

                // Tutorial action check
                if (bookSingles) {
                    checkTutorialStepAction('click_superstar_select');
                }
                else {
                    checkTutorialStepAction('click_team_select');
                }
            }
        }
    });

    // Booking feud click
    $(".book-match-feuds-container").on('click', '.feud-container', function () {
        let $this = $(this);
        let notAvailable = '';

        // Get participants
        let participants = $this.find('.feud-participants').text().split(' vs ');
        let participantElements = Array.from(participants, function (participant) {
            let el = $('#booking-talent-container .superstar-select').filter(function () {
                return $(this).data('name') === participant;
            });
            if (el.length <= 0) {
                notAvailable = participant;
                return false;
            }
            return el;
        });

        if (notAvailable) {
            notie.alert({type: 3, text: '{0} is not available to be booked at this Event'.format(notAvailable)});
            return false;
        }

        // Reset selections
        selectedParticipants = [];
        selectedElements.forEach(function (x) {
            // Unselect superstars not part of feud
            if (participants.indexOf(x.text()) < 0) {
                $(x).removeClass('selected')
            }
        });
        selectedElements = [];

        if ($this.hasClass('selected')) {
            // Deselect this feud
            $this.removeClass('selected');
            $(".feud-container").show();
            $('.match-participants-container').text('No participants selected');

            // If participant element is not selected, select it so 'click' trigger unselects it
            participantElements.forEach(function(element) {
                if (!($(element).hasClass('selected'))) {
                    $(element).addClass('selected');
                }
            });

            // Scroll to previous position
            $(".book-match-feuds-container").scrollTop($(".book-match-feuds-container").data('scrollTop'));
        }
        else {
            // Set scroll position
            $(".book-match-feuds-container").data('scrollTop', $(".book-match-feuds-container").scrollTop());

            // Unselect others
            $(".feud-container").removeClass('selected').hide();

            // Select this feud
            $this.addClass('selected');
            $this.show();

            // Select multi match
            if (!$("#multi-match-button").hasClass('selected')) {
                $("#multi-match-button").trigger('click')
            }

            // If participant element is selected, unselect it so 'click' trigger selects it
            participantElements.forEach(function(element) {
                if ($(element).hasClass('selected')) {
                    $(element).removeClass('selected');
                }
            });
        }

        // Trigger click on participant elements
        participantElements.forEach(function(element) {
            element.trigger('click');
        });

        // Tutorial action check
        checkTutorialStepAction('click_match_feud');
    });

    // Show gimmick matches button
    $bookingContainer.on('click', '#show-gimmick-matches-button', async function () {
        // Reset ui
        hideEventCardContent($('#event-card'));
        $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
        $('#select-gimmick-match-container').hide();
        $("#gimmick-matches-container").remove();

        if ($("#show-gimmick-matches-button").hasClass("selected")) {
            // Unselect
            selectedGimmickMatch = '';
            $(this).find('.fa').removeClass('fa-minus-circle').addClass('fa-plus-circle');

            // Update match participants text
            updateMatchParticipantsText();
        }
        else {
            // Select
            $(this).find('.fa').removeClass('fa-plus-circle').addClass('fa-minus-circle');

            // Add new div for gimmick matches
            let newDiv = $('<div id="gimmick-matches-container" class="box"></div>');
            let scrollDiv = $('<div class="gimmick-matches-container-scroll"></div>');
            $(newDiv).append(
                '<div class="margin-bottom-30">' +
                '   <span class="menu-header-color font-mukta-mahee font-1p325em">Gimmick Match</span>' +
                '</div>'
            );

            let tagMatchOptionSelected = $(".tag-match-options .selected").text();

            // Load gimmick matches
            await makeGameRequest(getBookingGimmickMatchesData, {tagMatchOptionSelected},
                showGetBookingGimmickMatchesData, {scrollDiv, newDiv}, false);
        }

        $("#show-gimmick-matches-button").toggleClass("selected");
    });

    // Gimmick match click handler
    $selectGimmickMatchContainer.on('click', '.gimmick-match', async function () {

        // Show error if open challenge and more than one participant selected
        if ($(this).attr('data-consequence') === 'random-opponent' && selectedParticipants.length > 1) {
            playSoundEffect('error');
            notie.alert({type: 3, text: "This gimmick match cannot be booked with more than 1 participant"});
            return false;
        }

        playSoundEffect('success');

        $('.confirm-gimmick-match-for-match').remove();
        $('.tooltip').remove();

        // Select event card gimmick match so it can be deselected
        if ($('.event-card-match-add-gimmick-button.selected').length > 0 && !selectedGimmickMatch) {
            if ($('#gimmick-matches-container .selected').length > 0) {
                selectedGimmickMatch = $('#gimmick-matches-container .selected');
            }
        }

        if (!selectedGimmickMatch) {
            selectedGimmickMatch = $(this);
            $(this).toggleClass("selected");
            if (!$(this).hasClass("selected")) { // If clicking on already selected gimmick match, unselect it
                selectedGimmickMatch = '';
            }
            else {
                // Set scroll position
                $('.gimmick-matches-container-scroll').data('scrollTop', $('.gimmick-matches-container-scroll').scrollTop());

                // Hide other gimmick matches
                $(".gimmick-match-item").each(function () {
                    if ($(this)[0] !== selectedGimmickMatch[0]) {
                        $(this).hide();
                    }
                });
                // Show selected gimmick match
                $(".gimmick-match-item").promise().done(function () {
                    if (selectedGimmickMatch) {
                        selectedGimmickMatch.find('.gimmick-match-details').show();

                        // Show full name
                        selectedGimmickMatch.find('.gimmick-match-item-name').text(selectedGimmickMatch.attr('data-name'));

                        if ($('.event-card-match-add-gimmick-button.selected').length > 0) {
                            selectedGimmickMatch.after('<button type="button" ' +
                                'class="display-block confirm-gimmick-match-for-match button retro-button condensed blue-button-background' +
                                ' margin-top-12 display-block condensed">Add Gimmick Match</button>');
                            // Don't select gimmick match for booking if adding to existing match
                            selectedGimmickMatch = '';
                        }
                    }
                });
                $("#gimmick-matches-container").children('#auto-picker').remove();

                // Show auto picker for battle royal
                if ($(this).attr('data-auto-picker') === 'true') {
                    let autoPickerHtml = getAutoPickerHtml();
                    $("#gimmick-matches-container").append(autoPickerHtml);
                }
            }
        }
        else {
            selectedGimmickMatch.toggleClass('selected'); // Unselect previously selected gimmick match
            selectedGimmickMatch.find('.gimmick-match-details').hide();

            // Hide full name
            if (selectedGimmickMatch.attr('data-name').length > 13) {
                selectedGimmickMatch.find('.gimmick-match-item-name').text(selectedGimmickMatch.attr('data-name').slice(0, 13) + '.');
            }

            // Clicking on selected gimmick match unselects it
            if (selectedGimmickMatch.attr('data-name') === $(this).attr('data-name')) {
                // Show other gimmick matches
                $(".gimmick-match-item").each(function () {
                    if ($(this)[0] !== selectedGimmickMatch[0]) {
                        $(this).show();
                    }
                });
                $("#gimmick-matches-container").children('#auto-picker').remove();
                selectedGimmickMatch = '';
                // Scroll to previous position
                $('.gimmick-matches-container-scroll').scrollTop($('.gimmick-matches-container-scroll').data('scrollTop'));
            }
            // Select new gimmick match
            else {
                $(this).toggleClass("selected");
                selectedGimmickMatch = $(this);
            }
        }

        // Add match if open challenge and one participant selected
        if (selectedGimmickMatch && selectedGimmickMatch.attr('data-consequence') === 'random-opponent' &&
            selectedParticipants.length === 1) {
            await callAddMatch();
        }

        // Update match participants text
        updateMatchParticipantsText();

        // Tutorial action check
        checkTutorialStepAction('click_gimmick_match_item');
    });

    // Auto picker
    $game.on('click', '#auto-pick', function () {
        if ($('#book-singles-menu-button').hasClass('selected')) {

            let numberToPick = parseInt($(this).siblings('#auto-pick-input').val());
            let autoPickerType = $(this).attr('data-type');
            let tournament = autoPickerType === 'tournament';
            let resultsContainer = $('#all-superstars');
            let mainContainer = $('#main-eventers, #upper-midcarders, #lower-midcarders, #jabroni');
            let notieText = '';

            // Reset selections
            selectedElements.forEach(function (x) {
                $(x).toggleClass("selected");
            });
            selectedParticipants = [];
            selectedElements = [];
            $(".feud-container").show().removeClass('selected');
            $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
            $('.superstar-select-feud-details').remove();

            // Popularity sort
            let autoSortBy = $(this).siblings("#auto-pick-sort").val();

            // Select results container for filtering, notify of active filter or search
            if (resultsContainer.is(':visible')) {
                mainContainer = resultsContainer;
                if ($(".superstar-filter.selected").length) {
                    notieText += `<span class="display-block">"${$(".superstar-filter.selected").text().trim()}" booking filter is active</span>`;
                }
                else if ($(".superstar-search-input").val()) {
                    notieText += '<span class="display-block">Search filter is active</span>';
                }
            }

            let superstarsElement = mainContainer.find('.superstar-select');
            // Top
            if (["1", "2", "3", "4"].includes(autoSortBy)) {
                superstarsElement = superstarsElement.filter(function() {
                    let popularity = $(this).attr('data-popularity');
                    if (autoSortBy === "1") {
                        return popularity >= 600
                    }
                    else if (autoSortBy === "2") {
                        return popularity >= 600 && popularity < 800
                    }
                    else if (autoSortBy === "3") {
                        return popularity >= 400 && popularity < 800
                    }
                    else if (autoSortBy === "4") {
                        return popularity >= 400 && popularity < 600
                    }
                });
                superstarsElement = $(shuffle(superstarsElement));
            }
            // Bottom
            else if (autoSortBy === "5") {
                superstarsElement = $(superstarsElement.get().reverse())
            }
            // Random
            else if (autoSortBy === "6") {
                superstarsElement = $(shuffle(superstarsElement))
            }

            // Pronoun filter
            let autoPickPronounFilter = $(this).siblings("#auto-pick-pronoun-filter").val();

            // He
            if (autoPickPronounFilter === "1") {
                superstarsElement = superstarsElement.filter('[data-pronoun="he"]')
            }
            // She
            else if (autoPickPronounFilter === "2") {
                superstarsElement = superstarsElement.filter('[data-pronoun="she"]')
            }
            // They
            else if (autoPickPronounFilter === "3") {
                superstarsElement = superstarsElement.filter('[data-pronoun="they"]')
            }

            // Booked filter
            let autoPickBookedFilter = $(this).siblings("#auto-pick-booked-filter").val();

            // Not booked
            if (autoPickBookedFilter === "0") {
                superstarsElement = superstarsElement.filter(':not(.booked)')
            }

            superstarsElement.each(function (index, element) {
                // Select and add superstars
                if (selectedParticipants.length < numberToPick) {
                    if (jQuery.inArray($(element).text(), selectedParticipants) === -1 &&
                        $(element).parent().attr('id') !== 'not-available' &&
                        $(element).parent().attr('id') !== 'vacated-titles') { // Only select superstars
                        selectedParticipants.push($(element).text());
                        selectedElements.push($(element));
                        $(element).toggleClass("selected");
                    }
                }
                else {
                    return false;
                }
            });

            // Format selection text
            let matchParticipantsText;
            let participantsText;
            if (tournament) {
                participantsText = selectedParticipants.join(', ');
            }
            else {
                participantsText = selectedParticipants.join(' vs ');
            }

            // Show match participants text if more than 1 superstar selected
            if (selectedParticipants.length > 0) {
                let suffix = 'Match';
                if (tournament) {
                    suffix = 'Tournament'
                }

                let selectedGimmickMatchName = selectedGimmickMatch ? selectedGimmickMatch.attr('data-name') : null;
                if (selectedGimmickMatchName) {
                    matchParticipantsText = "{0} ({1} Person {2} {3})".format(participantsText, selectedParticipants.length,
                        selectedGimmickMatchName, suffix);
                }
                else {
                    matchParticipantsText = "{0} ({1} Person {2})".format(participantsText, selectedParticipants.length, suffix);
                }

                // Show match participants text
                if (matchParticipantsText) {
                    let addButton = '';
                    if (!tournament && selectedParticipants.length > 1) {
                        addButton = '<button type="button" id="add-match-button" ' +
                            'class="button retro-button blue-button-background condensed display-block margin-top-5">' +
                            'Book' +
                            '</button>'
                    }
                    $("#multi-match-info").remove();
                    $(".match-participants-container").html('<div class="font-bold" ' +
                        ' id="multi-match-info">' +
                        matchParticipantsText +
                        addButton +
                        '</div>');
                }
            }
            else {
                notieText += "<span class='display-block'>No superstars found</span>";
                $("#multi-match-info").remove();
            }

            // Show tournament participants
            if (tournament) {
                $('.tournament-participants-selected').text(selectedParticipants.length)
            }

            if (notieText) {
                notie.alert({type: 4, text: notieText});
            }
        }
        else if ($('#book-tag-team-menu-button').hasClass('selected')) {

            let numberToPick = parseInt($(this).siblings('#auto-pick-input').val());
            let autoPickerType = $(this).attr('data-type');
            let tournament = autoPickerType === 'tournament';
            let notieText = '';

            // Reset selections
            selectedElements.forEach(function (x) {
                $(x).toggleClass("selected");
            });
            selectedParticipants = [];
            selectedElements = [];
            $(".feud-container").show().removeClass('selected');
            $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
            $('.superstar-select-feud-details').remove();

            // Notify of active filter or search, select results container for filtering
            if ($(".superstar-filter.selected").length && $(".superstar-filter.selected").attr('data-value')) {
                notieText += `<span class="display-block">"${$(".superstar-filter.selected").text().trim()}" booking filter is active</span>`;
            }
            else if ($(".superstar-search-input").val()) {
                notieText += '<span class="display-block">Search filter is active</span>';
            }

            let tagTeamType = (tagVal === 'Trio') ? 'trio' : 'tag-team';
            let teamDiv = (tagTeamType === 'trio') ? $('#trios') : $('#tag-teams');
            let autoSortBy = $(this).siblings("#auto-pick-sort").val();
            let tagTeamsElement;
            if (autoSortBy === "0") {
                tagTeamsElement = teamDiv.find('.superstar-select')
            }
            else if (autoSortBy === "5") {
                tagTeamsElement = $(teamDiv.find('.superstar-select').get().reverse())
            }
            else if (autoSortBy === "6") {
                tagTeamsElement = $(shuffle(teamDiv.find('.superstar-select')))
            }

            tagTeamsElement.each(function (index, element) {
                // Select and add superstars
                if (selectedParticipants.length < numberToPick) {
                    if (jQuery.inArray($(element).text(), selectedParticipants) === -1 &&
                        $(element).parent().attr('id') !== 'not-available' &&
                        $(element).parent().attr('id') !== 'vacated-titles') { // Only select superstars
                        selectedParticipants.push($(element).text());
                        selectedElements.push($(element));
                        $(element).toggleClass("selected");
                    }
                }
                else {
                    return false;
                }
            });

            // Format selection text
            let matchParticipantsText;
            let participantsText;
            if (tournament) {
                participantsText = selectedParticipants.join(', ');
            }
            else {
                participantsText = selectedParticipants.join(' vs ');
            }

            // Show match participants text if more than 1 superstar selected
            if (selectedParticipants.length > 0) {
                let suffix = 'Match';
                if (tournament) {
                    suffix = 'Tournament'
                }

                let selectedGimmickMatchName = selectedGimmickMatch ? selectedGimmickMatch.attr('data-name') : null;
                if (selectedGimmickMatchName) {
                    matchParticipantsText = "{0} ({1} Team {2} {3})".format(participantsText, selectedParticipants.length,
                        selectedGimmickMatchName, suffix);
                }
                else {
                    matchParticipantsText = "{0} ({1} Team {2})".format(participantsText, selectedParticipants.length, suffix);
                }
                // Add match participants text to screen
                if (matchParticipantsText) {
                    let addButton = '';
                    if (!tournament && selectedParticipants.length > 1) {
                        addButton = '<button type="button" id="add-match-button" ' +
                            'class="button retro-button blue-button-background condensed display-block margin-top-5">' +
                            'Book' +
                            '</button>';
                    }
                    $("#multi-match-info").remove();
                    $(".match-participants-container").html('<div class="font-bold" ' +
                        ' id="multi-match-info">' +
                        matchParticipantsText +
                        addButton +
                        '</div>');
                }
            }
            else {
                notieText += "No teams found";
                $("#multi-match-info").remove();
            }

            // Show tournament participants
            if (tournament) {
                $('.tournament-participants-selected').text(selectedParticipants.length)
            }

            if (notieText) {
                notie.alert({type: 4, text: notieText});
            }
        }

        // Select multi match button
        $("#multi-match-button").addClass('selected');
        $("#multi-match-button").find('.fa').removeClass('fa-circle-o').addClass('fa-check-circle-o');
    });

    // Prevent gimmick match click on inputs
    $selectGimmickMatchContainer.on('click', '.match-event-select, .match-fall-select, .match-referee-select, ' +
        '.match-name-input, .gimmick-match-generate-object-button', function (e) {
        e.stopPropagation();
    });

    // Set event of gimmick match element
    $selectGimmickMatchContainer.on('change', '.match-event-select', function () {
        let gimmickDiv = $(this).closest('.gimmick-match');
        gimmickDiv.attr('data-event-uid', $(this).val());
    });

    // Set object of gimmick match element
    $selectGimmickMatchContainer.on('keyup', '.match-name-input', function () {
        let gimmickDiv = $(this).closest('.gimmick-match');
        let object = toTitleCase($(this).val());
        if (gimmickDiv.find('.gimmick-match-generate-object-button').attr('data-generate-object') === 'true') {
            object = object + ' on a Pole'
        }
        else if (gimmickDiv.find('.gimmick-match-generate-object-button').attr('data-generate-location') === 'true') {
            object = object + ' Brawl'
        }
        gimmickDiv.attr('data-name', object);

        // Update match participants text
        updateMatchParticipantsText();
    });

    // Generate gimmick match object/location
    $selectGimmickMatchContainer.on('click', '.gimmick-match-generate-object-button', async function () {
        let element = $(this);
        let previousName = $(this).data('previous-name');

        // If adding gimmick match to existing match, select participants from match card
        let participantNames;
        if ($('.confirm-gimmick-match-for-match').is(':visible')) {
            let eventCardMatchElement = $('.event-card-match-add-gimmick-button.selected').closest('.event-match');
            participantNames = Array.from(eventCardMatchElement.find('.event-card-match-participant-name'), function (e) {
                return $(e).text()
            });
        }
        // Otherwise select selected superstars or teams
        else {
            participantNames = selectedParticipants
        }

        if ($(this).attr('data-generate-object') === 'true') {
            await makeGameRequest(generateGimmickMatchObject, {participantNames, previousName},
                showGenerateGimmickMatchData, {element, type: 'object'}, false);
        }
        else if ($(this).attr('data-generate-location') === 'true') {
            await makeGameRequest(generateGimmickMatchLocation, {participantNames, previousName},
                showGenerateGimmickMatchData, {element, type: 'location'}, false);
        }
    });

    // Add match button
    $game.on('click', '#add-match-button', async function () {
        await callAddMatch();
    });

    // Multi person button
    $bookingContainer.on('click', '#multi-match-button', function () {
        playSoundEffect('success');

        // Select/unselect
        $(this).toggleClass('selected');
        let icon = $(this).find('.fa');
        if (icon.hasClass('fa-circle-o')) {
            icon.removeClass('fa-circle-o').addClass('fa-check-circle-o');
        }
        else if (icon.hasClass('fa-check-circle-o')) {
            icon.removeClass('fa-check-circle-o').addClass('fa-circle-o');
        }

        // Hide tournament container
        $("#add-tournament-container").hide();
        $("#add-tournament-menu-button").removeClass("selected");

        // When unselecting, if more than one participant selected, unselect all
        if (!$(this).hasClass('selected')) {
            if (selectedParticipants.length >= 2) {

                // Reset participants
                selectedElements.forEach(function (x) {
                    $(x).toggleClass("selected");
                });
                selectedParticipants = [];
                selectedElements = [];
                $(".feud-container").show().removeClass('selected');
                $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
                $('.superstar-select-feud-details').remove();

                // Update match participants text
                updateMatchParticipantsText();
            }
        }

        // Tutorial action check
        checkTutorialStepAction('click_multi_button');
    });

    // Delete match
    $matches.on('click', '.event-card-match-delete-button', async function () {
        let $matchElement = $(this).closest('.event-match');
        let uid = parseInt($matchElement.attr('data-uid'));
        if ($matchElement.hasClass('tournament-match')) {
            // Add all tournament matches to be deleted
            $matchElement = $('.event-match.tournament-match');
            notie.confirm({
                text: 'Deleting this match will delete the whole tournament. Are you sure you want to do that?',
                submitText: 'Yes',
                cancelText: 'No',
                submitCallback: async function () {
                    await makeGameRequest(deleteCompanyMatch, {uid}, showDeleteMatchData,
                        {$matchElement}, false);
                }
            })
        }
        else {
            await makeGameRequest(deleteCompanyMatch, {uid}, showDeleteMatchData,
                {$matchElement}, false);
        }
    });

    // Add gimmick match event card button
    $matches.on('click', '.event-card-match-add-gimmick-button', async function () {

        // Reset
        selectedGimmickMatch = '';
        $("#show-gimmick-matches-button").find('.fa').addClass('fa-plus-circle').removeClass('fa-minus-circle');
        $("#show-gimmick-matches-button").removeClass("selected");
        updateMatchParticipantsText();

        // Add new div for gimmick matches
        let newDiv = $('<div id="gimmick-matches-container" class="box"></div>');
        let scrollDiv = $('<div class="gimmick-matches-container-scroll"></div>');
        $(newDiv).append(
            '<div class="margin-bottom-30">' +
            '   <span class="menu-header-color font-mukta-mahee font-1p325em">Add Gimmick Match</span>' +
            '</div>'
        );

        // Load gimmick matches
        let matchElement = $(this).closest('.event-match');
        let matchUid = parseInt(matchElement.attr('data-uid'));
        await makeGameRequest(getBookingGimmickMatchesData, {matchUid: matchUid},
            showGetBookingGimmickMatchesData, {scrollDiv, newDiv, eventCard: true}, false);
    });

    // Confirm gimmick match event card button
    $('#select-gimmick-match-container').on('click', '.confirm-gimmick-match-for-match', async function () {
        let parent = $('.event-card-match-add-gimmick-button.selected').closest('.event-match');
        let matchUid = parseInt(parent.attr('data-uid'));
        let gimmickMatchElement = $('.gimmick-match-item.selected');
        let gimmickMatchUid = parseInt(gimmickMatchElement.attr('data-uid'));
        let gimmickMatchName = gimmickMatchElement.attr('data-name');
        let gimmickMatchObject = gimmickMatchElement.find('.gimmick-match-generate-object-button').length > 0;

        // Validate event selected for gimmick match with match contract
        let matchEventUid = parseInt(gimmickMatchElement.attr('data-event-uid'));
        if (gimmickMatchElement.find('#match_event').length > 0) {
            if (!matchEventUid) {
                notie.alert({type: 3, text: "Select an event for this match contract to be held at"});
                gimmickMatchElement[0].scrollIntoView();
                gimmickMatchElement.find('#match_event').addClass('highlight');
                return false;
            }
        }

        // Get fall select values, referee uid
        let fallGimmickNames = Array.from(gimmickMatchElement.find('.match-fall-select'), function (x) {
            return $(x).val();
        });
        let refereeUid = parseInt(gimmickMatchElement.find('.match-referee-select').val());

        await makeGameRequest(addGimmickMatchToMatch, {matchUid, gimmickMatchUid, gimmickMatchName,
            matchEventUid, gimmickMatchObject, fallGimmickNames, refereeUid},
            showAddGimmickMatchToMatchData, {parent}, false);
    });

    // Drag to sort matches/segments
    $matches.sortable({
        cancel: '.tournament-match, .played, .hidden, .event-card-match-edit-menu, .event-card-button',
        axis: 'y',
        containment: '#matches',
        opacity: 0.8,
        tolerance: "pointer",
        items: '.event-match:not(.played)'
    });

    // Match/segment sort handler
    $matches.on("sortupdate", async function (event, ui) {
        let matchOrSegmentDiv = $(ui.item[0]);
        let matchOrSegmentDivIndex = $('.event-match').index(matchOrSegmentDiv);
        let uid = parseInt(matchOrSegmentDiv.attr('data-uid'));
        let objectName = matchOrSegmentDiv.attr('data-is-segment') === 'true' ? 'segment' : 'match';
        await makeGameRequest(changeMatchOrSegmentOrder, {uid, objectName, position: matchOrSegmentDivIndex},
            showChangeMatchOrSegmentOrderData, {matchOrSegmentDivIndex}, false);
    });

    // Don't allow drag on tournament and played matches
    $matches.on('mousedown', '.event-match.played, .event-match.tournament-match', function(e) {
        let target = $(e.target);
        if (target.closest('.button-dropdown').length <= 0) {
            notie.alert({type: 4, text: 'You cannot change the order of Tournament and Played Matches'});
        }
    });

    // Remove match championship
    $matches.on('click', '.event-card-match-remove-championship-button', async function () {
        let parent = $(this).closest('.event-match');
        let matchUid = parseInt(parent.attr('data-uid'));
        await makeGameRequest(removeChampionshipFromMatch, {matchUid}, showRemoveChampionshipFromMatchData,
            {parent}, false);
    });

    // Select match championships
    $matches.on('click', '.event-card-match-select-championships-button', async function () {
        let parent = $(this).closest('.event-match');
        let matchUid = parseInt(parent.attr('data-uid'));
        await makeGameRequest(getMatchChampionshipsForSelection, {matchUid},
            showGetMatchChampionshipsForSelectionData, {matchUid}, false);
    });

    // Confirm match championships
    $container.on('click', '#confirm-match-championships-selection', async function () {
        let matchUid = $('#match-championships-selection-container').data('match-uid');
        let selectedChampionshipDivs = $(this).parent().find('.selected');
        let selectedChampionshipsUids = Array.from(selectedChampionshipDivs, function (memberDiv) {
            return parseInt($(memberDiv).attr('data-uid'))
        });
        await makeGameRequest(changeMatchChampionships, {matchUid, selectedChampionshipsUids},
            showChangeMatchChampionshipsData, {matchUid}, false);
    });

    // Match championship item select
    $container.on('click', '.match-championships-item', function () {
        // Select, unselect
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
        }
        else {
            $(this).addClass('selected');
        }
    });

    // Load available feuds for match
    $matches.on('click', '.event-card-match-add-feud-button', async function () {
        let matchElement = $(this).closest('.event-match');
        let matchUid = parseInt(matchElement.attr('data-uid'));
        let matchType = matchElement.attr('data-matchtype');
        let isSegment = (matchElement.attr('data-is-segment')) ? matchElement.attr('data-is-segment') : false;
        await makeGameRequest(getAvailableFeudsForMatch, {matchUid, matchType, isSegment},
            showGetAvailableFeudsForMatchData, {matchUid, matchType, isSegment}, false);
    });

    // Add feud to match
    $("#feud-items-container").on('click', '.feud-item-container', async function () {
        // Don't run for disabled feud item
        if ($(this).hasClass('disabled')) {
            return false;
        }
        let feudItemUid = parseInt($(this).attr('data-uid'));
        let matchOrSegmentUid = parseInt($('#feud-items-container').attr('data-uid'));
        let matchType = $('#feud-items-container').attr('data-match-type');
        let isSegment = $('#feud-items-container').attr('data-is-segment') === 'true';
        let feudName = $(this).find('.feud-item-custom-name').val();
        await makeGameRequest(addFeudToMatchOrSegment, {matchOrSegmentUid, matchType, isSegment, feudItemUid, feudName},
            showAddFeudToMatchData, {matchOrSegmentUid}, false);
    });

    // Remove feud from match
    $matches.on('click', '.event-card-match-remove-feud-button', async function () {
        let matchElement = $(this).closest('.event-match');
        let matchOrSegmentUid = parseInt(matchElement.attr('data-uid'));
        let isSegment = matchElement.attr('data-is-segment') === 'true';
        await makeGameRequest(removeFeudFromMatchOrSegment, {matchOrSegmentUid, isSegment},
            showRemoveFeudFromMatchOrSegmentData, {matchElement}, false);
    });

    // Add feud blowoff
    $container.on('click', '.add-blowoff-to-feud', async function () {
        let matchUid = parseInt($(this).attr('data-uid'));
        let matchType = $(this).attr('data-match-type');
        let feudUid = parseInt($(this).attr('data-feud-uid'));
        let $el = $(this);
        await makeGameRequest(changeFeudBlowoff, {matchUid, matchType, feudUid, add: true},
            showChangeFeudBlowoffData, {$el, add: true}, false);
    });

    // Remove feud blowoff
    $container.on('click', '.remove-blowoff-from-feud', async function () {
        let matchUid = parseInt($(this).attr('data-uid'));
        let matchType = $(this).attr('data-match-type');
        let feudUid = parseInt($(this).attr('data-feud-uid'));
        let $el = $(this);
        await makeGameRequest(changeFeudBlowoff, {matchUid, matchType, feudUid, add: false},
            showChangeFeudBlowoffData, {$el, add: false}, false);
    });

    // Show 'add match manager' selections
    $matches.on('click', '.event-card-match-add-manager-button', async function () {
        let parent = $(this).closest('.event-match');
        let matchUid = parseInt(parent.attr('data-uid'));
        await makeGameRequest(getAddMatchManagerSelections, {matchUid},
            showGetAddMatchManagerSelectionsData, {matchUid}, false);
    });

    // Add match manager button
    $container.on('click', '#match-add-manager-button', async function () {
        let parent = $('#match-add-manager-container');
        let matchUid = parent.data('match-uid');
        let participantUid = parseInt(parent.find('.match-add-manager-participant-select').val());
        let managerUid = parseInt(parent.find('.match-add-manager-manager-select').val());
        await makeGameRequest(addManagerToMatch, {matchUid, participantUid, managerUid},
            showAddManagerToMatchData, {matchUid}, false);
    });

    // Show 'remove match manager' selections
    $matches.on('click', '.event-card-match-remove-manager-button', async function () {
        let parent = $(this).closest('.event-match');
        let matchUid = parseInt(parent.attr('data-uid'));
        await makeGameRequest(getRemoveMatchManagerSelections, {matchUid},
            showGetRemoveMatchManagerSelectionsData, {matchUid}, false);
    });

    // Remove match manager button
    $container.on('click', '#match-remove-manager-button', async function () {
        let parent = $('#match-remove-manager-container');
        let matchUid = parent.data('match-uid');
        let superstarUid = parseInt(parent.find('.match-remove-manager-manager-select').val());
        await makeGameRequest(removeManagerFromMatch, {matchUid, superstarUid},
            showRemoveManagerFromMatchData, {matchUid}, false);
    });

    // Load 'change trio team members' page
    $container.on('click', '.change-trio-tagteam-members', async function () {
        let members = $(this).data('trio-members');
        let membersSelected = $(this).data('trio-members-selected');
        let matchUid = $(this).data('match-uid');
        let teamName = $(this).data('team-name');
        showTrioMembersForSelection(members, membersSelected, matchUid, teamName);
    });

    // Change trio team members
    $container.on('click', '.trio-member', async function () {
        let selectedMemberDivs = $(this).parent().find('.selected');

        // Select, unselect
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
        }
        else {
            if (selectedMemberDivs.length < 2) {
                $(this).addClass('selected');

                // Change members if 2 selected
                selectedMemberDivs = $(this).parent().find('.selected');
                if (selectedMemberDivs.length === 2) {
                    let matchUid = $('#trio-members-selection-container').data('match-uid');
                    // JSON.parse teamName since it's a single string
                    let teamName = JSON.parse($('#trio-members-selection-container').data('team-name'));
                    let selectedMembers = Array.from(selectedMemberDivs, function (memberDiv) {
                        return $(memberDiv).text()
                    });
                    await makeGameRequest(changeTrioTagTeamMembers, {matchUid, teamName, selectedMembers},
                        showChangeTrioTagTeamMembersData, {matchUid}, false);
                }
            }
            // Don't allow 3 selections
            else {
                notie.alert({type: 4, text: "You can only select 2 members. Deselect a selected member first."});
            }
        }
    });

    // Load 'change faction team members page'
    $container.on('click', '.change-faction-tagteam-members', async function () {
        let members = $(this).data('faction-members');
        let membersSelected = $(this).data('faction-members-selected');
        let matchUid = $(this).data('match-uid');
        let teamName = $(this).data('team-name');
        let teamSize = $(this).data('team-size');
        showFactionMembersForSelection(members, membersSelected, matchUid, teamName, teamSize);
    });

    // Change faction team members
    $container.on('click', '.faction-member', async function () {
        let selectedMemberDivs = $(this).parent().find('.selected');
        let matchTeamSize = $('#faction-members-selection-container').data('team-size');

        // Select, unselect
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
        }
        else {
            if (selectedMemberDivs.length < matchTeamSize) {
                $(this).addClass('selected');

                // Change members if matchTeamSize selected
                selectedMemberDivs = $(this).parent().find('.selected');
                if (selectedMemberDivs.length === matchTeamSize) {
                    let matchUid = $('#faction-members-selection-container').data('match-uid');
                    // JSON.parse teamName since it's a single string
                    let teamName = JSON.parse($('#faction-members-selection-container').data('team-name'));
                    let selectedMembers = Array.from(selectedMemberDivs, function (memberDiv) {
                        return $(memberDiv).text()
                    });
                    await makeGameRequest(changeFactionTagTeamMembers, {matchUid, teamName, selectedMembers},
                        showChangeFactionTagTeamMembersData, {matchUid}, false);
                }
            }
            // Don't allow 3 selections
            else {
                notie.alert({type: 4, text: "You can only select " + matchTeamSize + " members. Deselect a selected member first."});
            }
        }
    });

    // Change superstar attire
    $container.on('click', '.change-superstar-attire-button', async function () {
        let superstarUid = parseInt($(this).attr('data-uid'));
        let $el = $(this);
        await makeGameRequest(changeSuperstarAttire, {superstarUid}, showChangeSuperstarAttireData, {$el}, false);
    });

    // View roster member details while booking
    $('#booking-talent-info').on('click', '.view-roster-member-details-button', async function () {
        let type = $(this).attr('data-type');
        let uid = parseInt($(this).attr('data-uid'));
        await makeGameRequest(getViewRosterMemberData, {uid, type}, showViewRosterMemberDetailsData,
            {uid, type});
    });


    // ** SEGMENTS **


    // Book segment menu button
    $mainMenuRight.on('click', '#book-segment-menu-button', async function () {

        const $bookingContainer = $('#booking-container');

        // Reset ui
        $('#booking-menu').find('li').removeClass('selected');
        $(this).addClass('selected');
        $('.tooltip').remove();
        $(".tag-match-options").remove();
        $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
        $('.segment-participants').removeClass('faded-red-light').text('No participants selected');
        $('.segment-item-selected').removeClass('faded-purple').text('No Segment Item selected');
        $('.segment-item-container.selected').removeClass('selected');
        $('.segment-booking-already-held').remove();
        $('.segment-item-container.already-held').removeClass('already-held');
        $('.segment-booking-unavailable').remove();
        $('.segment-item-container.unavailable').removeClass('unavailable');
        $bookingContainer.find('input[value="add_segment_producer_focus"]').prop('checked', false);
        $bookingContainer.find('.add-segment-producer-select').hide();
        $('#booking-talent-container').find('.superstar-select').removeClass('selected');
        $('#add-tournament-menu-button').hide();

        // Add segment menu
        let segmentBookingMenuHtml = getSegmentBookingMenuHtml();
        $("#add-segment-menu").html(segmentBookingMenuHtml);

        // Add segment item menu
        let segmentItemMenuHtml = getSegmentItemMenuHtml();
        $("#add-segment-item-menu").html(segmentItemMenuHtml);

        // Reset variables
        segmentParticipants = [];

        // Show feuds
        let matchType = 'segment';
        const $bookSegmentFeudsContainer = $('.book-segment-feuds-container');
        await makeGameRequest(getFeudsForBooking, {matchType}, showGetFeudsForBookingData,
            {matchType, $el: $bookSegmentFeudsContainer}, true);

        // Show booking container
        $bookingContainer.find('.participants-box-callup-header, .participants-box-match-header, .participants-box-draft-header, ' +
            '.participants-box-match-container, .participants-box-trade-offer-header, ' +
            '#booking-talent-info, #booking-talent-menu, #booking-talent-container, #booking-championship-info').hide();
        $bookingContainer.find('#add-segment-item-menu, #segment-items-container, .participants-box-segment-header, ' +
            '.participants-box-segment-container, #add-segment, #add-segment-menu').show();
        $bookingContainer.show();
        $('.book-segment-feuds-container').scrollTop(0);
        $('#segment-items-container').scrollTop(0);

        // Load segment items
        await makeGameRequest(getAvailableSegmentItems, {}, showGetAvailableSegmentItemsData,
            {}, false, true);

        // Load producers
        await makeGameRequest(getCompanyProducers, {}, showGetCompanyProducersData,
            {}, false, true);
    });

    // Book segment option button (feuds, singles etc)
    $("#add-segment-menu").on('click', '.book-segment-option', async function () {

        // Reset ui
        $(".book-segment-option").removeClass('selected');
        $(this).addClass('selected');
        $('#booking-talent-container').addClass('compact segments-selection');
        $('.segment-participants').removeClass('faded-red-light').text('No participants selected');
        $(".feud-container.selected").trigger('click');
        if ($('.add-custom-segment-segments-menu-button').hasClass('selected')) {
            $('.add-custom-segment-segments-menu-button').trigger('click') // Hide custom segment container
        }

        // Reset variables
        selectedParticipants = [];
        selectedElements = [];
        segmentParticipants = [];

        let val = $(this).text();

        // Show singles roster
        if (val === 'Singles') {
            await makeGameRequest(getBookingData, {matchType: 'singles', segment: true,
                getVacatedChampionships: false}, showGetBookingData, {matchType: 'singles', segment: true});
        }
        // Show tag roster
        else if (val === 'Tag') {
            await makeGameRequest(getBookingData, {matchType: 'tag', segment: true,
                getVacatedChampionships: false, tagTeamType: 'tag-team'}, showGetBookingData,
                {matchType: 'tag', segment: true, tagTeamType: 'tag-team'});
        }
        // Show feuds
        else if (val === 'Feuds') {
            $('#booking-talent-info, #booking-talent-container, #booking-talent-menu').hide();
            $('#booking-talent-container').find('.superstar-select').removeClass('selected');
            $('.book-segment-feuds-container').show();
            $('.book-segment-feuds-container').scrollTop(0);
        }
        // Show factions
        else if (val === 'Factions') {
            await makeGameRequest(getBookingData, {matchType: 'factions', segment: true,
                getVacatedChampionships: false}, showGetBookingData,
                {matchType: 'factions', segment: true});
        }
    });

    // Book segment feud click
    $(".book-segment-feuds-container").on('click', '.feud-container', async function () {
        playSoundEffect('success');
        let $this = $(this);

        // Unselect other options
        $(".feud-container").each(function (i, e) {
            if (!$(e).is($this)) {
                $(e).removeClass('selected');
                $(e).hide();
            }
        });

        // Remove already held indication
        $('.segment-booking-already-held').remove();
        $('.segment-item-container.already-held').removeClass('already-held');

        // Remove unavailable indication
        $('.segment-booking-unavailable').remove();
        $('.segment-item-container.unavailable').removeClass('unavailable');

        if ($this.hasClass('selected')) {
            // Deselect this feud
            $this.removeClass('selected');
            $(".feud-container").show();
            $('.segment-participants').removeClass('faded-red-light').text('No participants selected');

            // If 'available' segment filter selected, get available segments again (as they are changed by feud deselection)
            if ($('.filter-segment-items-option[data-value="available"].selected').length > 0) {
                showAvailableSegmentItems()
            }
        }
        else {
            // Select this feud
            $this.addClass('selected');
            $this.show();

            // Update segment participants
            let participants = $this.find('.feud-participants').text().split(' vs ');
            let participantNames = participants.slice(0, -1).join(', ') + ' and ' + participants.slice(-1);
            $('.segment-participants').addClass('faded-red-light').text(participantNames);

            // Show already held segment items, gets unique list of segment item names
            let uid = parseInt($(this).attr('data-uid'));
            await makeGameRequest(getFeudSegmentsInformation, {uid}, showGetFeudSegmentsInformationData,
                {}, false, true);
        }

        // Tutorial action check
        checkTutorialStepAction('click_segment_feud');
    });

    // Book segment participant click
    $("#booking-talent-container").on('click', '.superstar-select', async function () {

        // Don't run for training, vacated titles, non-segment booking
        if (!$('#booking-talent-container').hasClass('segments-selection')) {
            return;
        }
        let parentId = $(this).parent().closest('div').attr('id');
        if (parentId === 'training' || parentId === 'vacated-titles') {
            return;
        }

        playSoundEffect('success');
        let $this = $(this);
        let name = $this.data('name');
        let uid = $this.data('uid');
        let selectedSegmentItem = $('.segment-item-container.selected');

        if ($this.hasClass('selected')) {
            // Deselect this participant
            $this.removeClass('selected');
            segmentParticipants.splice(segmentParticipants.indexOf(name), 1);
            if (selectedSegmentItem.length > 0 &&
                selectedSegmentItem.attr('data-consequence') !== 'create-faction') {
                selectedSegmentItem.find('.segment-item-faction-inputs').remove();
                selectedSegmentItem.find('.segment-item-manager-inputs').remove();
                if (['vacate-title', 'award-title'].indexOf(selectedSegmentItem.attr('data-consequence')) >= 0 ||
                    selectedSegmentItem.attr('data-requirement') === 'feud-present') {
                    selectedSegmentItem.find('.segment-item-other-inputs').remove()
                }
            }
        }
        else {
            // Select this participant
            segmentParticipants.push(name);
            $this.addClass('selected');
        }

        let participantNames = segmentParticipants[0];
        if (segmentParticipants.length > 1) {
            participantNames = segmentParticipants.slice(0, -1).join(', ') + ' and ' + segmentParticipants.slice(-1);
        }
        else if (segmentParticipants.length < 1) {
            participantNames = 'No participants selected'
        }
        $('.segment-participants').removeClass('faded-red-light').text(participantNames);

        // Revert to all superstars, scroll to selected element
        if ($('.superstar-search-input').val()) {
            $('.superstar-search-input').val('').focus().trigger('input');
            let $container = $('#booking-talent-container'),
                $scrollTo = $(this);
            $container.scrollTop(
                $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
            );
        }

        // Show information for selected superstar (feuds, teams/factions)
        $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
        $('.superstar-select-feud-details').remove();
        if (segmentParticipants.length > 0 && $(this).hasClass('selected')) {
            if (uid) {
                let participantType = $this.attr('data-type');
                await makeGameRequest(getBookingSelectionInformation, {uid, participantType},
                    showGetBookingSelectionInformationData, {}, false, true);
            }
            else {
                if (typeof window.Sentry !== 'undefined') {
                    Sentry.captureMessage('(Segment) Name attribute not present for .superstar-select: ' + $this.text() + ' type: ' + $this.data('type') + ' name: ' + $this.data('name'))
                }
            }
        }

        let selectedParticipant = $('#booking-talent-container .superstar-select.selected').eq(0);

        // Show faction inputs if faction segment and faction roster member selected, and if not create faction segment
        if (selectedParticipant.attr('data-type') === 'faction') {
            if (selectedSegmentItem.length > 0 && selectedSegmentItem.data('tags').indexOf('faction') >= 0
                && selectedSegmentItem.attr('data-consequence') !== 'create-faction') {
                await showFactionSegmentInputs(selectedSegmentItem, selectedParticipant)
            }
        }

        // Show manager inputs if manager segment and superstar selected
        if (selectedParticipant.attr('data-type') === 'superstar' || selectedParticipant.attr('data-type') === 'tag-team' ||
            selectedParticipant.attr('data-type') === 'trio') {
            if (selectedSegmentItem.length > 0 && selectedSegmentItem.attr('data-manager-input')) {
                await showManagerSegmentInputs(selectedSegmentItem, selectedParticipant)
            }
        }

        // Show other inputs (only for title/feud segment)
        if (selectedParticipant.attr('data-type') &&
            (['vacate-title', 'award-title'].indexOf(selectedSegmentItem.attr('data-consequence')) >= 0 ||
                selectedSegmentItem.attr('data-requirement') === 'feud-present')) {
            if (selectedSegmentItem.length > 0 && selectedSegmentItem.attr('data-other-input')) {
                await showOtherSegmentInputs(selectedSegmentItem, selectedParticipant)
            }
        }

        // Tutorial action check
        setTimeout(function () {
            checkTutorialStepAction('click_segment_superstar_select');
        }, 50);
    });

    // Book segment item click
    $("#segment-items-container").on('click', '.segment-item-container', async function () {
        playSoundEffect('success');
        notie.hideAlerts();

        let $this = $(this);

        // Unselect other options
        $("#segment-items-container .item-container").each(function (i, e) {
            if (!$(e).is($this)) {
                $(e).removeClass('selected');
                $(e).find('.segment-item-faction-inputs').remove();
                $(e).find('.segment-item-manager-inputs').remove();
                $(e).find('.segment-item-brand-inputs').remove();
                $(e).find('.segment-item-other-inputs').remove();
            }
        });

        if ($this.hasClass('selected')) {
            // Deselect this segment
            $this.removeClass('selected');
            $('.segment-item-selected').removeClass('faded-purple').text('No Segment Item selected');
            $this.find('.segment-item-faction-inputs').remove();
            $this.find('.segment-item-manager-inputs').remove();
            $this.find('.segment-item-brand-inputs').remove();
            $this.find('.segment-item-other-inputs').remove();
        }
        else {
            // Select this segment
            $this.addClass('selected');
            let segmentButtonsHtml = '<div>' +
                '<button type="button" class="button retro-button condensed blue-button-background margin-top-5" id="add-segment">Book</button>' +
                '</div>';
            $('.segment-item-selected').addClass('faded-purple').html($this.find('.segment-item-name').text() + segmentButtonsHtml);

            // Show help text
            if ($this.find('.segment-item-name').text() === 'Talk Show') {
                notie.alert({type: 4, text: 'The first Participant selected hosts the talk show'});
            }
            if ($this.find('.segment-item-name').text() === 'Handicap Beatdown') {
                notie.alert({type: 4, text: 'The first Participant selected gets the beatdown'});
            }

            if ($this.data('tags').indexOf('choose-winner') >= 0) {
                notie.alert({type: 4, text: 'You can choose who performs/wins this Segment when it runs'});
            }

            let selectedParticipant = $('#booking-talent-container .superstar-select.selected').eq(0);

            // Show faction inputs if faction segment and faction roster member selected or create faction segment
            if ($this.data('tags').indexOf('faction') >= 0) {
                if (selectedParticipant.attr('data-type') === 'faction' || $this.attr('data-consequence') === 'create-faction') {
                    await showFactionSegmentInputs($this, selectedParticipant)
                }
            }

            // Show manager inputs if manager segment and superstar selected
            if ($this.attr('data-manager-input')) {
                if (selectedParticipant.attr('data-type') === 'superstar' || selectedParticipant.attr('data-type') === 'tag-team' ||
                    selectedParticipant.attr('data-type') === 'trio') {
                    await showManagerSegmentInputs($this, selectedParticipant)
                }
            }

            // Show brand inputs if brand segment
            if ($this.attr('data-brand-input')) {
                await showBrandSegmentInputs($this)
            }

            // Show other inputs (only show for title/feud segments if participant selected)
            if ($this.attr('data-other-input')) {
                if (selectedParticipant.attr('data-type') ||
                    (['vacate-title', 'award-title'].indexOf($this.attr('data-consequence')) < 0 && $this.attr('data-requirement') !== 'feud-present')) {
                    await showOtherSegmentInputs($this, selectedParticipant)
                }
            }
        }

        // Tutorial action check
        checkTutorialStepAction('click_segment_item');
    });

    // Add segment button
    $("#booking-container").on('click', '#add-segment', async function () {

        let selectedSegment = $('.segment-item-container.selected');
        let segmentItemUid = parseInt(selectedSegment.attr('data-uid'));
        let noParticipants = selectedSegment.attr('data-no-participants');
        let isFactionSegment = selectedSegment.attr('data-is-faction-segment') === 'true';
        let isFactionInputSegment = selectedSegment.attr('data-faction-input');
        let isManagerInputSegment = selectedSegment.attr('data-manager-input');
        let isBrandInputSegment = selectedSegment.attr('data-brand-input');
        let isOtherInputSegment = selectedSegment.attr('data-other-input');

        // Feud/participants
        let feudUid;
        if ($('.feud-container.selected').is(':visible')) {
            feudUid = parseInt($('.feud-container.selected').attr('data-uid'))
        }

        // Validation checks
        if (!segmentItemUid) {
            notie.alert({type: 3, text: "Select a Segment Item to use"});
            return false;
        }
        if (!noParticipants) {
            if (!feudUid && segmentParticipants.length < 1) {
                notie.alert({type: 3, text: "Select participants for this Segment"});
                return false;
            }
        }

        // Reset search
        if ($('.superstar-search-input').val()) {
            $('.superstar-search-input').val('').trigger('input');
        }

        // Get selected participants
        let selectedParticipants = [];
        let selectedElements = $('#booking-talent-container.segments-selection .superstar-select.selected');
        selectedElements.each(function(i, selection) {
            selectedParticipants.push({'name': $(selection).attr('data-name'), 'uid': parseInt($(selection).attr('data-uid')),
                'type': $(selection).attr('data-type')});
        });
        // Sort in order of selected participants
        if (segmentParticipants.length > 0) {
            selectedParticipants.sort((x, y) => segmentParticipants.indexOf(x.name) - segmentParticipants.indexOf(y.name));
        }

        // Check if factions selected in faction segment
        if (isFactionSegment) {
            let selectedParticipantsNotFactions = selectedParticipants.filter(function (selectedParticipant) {
                return selectedParticipant['type'] !== 'faction';
            });
            if (selectedParticipantsNotFactions.length > 0 && !noParticipants) {
                notie.alert({type: 3, text: "You can only select Factions for this Segment"});
                return false;
            }
        }

        // Get consequence data (faction inputs) if faction input segment
        let consequenceData = {};
        if (isFactionInputSegment) {

            // Check for empty first input
            let selectFactionMemberInputs = selectedSegment.find('.select-faction-member');
            if (selectFactionMemberInputs.length > 0 && !selectFactionMemberInputs.eq(0).val()) {
                notie.alert({type: 3, text: "Select members for this segment (under the segment item)"});
                selectedSegment[0].scrollIntoView();
                selectFactionMemberInputs.eq(0).addClass('highlight');
                return false;
            }

            // Get faction member inputs that aren't empty
            let superstarUids = [];
            selectFactionMemberInputs.each(function() {
               if ($(this).val()) {
                   superstarUids.push(parseInt($(this).val()))
               }
            });

            let factionConsequenceUids = Array.from(selectedSegment.find('.select-faction'), function (x) {
                return parseInt($(x).val());
            });
            let factionUids = Array.from(selectedElements, function (x) {
                return parseInt($(x).attr('data-uid'));
            });
            let createdFactionName = selectedSegment.find('.segment-item-faction-name').val();
            let leaderUid = parseInt(selectedSegment.find('.select-faction-leader').val());

            // Validate
            if (selectedSegment.find('.segment-item-faction-name').length > 0 && createdFactionName.length <= 0) {
                notie.alert({type: 3, text: "Enter a name for the Faction"});
                return false;
            }

            consequenceData['superstarUids'] = superstarUids;
            consequenceData['factionUids'] = factionUids;
            consequenceData['factionConsequenceUids'] = factionConsequenceUids;
            consequenceData['createdFactionName'] = createdFactionName;
            consequenceData['leaderUid'] = leaderUid;
        }

        // Check talent input for manager input segment
        let managedTalentUid;
        let managerUid;
        if (isManagerInputSegment) {

            // Check if superstar or team selected
            let selectedParticipantsFactions = selectedParticipants.filter(function (selectedParticipant) {
                return selectedParticipant['type'] === 'faction';
            });
            if (selectedParticipantsFactions.length > 0) {
                notie.alert({type: 3, text: "You can only select Superstars and Teams for this Segment"});
                return false;
            }

            // Check for empty first input for managed talent select
            let selectManagedTalentInput = selectedSegment.find('.select-managed-talent');
            if (selectManagedTalentInput.length > 0 && !selectManagedTalentInput.eq(0).val()) {
                notie.alert({type: 3, text: "Select managed talent to use for this segment (under the segment item)"});
                selectedSegment[0].scrollIntoView();
                selectManagedTalentInput.eq(0).addClass('highlight');
                return false;
            }

            // Check for empty first input for manager select
            let selectManagerInput = selectedSegment.find('.select-manager');
            if (selectManagerInput.length > 0 && !selectManagerInput.eq(0).val()) {
                notie.alert({type: 3, text: "Select a manager to add to this talent (under the segment item)"});
                selectedSegment[0].scrollIntoView();
                selectManagerInput.eq(0).addClass('highlight');
                return false;
            }

            // Get uid for talent
            managedTalentUid = parseInt(selectManagedTalentInput.eq(0).val());

            // Get uid for manager
            managerUid = parseInt(selectManagerInput.eq(0).val());
        }

        // Get consequence data if brand input segment
        if (isBrandInputSegment) {
            let selectBrandInput = selectedSegment.find('.select-brand');
            if (selectBrandInput.length > 0 && !selectBrandInput.eq(0).val()) {
                notie.alert({type: 3, text: "Select a brand to draft this talent to (under the segment item)"});
                selectedSegment[0].scrollIntoView();
                selectBrandInput.eq(0).addClass('highlight');
                return false;
            }
            // Get uid for brand
            consequenceData['brandUid'] = parseInt(selectBrandInput.eq(0).val());

            let selectBrandTalentInput = selectedSegment.find('.select-brand-talent');
            if (selectBrandTalentInput.length > 0 && !selectBrandTalentInput.eq(0).val()) {
                notie.alert({type: 3, text: "Select a talent to draft (under the segment item)"});
                selectedSegment[0].scrollIntoView();
                selectBrandTalentInput.eq(0).addClass('highlight');
                return false;
            }
            // Get uid and type for talent
            consequenceData['talentUid'] = parseInt(selectBrandTalentInput.eq(0).val());
            consequenceData['talentType'] = selectBrandTalentInput.find(':selected').attr('data-type');
        }

        // Get consequence data if other input segment
        if (isOtherInputSegment) {
            let otherInput = selectedSegment.find('.segment-item-input');
            if (otherInput.length > 0) {
                if (otherInput.attr('name') === 'segment-item-unavailable-months') {
                    consequenceData['monthsUnavailable'] = otherInput.eq(0).val()
                }
                if (otherInput.attr('name') === 'segment-item-object-name') {
                    consequenceData['objectName'] = otherInput.eq(0).val()
                }
                if (otherInput.attr('name') === 'segment-item-competitor') {
                    consequenceData['competitorUid'] = parseInt(otherInput.eq(0).val())
                }
                if (otherInput.attr('name') === 'segment-item-feud') {
                    consequenceData['feudUid'] = parseInt(otherInput.eq(0).val())
                }
                if (otherInput.attr('name') === 'segment-item-championship') {
                    consequenceData['championshipUid'] = parseInt(otherInput.eq(0).val())
                }
                if (otherInput.attr('name') === 'segment-item-match-or-segment') {
                    consequenceData['matchOrSegmentUid'] = parseInt(otherInput.eq(0).val());
                    consequenceData['matchOrSegmentType'] = otherInput.find(":selected").attr('data-type');
                }
            }
        }

        // Get producer uid if selected
        let producerUid;
        if ($('#booking-container').find('input[value="add_segment_producer_focus"]').prop('checked')) {
            producerUid = parseInt($('#booking-container').find('.add-segment-producer-select').val())
        }

        await makeGameRequest(bookSegment, {feudUid, segmentItemUid, selectedParticipants, consequenceData,
            managedTalentUid, managerUid, producerUid}, showBookSegmentData, {}, false);
    });

    // Show/hide segment producer select
    $('#booking-container').on('click', 'input[value="add_segment_producer_focus"]', function () {
        let value = $(this).prop('checked');
        if (value) {
            $('#booking-container').find('.add-segment-producer-select').show()
        }
        else {
            $('#booking-container').find('.add-segment-producer-select').hide()
        }
    });

    // Segment items filter
    $addSegmentItemMenu.on('click', '.filter-segment-items-option', function () {
        playSoundEffect('success');

        let filterName;
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
        }
        else {
            $('.filter-segment-items-option').removeClass('selected');
            $(this).addClass('selected');
            filterName = $(this).attr('data-value');
        }

        $('#segment-items-container').show();
        $('.add-custom-segment-container').hide();
        $('.add-custom-segment-segments-menu-button').removeClass('selected');
        $('.no-segment-search-results').hide();

        let segmentItemsContainer = $('#segment-items-container');
        let segmentElements = segmentItemsContainer.find('.item-container');

        if (filterName) {
            if (filterName === 'available') {
                // For dynamic filters (like unavailable feud segments), check for class
                segmentElements.each(function (i, e) {
                    if ($(e).hasClass('unavailable') || $(e).hasClass('locked')) {
                        $(e).hide();
                    }
                    else {
                        $(e).show();
                    }
                });
            }
            else {
                // Otherwise, check if filter value present in segment item's tags
                segmentElements.each(function (i, e) {
                    let tags = $(e).data('tags');
                    if (tags.indexOf(filterName) >= 0) {
                        $(e).show();
                    } else {
                        $(e).hide();
                    }
                });
            }

            if (segmentElements.is(':visible')) {
                $('.no-segment-search-results').hide()
            }
            else {
                if ($('.no-segment-search-results').length > 0) {
                    $('.no-segment-search-results').show()
                }
                else {
                    segmentItemsContainer.append('<div class="no-segment-search-results font-bold margin-left-5 light-grey ' +
                        'margin-top-2">No Results Found</div>')
                }
            }

        }
        else {
            segmentElements.show();
        }

        // Reset search
        $(".segment-search-input").val('');

        $('#segment-items-container').scrollTop(0);
    });

    // Segment items search
    $addSegmentItemMenu.on('input', '.segment-search-input', function () {
        runSegmentSearch();
    });

    // Segment items sort
    $addSegmentItemMenu.on('change', '.segment-sort', function () {
        let value = $(this).val();
        applySegmentSort(value);
    });

    // Segment items sort order
    $addSegmentItemMenu.on('click', '.segment-sort-order', function () {
        let icon = $(this).find('i');
        if (icon.hasClass('fa-sort-up') || icon.hasClass('fa-sort-down')) {
            let segmentItemsContainer = $('#segment-items-container');
            let availableSegmentElements = segmentItemsContainer.find('.item-container:not(.locked)');
            let unavailableSegmentElements = segmentItemsContainer.find('.item-container.locked');

            segmentItemsContainer.append(availableSegmentElements.get().reverse());
            segmentItemsContainer.append(unavailableSegmentElements.get().reverse());

            if (icon.hasClass('fa-sort-up')) {
                icon.removeClass('fa-sort-up').addClass('fa-sort-down');
            } else if (icon.hasClass('fa-sort-down')) {
                icon.removeClass('fa-sort-down').addClass('fa-sort-up');
            }
        }
    });

    // Add custom segment menu button
    $addSegmentItemMenu.on('click', '.add-custom-segment-segments-menu-button', function () {
        playSoundEffect('success');

        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');

            // Show all segment items
            let segmentItemsContainer = $('#segment-items-container');
            let segmentElements = segmentItemsContainer.find('.item-container');
            segmentElements.show();
            segmentItemsContainer.show();

            // Hide custom segment container
            $('.add-custom-segment-container').hide();

            // Scroll to top of segment items container
            segmentItemsContainer.scrollTop(0);

            return false;
        }
        else {
            $('.filter-segment-items-option').removeClass('selected');
            $('.segment-search-input').val('');
            $(this).addClass('selected');
            $('.add-custom-segment-container').find('.back-to-view-segments-button').hide();
        }

        customSegmentsData.addCustomSegmentChangesMade = false;
        $('.add-custom-segment-container').addClass('scroll margin-top-20').show();
        $('.add-custom-segment-container').scrollTop(0);
        $('#segment-items-container').hide();

        // Reset
        $(".add-custom-segment-template-button:contains('Basic')").trigger('click');
        $('.add-custom-segment-more-options').hide();
        let customSegmentMoreOptionsButton = $(".add-custom-segment-more-options-button");
        customSegmentMoreOptionsButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        customSegmentMoreOptionsButton.find('span').text('Show Details');
        $('.import-community-segment-input').val('');

        $('.add-custom-segment-community-segments-container').hide();
        let customSegmentCommunitySegmentsButton = $(".add-custom-segment-show-community-segments-button");
        customSegmentCommunitySegmentsButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        customSegmentCommunitySegmentsButton.find('span').text('Show Community Segments');

        // Show save options
        $('.add-custom-segment-save-to-game-container').show();
        $('.add-custom-segment-save-to-community-container').show();

        // Hide edit info
        $('.edit-custom-segment-button').hide();
        $('.back-to-edit-custom-segments-button').hide();
        $('.add-custom-segment-button').show();
        $('.add-custom-segment-label').text('Add Custom Segment');
        $('.add-custom-segment-help-text-container').hide();
        let customSegmentHelpButton = $(".add-custom-segment-help-button");
        customSegmentHelpButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        customSegmentHelpButton.find('span').text('Show How It Works');

        // Disable if free user
        if (!globalUser.paid) {
            $('.add-custom-segment-container').addClass('disabled');
            $('.add-custom-segment-container').find('input, textarea').prop('disabled', true);
            $('.add-custom-segment-container').addClass('help-text');
            $('.add-custom-segment-container').attr('title', 'JoW Paid includes Custom Segments');

            $('.add-custom-segment-help-text-container').hide();
            let customSegmentHelpButton = $(".add-custom-segment-help-button");
            customSegmentHelpButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
            customSegmentHelpButton.find('span').text('Show How It Works');
        }
        else {
            $('.add-custom-segment-container').removeClass('help-text');
            $('.add-custom-segment-container').removeAttr('title');
            $('.add-custom-segment-container').removeClass('disabled');
            $('.add-custom-segment-container').find('input, textarea').prop('disabled', false);
        }
    });

    // Custom Package preview
    let customPackageTimer = null;
    let customPackageInterval = null;
    let customPackageTypingTimer = null;
    $segmentItemsContainer.on("keyup", ".custom-package-start-text, .custom-package-action-text, .custom-package-name",
        function () {
            let timeoutDelay = 800;
            if (window.mobilecheck()) {
                timeoutDelay = 1400
            }

            // Reset timers
            clearTimeout(customPackageTimer);
            clearTimeout(customPackageInterval);
            clearTimeout(customPackageTypingTimer);

            let name = $('.custom-package-name').val();
            let startText = $('.custom-package-start-text').val();

            // Wait for user to stop typing
            customPackageTypingTimer = setTimeout(function () {
                (function showPackageAnimation() {
                    customPackageTimer = runCustomPackagePreviewAnimation(name, startText, customPackageTimer);
                    // Loop package preview
                    customPackageInterval = setTimeout(showPackageAnimation, 5400);
                })();
            }, timeoutDelay);
        });

    // Custom package help
    $segmentItemsContainer.on("click", ".custom-package-help-button", function () {
        let container = $('.custom-package-help-container');
        if (container.is(':visible')) {
            container.hide();
            $(this).text('help');
        }
        else {
            container.show();
            $(this).text('hide help');
        }
    });

    // Add custom package action text inputs
    $segmentItemsContainer.on("click", ".add-custom-package-action-text-button, " +
        ".remove-custom-package-action-text-button", function () {
        if ($(this).hasClass('add-custom-package-action-text-button')) {
            $('.custom-package-action-text').last().after(
                '<input type="text" placeholder="Action Text" ' +
                'class="styled-input custom-package-action-text margin-top-5" maxlength="250">'
            );
        }
        else {
            $('.custom-package-action-text').last().remove()
        }
        // Add/remove icons
        if ($('.custom-package-action-text').length > 1) {
            $('.remove-custom-package-action-text-button').show()
        }
        else {
            $('.remove-custom-package-action-text-button').hide()
        }
        if ($('.custom-package-action-text').length > 10) {
            $('.add-custom-package-action-text-button').hide()
        }
        else {
            $('.add-custom-package-action-text-button').show()
        }
    });

    // Create custom package
    $("#segment-items-container").on("click", "#create-custom-package-button", async function () {

        // Get values
        let name = $('.custom-package-name').val();
        let startText = $('.custom-package-start-text').val();
        let actionTexts = [];
        let actionTextInputs = $('.custom-package-action-text').filter(function () {
            return !!this.value;
        });
        actionTextInputs.each(function (i, e) {
            actionTexts.push($(e).val());
        });

        await makeGameRequest(createCustomProductionPackage, {name, startText, actionTexts},
            showCreateCustomProductionPackageData, {}, false);
    });

    $segmentItemsContainer.on('click', '.add-faction-member-select-button, .remove-faction-member-select-button, ' +
        '.select-faction-member, .select-faction, .segment-item-faction-name, .select-faction-leader, ' +
        '.select-managed-talent, .select-manager, .select-brand, .select-brand-talent, .segment-item-input', function (e) {
        e.stopPropagation();
    });

    // Delete segment
    $("#matches").on('click', '.event-card-segment-delete-button', async function () {
        let $segmentElement = $(this).closest('.event-match');
        let uid = parseInt($segmentElement.attr('data-uid'));
        await makeGameRequest(deleteCompanySegment, {uid}, showDeleteSegmentData,
            {$segmentElement}, false);
    });

    // Show 'add producer' page for segment
    $("#matches").on('click', '.event-card-segment-add-producer-button', async function () {
        let segmentUid = parseInt($(this).closest('.event-match').attr('data-uid'));
        await makeGameRequest(getCompanyProducers, {}, showGetAddProducersData, {segmentUid}, false);
    });

    // Add segment producer button
    $("#container").on('click', '#segment-add-producer-button', async function () {
        let parent = $('#segment-add-producer-container');
        let segmentUid = parent.data('segment-uid');
        let producerUid = parseInt(parent.find('.segment-add-producer-select').val());

        // Validate
        if (!producerUid) {
            notie.alert({type: 3, text: "Select a Producer to assign to the Segment"});
            return false;
        }

        await makeGameRequest(addProducerToSegment, {segmentUid, producerUid},
            showAddProducerToSegmentData, {segmentUid}, false);
    });

    // Remove segment producer button
    $("#matches").on('click', '.event-card-segment-remove-producer-button', async function () {
        let segmentUid = parseInt($(this).closest('.event-match').attr('data-uid'));
        await makeGameRequest(removeProducerFromSegment, {segmentUid},
            showRemoveProduceFromSegmentData, {segmentUid}, false);
    });


    // ** AUTO BOOKER / SIMULATOR **


    // Show auto booker
    $('#main-menu-right').on('click', '#auto-book-button', function () {
        hideContent($('#event-card'));

        // Reset ui
        $(".tag-match-options").remove();
        $('#add-tournament-menu-button').hide();

        // Cost
        let autoBookerCost = '15';
        if (globals.game.weeklyShow) {
            autoBookerCost = '7'
        }

        // Hide booked
        let hideBookedChecked = '';
        let rememberHideBookedChecked = '';
        let hideRememberCheckbox = ' display-none';
        if (globals.game.settings['rememberHideBooked']) {
            hideBookedChecked = ' checked="checked"';
            rememberHideBookedChecked = ' checked="checked"';
            hideRememberCheckbox = '';
        }

        // Add auto booker container
        let autoBookerHtml =
            '<div class="auto-booker-container font-bold box margin-0-auto">' +

            '<div class="margin-0-auto auto-booker">' +
            '<div class="margin-bottom-10">' +
            '<span class="font-mukta-mahee font-1p325em menu-header-color">Auto Booker</span>' +
            '<span class="blue float-right">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/> ' +
            '<span class="auto-booker-cost">' + autoBookerCost + '</span>' +
            '</span>' +
            '</div>' +

            '<div class="font-0p825em">' +
            '<div class="margin-bottom-10">' +
            '<div class="display-block margin-bottom-2">Style</div>' +
            '<select class="styled-select help-text" id="auto-booker-style" ' +
            'title="Select the booking style">' +
            '<option value="quality" selected>Quality</option>' +
            '<option value="standard">Standard</option>' +
            '<option value="long-term">Long-term</option>' +
            '<option value="bizarro">Bizarro</option>' +
            '<option value="terrible">Terrible</option>' +
            '</select>' +
            '</div>' +

            '<div class="margin-bottom-15">' +
            '<div class="display-block margin-bottom-2">Number of Matches/Segments</div>' +
            '<select class="styled-select help-text" id="auto-booker-matches" ' +
            'title="Select the number of Matches/Segments to book">' +
            '<option value="auto" selected>Auto</option>' +
            '<option value="max">Maximum</option>' +
            '<option value="min">Minimum</option>' +
            '</select>' +
            '</div>' +

            '<div class="margin-bottom-10">' +
            '<label class="control control--radio margin-right-10">' +
            'Replace<input type="radio" name="radio-auto-booker-option" value="replace" checked="checked">' +
            '<div class="control__indicator"></div></label>' +
            '<label class="control control--radio margin-right-10">' +
            'Add <input type="radio" name="radio-auto-booker-option" value="add">' +
            '<div class="control__indicator"></div></label>' +
            '</div>' +

            '<div class="margin-bottom-15">' +
            '<label class="control control--checkbox">' +
            'Hide Booked' +
            '<input type="checkbox" class="auto-booker-hide-booked-checkbox"' + hideBookedChecked + '/>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox margin-left-10' + hideRememberCheckbox + '">' +
            'Remember' +
            '<input type="checkbox" class="auto-booker-hide-booked-remember-checkbox"' + rememberHideBookedChecked + '/>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '</div>' +

            '<div>' +
            '<button type="button" ' +
            'class="button retro-button blue-button-background" id="auto-book-button">Book</button> ' +
            '</div>' +
            '</div>' +
            '</div>' +

            '</div>';

        $('#auto-booker-container').html(autoBookerHtml).show();
    });

    // Show remember 'hide booked' checkbox
    $('#auto-booker-container').on('click', '.auto-booker-hide-booked-checkbox', function () {
        if ($(this).prop('checked')) {
            $('.auto-booker-hide-booked-remember-checkbox').parent().removeClass('display-none');
        }
        else {
            $('.auto-booker-hide-booked-remember-checkbox').parent().addClass('display-none');
        }
    });

    // Change auto booker style
    $("#auto-booker-container").on('change', '#auto-booker-style', function () {
        let style = $(this).val();
        let cost = getSimulatorCost(style);
        if (globals.game.weeklyShow) {
            cost = Math.floor(cost / 2);
        }
        $('.auto-booker-cost').text(cost);
    });

    // Change game setting (remember hide booked)
    $('#auto-booker-container').on('click', '.auto-booker-hide-booked-remember-checkbox', async function () {
        let settingName = 'rememberHideBooked';
        let value = $(this).prop('checked');
        await changeGameSettingRequest(settingName, value);
    });

    // Auto book button
    $("#auto-booker-container").on('click', '#auto-book-button', async function () {
        let style = $('.auto-booker-container').find('#auto-booker-style').val();
        let numberOption = $('.auto-booker-container').find('#auto-booker-matches').val();
        let addOption = $('input[name="radio-auto-booker-option"]:checked').val();

        // If matches exist, confirm
        if ($('#matches .event-match').length > 0 && addOption === 'replace') {
            notie.confirm({
                text: 'Auto booking will remove all booked Matches/Segments. Are you sure you want to do that?',
                submitText: 'Yes',
                cancelText: 'No',
                submitCallback: async function () {
                    await autoBookRequest(style, numberOption, addOption);
                },
                cancelCallback: function () {
                    return false;
                }
            })
        }
        else {
            await autoBookRequest(style, numberOption, addOption);
        }
    });

    // Show simulator
    $('#main-menu-right').on('click', '#simulator-menu-button', function () {
        hideContent($('#event-card'));

        // Reset ui
        $(".tag-match-options").remove();
        $('#add-tournament-menu-button').hide();

        let maxEvents = 1000;

        // Add auto booker container
        let div =
            '<div class="auto-booker-container font-bold box margin-0-auto">' +

            '<div class="margin-0-auto simulator">' +
            '<div class="margin-bottom-10">' +
            '<span class="font-mukta-mahee font-1p325em menu-header-color">Simulator</span>' +
            '<span class="blue float-right">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/> ' +
            '<span class="simulator-cost">15</span>' +
            '</span>' +
            '</div>' +

            '<div class="font-0p825em">' +
            '<div class="margin-bottom-10">' +
            '<div class="display-block margin-bottom-2">Booking Style</div>' +
            '<select class="styled-select help-text" id="simulator-booking-style" ' +
            'title="Select the booking style">' +
            '<option value="quality" selected>Quality</option>' +
            '<option value="standard">Standard</option>' +
            '<option value="long-term">Long-term</option>' +
            '<option value="bizarro">Bizarro</option>' +
            '<option value="terrible">Terrible</option>' +
            '</select>' +
            '</div>' +

            '<div class="margin-bottom-10">' +
            '<div class="display-block margin-bottom-2">Events</div>' +
            '<input type="number" id="simulator-events" min="1" max="' + maxEvents + '" ' +
            'name="simulator-events" class="styled-input help-text" ' +
            'value="1" ' +
            'title="Select the number of months to simulate">' +
            '</div>' +

            '<div class="margin-bottom-20">' +
            '<div class="display-block margin-bottom-2">Notifications</div>' +
            '<select class="styled-select" id="simulator-notifications">' +
            '<option value="brief">Brief</option>' +
            '<option value="deep" selected>Deep</option>' +
            '</select>' +
            '</div>' +

            '<div class="margin-bottom-15">' +
            '<label class="control control--radio margin-right-10">' +
            'Book Only<input type="radio" name="radio-simulator-option" value="book" checked="checked">' +
            '<div class="control__indicator"></div></label>' +
            '<label class="control control--radio margin-right-10 help-text" ' +
            'title="While managing the Company, Simulator creates and disbands Teams, signs and ' +
            'releases Superstars, creates and retires Titles, uses Artifacts and calls up Superstars.">' +
            'Book & Manage Company' +
            '<input type="radio" name="radio-simulator-option" value="manage">' +
            '<div class="control__indicator"></div></label>' +
            '</div>' +

            '<div>' +
            '<button type="button" ' +
            'class="button retro-button blue-button-background" id="simulator-button">Simulate</button> ' +
            '</div>' +
            '</div>' +
            '</div>' +

            '</div>';

        $('#auto-booker-container').html(div).show();
    });

    // Simulator cost
    $("#auto-booker-container").on('input', '#simulator-events', function () {
        let style = $('#simulator-booking-style').val();
        let cost = getSimulatorCost(style);
        let totalCost = $(this).val() * cost;
        $('.simulator-cost').text(totalCost);
    });
    $("#auto-booker-container").on('change', '#simulator-booking-style', function () {
        let style = $(this).val();
        let cost = getSimulatorCost(style);
        let totalCost = $('#simulator-events').val() * cost;
        $('.simulator-cost').text(totalCost);
    });

    // Simulate button
    $("#auto-booker-container").on('click', '#simulator-button', async function () {
        let style = $('.simulator').find('#simulator-booking-style').val();
        let eventsToSimulate = parseInt($('.simulator').find('#simulator-events').val());
        let notificationsOption = $('.simulator').find('#simulator-notifications').val();
        let simulatorOption = $('.simulator').find('input[name="radio-simulator-option"]:checked').val();
        let maxEvents = 1000;

        if (eventsToSimulate < 1) {
            notie.alert({type: 3, text: "You can\'t simulate less than 1 month"});
            return false;
        }
        if (eventsToSimulate > maxEvents) {
            notie.alert({type: 3, text: "You can\'t simulate more than " + maxEvents + " Events at a time"});
            return false;
        }

        // Reset ui
        hideContent($());
        $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
        $('#simulation-results-container').show();
        $('#simulation-results-container').data('stopSimulation', false);
        $('#stop-simulation-button').parent().show();
        let progressBarHtml = '<div class="progress-under margin-bottom-20">' +
        '<div class="progress" style="width:0">' + '</div>' +
        '</div>';
        let progressHtml = '<div id="simulation-progress-bar" class="margin-bottom-25">' + progressBarHtml + '</div>';
        $('#simulation-results-container #simulation-progress').html(progressHtml);
        $('#simulation-updates').html('');
        $('#simulation-news').html('');
        notie.setOptions({
            transitionDuration: 0
        });
        notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Simulating...', stay: true});

        setTimeout(async () => {
            notie.setOptions({
                transitionDuration: 0.3
            });
            await makeGameRequest(runSimulator, {style, eventsToSimulate, simulatorOption},
                showRunSimulatorData, {style, eventsToSimulate, notificationsOption, simulatorOption,
                    totalEvents: eventsToSimulate}, false, true, true, false);
        }, 50);
    });

    // Stop simulation button
    $('#simulation-results-container').on('click', '#stop-simulation-button', function () {
        $('#simulation-results-container').data('stopSimulation', true);
        notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Stopping Simulation', stay: true});
    });


    // ** TOURNAMENT **


    // Show tournament page
    $('#main-menu-right').on('click', '#add-tournament-menu-button', async function () {

        // If tournament matches exist, don't allow
        if ($('#matches').find('.tournament-match').length > 0) {
            notie.alert({type: 3, text: "You already have a tournament booked at this event"});
            return false;
        }

        // Don't allow singles tag tournament
        if (['2v2', '3v3', '4v4', '5v5', '1v2', '1v3', '2v3', '?v?'].indexOf($('.tag-match-option.selected').text()) >= 0) {
            notie.alert({type: 3, text: "You can only book tag/trio tournaments (not 3v3, 4v4 etc)"});
            return false;
        }

        await makeGameRequest(getCompanyUniqueTournaments, {}, showGetCompanyUniqueTournamentsData,
            {}, false);
    });

    // Show Round Robin options
    $("#add-tournament-container").on('change', '#tournament-type', function () {
        if (this.value === 'round-robin') {
            $('.round-robin-options').show();
            $(this).closest('#add-tournament-container').find('#auto-pick-input').replaceWith(
                '<input type="number" id="auto-pick-input" class="auto-pick-input" name="auto-picker-value" value="12" min="4">'
            );
            $('#create-bracket').text('Create Groups');
            $('.tournament-bracket-container').hide();
        }
        else {
            $('.round-robin-options').hide();
            $(this).closest('#add-tournament-container').find('#auto-pick-input').replaceWith(
                '<select name="auto-pick-number" id="auto-pick-input" class="styled-select">' +
                '<option value="4">4</option>' +
                '<option value="8">8</option>' +
                '<option value="16" selected>16</option>' +
                '<option value="32">32</option>' +
                '<option value="64">64</option>' +
                '<option value="128">128</option>' +
                '</select>'
            );
            $('#create-bracket').text('Create Bracket');
            $('.tournament-groups-container').hide();
        }
        setTournamentMatchesAtEvent();
    });

    // Set participant options based on number of groups
    $("#add-tournament-container").on('change', '#number-of-groups', function () {
        if (this.value === '1') {
            $('#participants-advancing').html(
                '<option value="0">0</option>' +
                '<option value="2" selected>2</option>'
            );
            $('.number-of-groups-text').text(' Group')
        }
        else {
            $('#participants-advancing').html(
                '<option value="1" selected>1</option>' +
                '<option value="2">2</option>'
            );
            $('.number-of-groups-text').text(' Groups')
        }
        $('#participants-advancing').trigger('change');
        setTournamentMatchesAtEvent();
    });

    // Set participants advancing text
    $("#add-tournament-container").on('change', '#participants-advancing', function () {
        if (this.value === '1') {
            $('.participant-advancing-text').text(' Participant advances')
        }
        else if (this.value === '0') {
            $('.participant-advancing-text').text(' Participants advance (No Elimination Round)')
        }
        else {
            $('.participant-advancing-text').text(' Participants advance')
        }
        setTournamentMatchesAtEvent();
    });

    // Show award options
    $("#add-tournament-container").on('change', 'input[name="radio-award-option"]', function () {
        if (this.value === 'match-contract') {
            $('.award-options-match-contract').show()
        }
        else {
            $('.award-options-match-contract').hide()
        }
    });

    // Show selected tournament's prestige while adding a tournament
    $("#add-tournament-container").on('change', '#add-tournament-select', function () {
        let selected = $(this).find(':selected');

        if (selected.val()) {
            let prestige = $(selected).attr('data-prestige');

            let prestigeIcon = '';
            switch (prestige) {
                case 'C':
                    prestigeIcon = '<i class="fa fa-star-o font-bold top-1px margin-left-8 bronze"></i>';
                    break;
                case 'B':
                    prestigeIcon = '<i class="fa fa-star-o font-bold top-1px margin-left-8 silver"></i>';
                    break;
                case 'A':
                    prestigeIcon = '<i class="fa fa-star-o font-bold top-1px margin-left-8 gold-light"></i>';
                    break;
            }

            $('.add-tournament-select-prestige').html(prestigeIcon);

            let cost = $(selected).attr('data-cost');
            $('.add-tournament-cost').text(cost);

            // Show/hide award options
            let matchContractName = $(selected).attr('data-match-contract-name');
            if (matchContractName) {
                $('#tournament-match-contract-name').val(matchContractName);
                $('input[name="radio-award-option"]').val(['match-contract']);
                $('.award-options-match-contract').show();
            }
            else {
                $('#tournament-match-contract-name').val('');
                $('input[name="radio-award-option"]').val(['none']);
                $('.award-options-match-contract').hide();
            }

            $('#tournament-name').hide();
        }
        else {
            $('.add-tournament-select-prestige').html('');
            $('.add-tournament-cost').text('150');
            $('#tournament-match-contract-name').val('');
            $('input[name="radio-award-option"]').val(['none']);
            $('.award-options-match-contract').hide();
            $('#tournament-name').show();
        }
    });

    // Get tournament bracket
    $("#add-tournament-container").on('click', '#create-bracket', async function () {
        let tournamentType = $('.add-tournament-container').find('#tournament-type').val();
        let numberOfGroups = parseInt($('#number-of-groups').val());
        let matchType;
        let $el = $(this);
        if ($('#book-singles-menu-button').hasClass('selected')) {
            matchType = 'singles';
        }
        else if ($('#book-tag-team-menu-button').hasClass('selected')) {
            matchType = 'tag';
        }

        // Validate elimination
        if (tournamentType === 'elimination') {
            // Max
            let participantsLimit = 16;
            if (globalUser.paid) {
                participantsLimit = 128
            }
            // Minimum
            if (selectedParticipants.length < 4) {
                notie.alert({type: 3, text: "You need to select at least 4 participants for a tournament"});
                return false;
            }
            // Maximum participants
            else if (selectedParticipants.length > participantsLimit) {
                let paidText = '';
                if (!globalUser.paid) {
                    paidText += '. JoW Paid allows 128 participants.'
                }
                notie.alert({
                    type: 3, text: "You can't select more than " + participantsLimit +
                    " participants for an Elimination Tournament" + paidText
                });

                return false;
            }
            // Power of 2
            else if (!isPowerOfTwo(selectedParticipants.length)) {
                notie.alert({type: 3, text: "Tournament participants need to be a power of 2 e.g 4/8/16/32 etc"});
                return false;
            }
        }
        else if (tournamentType === 'round-robin') {
            // Max
            let participantsLimit = 12;
            if (globalUser.paid) {
                participantsLimit = 24
            }
            // Check for minimum group participants
            if (selectedParticipants.length < (numberOfGroups * 4)) {
                notie.alert({type: 3, text: "You need to select at least 4 participants for every group"});
                return false;
            }
            // Maximum group participants
            if (selectedParticipants.length > participantsLimit) {
                let paidText = '';
                if (!globalUser.paid) {
                    paidText += '. JoW Paid allows 24 participants.';
                }
                notie.alert({
                    type: 3, text: "You can't select more than " + participantsLimit +
                        " participants for a Round Robin Tournament" + paidText
                });
                return false;
            }
            // Participants per group must be even
            if (selectedParticipants.length / numberOfGroups % 2 !== 0) {
                notie.alert({type: 3, text: "The number of participants per group should be an even number"});
                return false;
            }
            // Participants multiple of number of groups
            if (selectedParticipants.length % numberOfGroups !== 0) {
                notie.alert({
                    type: 3, text: "The number of participants should be a multiple of the number of groups" +
                    " e.g 8/10/12 etc for 2 groups"
                });
                return false;
            }
            // Multiple of 2
            if (selectedParticipants.length % 2 !== 0) {
                notie.alert({type: 3, text: "Tournament participants need to be a multiple of 2 e.g 8/10/12 etc"});
                return false;
            }
        }

        // Get participants data
        let participantsData = [];
        selectedElements.forEach(function(selection) {
            let $selectionElement = $(selection);
            participantsData.push({'name': $selectionElement.attr('data-name'), 'type': $selectionElement.attr('data-type'),
                'uid': parseInt($selectionElement.attr('data-uid'))})
        });

        await makeGameRequest(getTournamentDisplay, {participantsData, tournamentType, matchType, numberOfGroups},
            showGetTournamentDisplayData, {participantsData, tournamentType, $el}, false);
    });

    // Add tournament
    $("#add-tournament-container").on('click', '#create-tournament', async function () {
        let nameElement = $('.add-tournament-container').find('#tournament-name');
        let name = nameElement.val().trim();
        let tournamentName = $('#add-tournament-select').find(':selected').val();

        let type = $('.add-tournament-container').find('#tournament-type').val();
        let matchesAtEvent = $('.add-tournament-container').find('#tournament-matches-at-event').val();
        let participantsAdvancing = parseInt($('#participants-advancing').val());

        // Get participants
        let participantsData;
        if (type === 'elimination') {
            participantsData = Array.from($('.add-tournament-container .tournament-participant-name:visible'), function (x) {
                if ($(x).attr('data-name') !== undefined) {
                    return $(x).attr('data-name')
                }
                return $(x).text()
            });
        }
        else if (type === 'round-robin') {
            participantsData = [];
            $('.add-tournament-container .tournament-bracket-match').each(function(i, e) {
                let x = [];
                $(e).find('.tournament-participant-name:visible').each(function(j, p) {
                    x.push($(p).text())
                });
                participantsData.push(x)
            })
        }

        let matchType;
        if ($('#book-singles-menu-button').hasClass('selected')) {
            matchType = 'singles'
        }
        else if ($('#book-tag-team-menu-button').hasClass('selected')) {
            matchType = 'tag';
        }

        let matchContractName = $('#tournament-match-contract-name').val();
        let matchContractEventName = $('#tournament-match-contract-event').val();
        let awardOption = $('input[name="radio-award-option"]:checked').val();

        // Validate
        if (!name && nameElement.is(':visible')) {
            notie.alert({type: 3, text: "Enter a name for the Tournament"});
            return false;
        }

        let triosMatch = $("#tag-teams:visible").length <= 0 && $("#trios:visible").length > 0;
        let selectedChampionshipUid = selectedChampionship ? parseInt(selectedChampionship.attr('data-uid')) : null;

        await makeGameRequest(createTournament, {participantsData, name, tournamentName, type, matchesAtEvent,
            matchType, matchContractName, matchContractEventName, awardOption, participantsAdvancing, triosMatch,
            selectedChampionshipUid}, showCreateTournamentData, {matchType}, false);
    });
});

function showGetBookingData({data, matchType, callbackFunction, segment, tagTeamType} = {}) {

    // Define selectors
    let $tagTeamContainer = $('#tag-teams');
    let $trioContainer = $('#trios');
    let $factionContainer = $('#factions');
    let $notAvailableSelector = $('#not-available');
    let $managersSelector = $('#managers');
    let $retiredSelector = $('#retired');
    const $bookingTalentContainer = $('#booking-talent-container');
    const $bookingContainer = $('#booking-container');
    const $bookingTalentInfo = $('#booking-talent-info');

    // Reset ui
    $bookingTalentInfo.html(emptyTalentInfoHtml);
    $bookingTalentInfo.removeClass('match');
    $bookingTalentContainer.find('.superstar-select, .none-team-text').remove();
    $bookingTalentContainer.children().hide();

    // Show vacated championships
    data['vacatedChampionships'].forEach(function (championship) {
        let name = getChampionshipDisplayName(championship);
        $('#vacated-titles').append(
            '<button type="button" class="superstar-select roster-item-championship font-bold" data-uid="' +
            championship['uid'] + '">'
            + name + '</button>'
        );
    });
    if (data['vacatedChampionships'].length > 0) {
        $('#vacated-titles').show();
    }

    if (matchType === 'singles') {

        function addSuperstarToSelector(superstar, selector) {
            let superstarDiv = getRosterMemberBookingHtml(superstar, 'superstar');
            selector.append(superstarDiv);
        }

        let $mainEventersSelector = $('#main-eventers');
        let $upperMidcardersSelector = $('#upper-midcarders');
        let $lowerMidcardersSelector = $('#lower-midcarders');
        let $jabroniSelector = $('#jabroni');

        // Add superstars to respective ranks
        data['available'].forEach(function (superstar) {
            let rankSelector;
            switch (superstar['rank']) {
                case 'Main Eventer':
                    rankSelector = $mainEventersSelector;
                    break;
                case 'Upper Midcarder':
                    rankSelector = $upperMidcardersSelector;
                    break;
                case 'Lower Midcarder':
                    rankSelector = $lowerMidcardersSelector;
                    break;
                case 'Jabroni':
                    rankSelector = $jabroniSelector;
                    break;
            }
            addSuperstarToSelector(superstar, rankSelector)
        });

        // Show containers
        $mainEventersSelector.show();
        $upperMidcardersSelector.show();
        $lowerMidcardersSelector.show();
        $jabroniSelector.show();
    }
    else if (matchType === 'tag') {

        // Show tag teams
        let tagTeams = data['teams'].filter(function (obj) {
            return obj['trio'] === false;
        });
        tagTeams.forEach(function (tagTeam) {
            let tagTeamDiv = getRosterMemberBookingHtml(tagTeam, 'tag-team');
            $tagTeamContainer.append(tagTeamDiv);
        });
        if (tagTeams.length < 1) {
            $tagTeamContainer.append('<span class="font-bold grey margin-left-5 display-block margin-top-2 none-team-text">' +
                'None</span>');
        }

        // Show trios
        let trios = data['teams'].filter(function (obj) {
            return obj['trio'] === true;
        });
        trios.forEach(function (tagTeam) { // Show tag teams
            let tagTeamDiv = getRosterMemberBookingHtml(tagTeam, 'trio');
            $trioContainer.append(tagTeamDiv);
        });
        if (trios.length < 1) {
            $trioContainer.append('<span class="font-bold grey margin-left-5 display-block margin-top-2 none-team-text">' +
                'None</span>');
        }

        // Show factions if not segment
        if (!segment && globalUser.paid) {
            data['factions'].forEach(function (faction) {
                let factionDiv = getRosterMemberBookingHtml(faction, 'faction');
                $factionContainer.append(factionDiv);
            });
            if (data['factions'].length < 1) {
                $factionContainer.append('<span class="font-bold grey margin-left-5 display-block margin-top-2 none-team-text">' +
                    'None</span>');
            }
        }

        // Show/hide containers
        if (matchType === 'tag') {
            if (tagTeamType === 'trio') {
                $trioContainer.show();
            } else {
                $tagTeamContainer.show();
                $trioContainer.show();
            }
            if (!segment) {
                $factionContainer.show()
            }
        }

        if (!globalUser.paid) {
            $factionContainer.hide();
        }
    }
    else if (matchType === 'factions') {
        // Show factions
        data['factions'].forEach(function (faction) {
            let factionDiv = getRosterMemberBookingHtml(faction, 'faction');
            $factionContainer.append(factionDiv);
        });
        if (data['factions'].length < 1) {
            $factionContainer.append('<span class="font-bold grey margin-left-7 display-block margin-top-5 none-team-text">' +
                'None</span>');
        }

        $factionContainer.show()
    }

    // Not available
    if (Array.isArray(data['notAvailable']) && data['notAvailable'].length > 0) {
        data['notAvailable'].forEach(function (superstar) {
            let rosterMemberType = matchType === 'tag' ? 'tag-team' : 'superstar';
            let superstarDiv = getRosterMemberBookingHtml(superstar, rosterMemberType);
            $notAvailableSelector.append(superstarDiv);
        });
        if (segment) {
            $notAvailableSelector.find('.superstars-header').addClass('medium-grey').removeClass('unavailable-color')
        }
        else {
            $notAvailableSelector.find('.superstars-header').removeClass('medium-grey').addClass('unavailable-color')
        }
        $notAvailableSelector.show()
    }

    // Managers
    if (Array.isArray(data['managers']) && data['managers'].length > 0 && globalUser.paid) {
        data['managers'].forEach(function (superstar) {
            let superstarDiv = getRosterMemberBookingHtml(superstar, 'superstar');
            $managersSelector.append(superstarDiv);
        });
        $managersSelector.show()
    }

    // Retired
    if (Array.isArray(data['retired']) && data['retired'].length > 0) {
        data['retired'].forEach(function (superstar) {
            let superstarDiv = getRosterMemberBookingHtml(superstar, 'superstar');
            $retiredSelector.append(superstarDiv);
        });
        $retiredSelector.show()
    }

    // Run callback function
    if (callbackFunction) {
        callbackFunction();
    }

    // Get all roster members
    let rosterMembers = data['available'].concat(data['notAvailable'], data['factions'], data['managers'],
        data['retired'], data['teams']);

    // Show roster member information
    let rosterItemMemberTimer;
    $bookingTalentContainer.off('mouseenter', '.roster-item-member');
    $bookingTalentContainer.on({
        mouseenter: function () {
            let $this = $(this);
            rosterItemMemberTimer = setTimeout(function () {
                let rosterItemMemberUid = parseInt($this.attr('data-uid'));
                let objectName = $this.attr('data-type');
                if (objectName === 'tag-team' || objectName === 'trio') {
                    objectName = 'tagTeam'
                }
                if (objectName === 'singles') {
                    objectName = 'superstar'
                }
                let member = rosterMembers.filter(function (obj) {
                    return (obj.objectName === objectName || obj.type === objectName) && obj.uid === rosterItemMemberUid;
                })[0];
                if (member) {
                    if ($this.attr('data-type') === 'tag-team' || $this.attr('data-type') === 'trio') {
                        showTagteamInformation(member);
                    }
                    else if ($this.attr('data-type') === 'faction') {
                        showFactionInformation(member);
                    }
                    else {
                        showSuperstarInformation(member);
                    }
                }
            }, 70);
        },
        mouseleave: function () {
            clearTimeout(rosterItemMemberTimer);
        }
    }, ".roster-item-member");

    // Show championship information
    let rosterItemChampionshipTimer;
    $bookingTalentContainer.off('mouseenter', '.roster-item-championship');
    $bookingTalentContainer.on({
        mouseenter: function () {
            let $this = $(this);
            rosterItemChampionshipTimer = setTimeout(function () {
                let itemUid = parseInt($this.attr('data-uid'));
                let championship = data['vacatedChampionships'].filter(function (obj) {
                    return obj.uid === itemUid;
                })[0];
                showChampionshipInformation(championship);
            }, 70);
        },
        mouseleave: function () {
            clearTimeout(rosterItemChampionshipTimer);
        }
    }, ".roster-item-championship");

    // Add custom brand filters
    $('.superstar-filter.brand-filter').remove();
    let superstarFilterNoBrand = $('.superstar-filter[data-value="no-brand"]');
    if (data['brandNames'].length > 0) {
        data['brandNames'].forEach(function (rosterBrandName) {
            let rosterBrandFilterHtml = '<button type="button" class="superstar-filter brand-filter ' +
                'button retro-button condensed light-button-background" data-value="custom-brand" ' +
                'data-brand-name="' + rosterBrandName.replace(/"/g, "&quot;") + '">' +
                rosterBrandName + '</button> ';
            superstarFilterNoBrand.before(rosterBrandFilterHtml);
        });
        superstarFilterNoBrand.show();
    }
    else {
        superstarFilterNoBrand.hide();
    }

    // Add default order
    $bookingContainer.find('.roster-item-member').each(
        function (i, e) {
            $(e).attr('data-default-order', i);
        });

    // Reset search, filters, sort
    $(".superstar-search-input").val('');
    $('.superstar-filter').removeClass('selected');
    $('.superstar-filter:contains("All")').addClass('selected');
    $('.superstar-sort').val('pop');
    $('.superstar-sort-order i').removeClass('fa-sort-up fa-sort-down fa-sort').addClass('fa-sort');
    $('.superstar-sort').find('option[value="fatigue"]').show();
    if (globals.game.settings['enable_fatigue'] === false) {
        $('.superstar-sort').find('option[value="fatigue"]').hide()
    }
    $('.no-tag-team-search-results').hide();
    $('.no-trios-search-results').hide();
    $('.no-factions-search-results').hide();

    // Show booking container and sub containers
    if (segment) {
        $('.book-segment-feuds-container').hide();
        $bookingContainer.find('#booking-talent-info, #booking-talent-container, #booking-talent-menu').show();
    }
    else {
        $bookingContainer.find('.participants-box-match-header, .participants-box-match-container, #booking-talent-info, ' +
            '#booking-talent-menu, #booking-talent-container').show();
        $bookingContainer.find('#add-segment-item-menu, #segment-items-container, .participants-box-segment-header, ' +
            '.participants-box-segment-container, #add-segment, .participants-box-callup-header, .participants-box-draft-header, ' +
            '.participants-box-trade-offer-header, #booking-championship-info').hide();
    }
    $bookingContainer.show();
    $bookingTalentContainer.hide().fadeIn();
    setTimeout(() => {
        $bookingTalentContainer.scrollTop(0);
    });

    // Add no margin top to first header
    $bookingTalentContainer.find('.superstars-header').removeClass('no-margin-top');
    $bookingTalentContainer.find('.superstars-header:visible:first').addClass('no-margin-top');

    disableTutorialPointerEvents(globals.currentTutorialStep);

    // Tutorial action check
    if (matchType === 'singles') {
        checkTutorialStepAction('click_book_button');
        checkTutorialStepAction('click_segment_singles_button');
    }
    else if (matchType === 'tag') {
        checkTutorialStepAction('click_tag_team_button');
    }
}

function getRosterMemberBookingHtml(rosterMember, memberType) {

    if (rosterMember['type'] === 'faction') {
        memberType = 'faction'
    }

    let dataAge = '';
    let dataPronoun = '';
    let dataPopularity = ' data-popularity="' + rosterMember['popularity'] + '"';
    let dataAlignment = ' data-alignment="' + rosterMember['alignment'] + '"';
    let dataOverness = ' data-overness="' + rosterMember['overness'] + '"';
    let dataCharisma = ' data-charisma="' + rosterMember['charisma'] + '"';
    let dataWorkrate = ' data-workrate="' + rosterMember['workrate'] + '"';
    let dataMorale = ' data-morale="' + rosterMember['morale'] + '"';
    let dataFatigue = ' data-fatigue="' + rosterMember['fatigue'] + '"';
    let dataType = ' data-type="' + memberType + '"';
    let dataUid = ' data-uid="' + rosterMember['uid'] + '"';
    let dataName = ' data-name="' + rosterMember['name'].replace(/"/g, "&quot;") + '"';
    let brandName = rosterMember['brandName'];
    if (brandName) {
        brandName = brandName.replace(/"/g, "&quot;")
    }
    let dataManagingMultipleTalent = (rosterMember['managedTalentNames'] && rosterMember['managedTalentNames'].length > 1) ? ' data-managing-multiple-talent="true"' : '';
    let dataBrandName = ' data-brand-name="' + brandName + '"';

    if (rosterMember['age']) {
        dataAge = ' data-age="' + rosterMember['age'] + '"'
    }
    if (rosterMember['pronoun']) {
        dataPronoun = ' data-pronoun="' + rosterMember['pronoun'] + '"'
    }

    let classes = '';
    if (rosterMember['championships'] && rosterMember['championships'].length > 0) {
        classes += 'champion ';
    }
    if (rosterMember['partTimer']) {
        classes += 'part-timer ';
    }
    if (rosterMember['unhappy']) {
        classes += 'unhappy ';
    }
    if (rosterMember['workableInjury']) {
        classes += 'dark-red ';
    }
    if (rosterMember['booked']) {
        classes += 'booked ';
    }

    return '<button type="button" class="font-bold superstar-select roster-item-member ' +
        classes + '"' + dataType + dataUid + dataAge + dataPronoun + dataPopularity + dataAlignment +
        dataOverness + dataCharisma + dataWorkrate + dataMorale + dataFatigue + dataName + dataManagingMultipleTalent +
        dataBrandName + '>' +
        rosterMember['name'] + '</button>';
}

function showSuperstarInformation(superstar, inMatch, showNumberOfAppearances, showTeamSuperstars,
                                  showViewDetailsButton = false) {
    if (typeof(inMatch) === 'undefined') inMatch = false;
    if (typeof(showNumberOfAppearances) === 'undefined') showNumberOfAppearances = true;
    // Define variables
    let championshipHtml = '';
    let appearancesHtml = '';
    let injuredHtml = '';
    let suspendedHtml = '';
    let unavailableHtml = '';
    let fotcHtml = '';
    let unhappyHtml = '';
    let cyborgHtml = '';
    let retiredHtml = '';
    let hofHtml = '';
    let teamsHtml = '';
    let factionsHtml = '';
    let managerHtml = '';
    let managedTalentHtml = '';
    let fullTimeManagerHtml = '';
    const $bookingTalentInfo = $('#booking-talent-info');

    // Add championships
    if (superstar['championships']) {
        superstar['championships'].forEach(function (championship, i) {
            championshipHtml += getTalentInformationChampionshipHtml(championship, superstar, i, inMatch);
        })
    }

    // Show appearances left if part timer or traded or returning from retirement
    if (superstar['partTimer'] || superstar['activeEffect'] === 'traded' ||
        superstar['activeEffect'] === 'retirement_return') {
        if (showNumberOfAppearances) {
            // Show 'months' instead of 'appearances' if on trade deal
            let appearancesWord = (superstar['activeEffect'] === 'traded') ? 'month' : 'appearance';
            if (superstar['appearances'] === 1) {
                appearancesHtml = superstar['appearances'] + ' ' + appearancesWord + ' left';
            }
            else {
                appearancesHtml = superstar['appearances'] + ' ' + appearancesWord + 's left';
            }
            // Add text for active effects
            if (superstar['activeEffect'] === 'traded') {
                appearancesHtml += ' | Trade Deal'
            } else if (superstar['activeEffect'] === 'retirement_return') {
                appearancesHtml += ' | Retirement Return'
            }
        }
        else {
            appearancesHtml = 'Limited appearances'
        }

        // Add help text for part timers
        if (superstar['partTimer']) {
            appearancesHtml =
                '<span class="help-text" title="Part-timer appearances are used up in Matches but not in Segments">' + appearancesHtml + '</span>'
        }
    }

    // Add injury details
    if (superstar['injured'] > 0) {
        injuredHtml = getSuperstarInjuredText(superstar);
    }

    // Add other status effects
    if (superstar['suspensionMonths'] > 0) {
        if (superstar['suspensionMonths'] === '1') {
            suspendedHtml = 'Suspended for ' + superstar['suspensionMonths'] + ' month';
        }
        else {
            suspendedHtml = 'Suspended for ' +
                superstar['suspensionMonths'] + ' months';
        }
    }
    if (superstar['unavailable']) {
        unavailableHtml = 'Unavailable';
    }
    if (superstar['unhappy']) {
        unhappyHtml = '<span class="puke-green">Unhappy</span>';
    }
    if (superstar['cyborg']) {
        cyborgHtml = '<span class="grey-blue">Cyborg</span>';
    }
    if (superstar['retired']) {
        retiredHtml = ' <span class="help-text" title="Retired Superstars can be booked in Legends, Retired ' +
            'and Manager Segments or as part of a Faction">Retired</span>';
    }
    if (superstar['hallOfFamer']) {
        hofHtml = ' <span class="gold">Hall of Famer</span>';
    }
    if (superstar['faceOfTheCompany']) {
        fotcHtml = '<span class="light-grey margin-left-5 help-text" title="Face of the Company">' +
            '<i class="fa fa-star medium-blue"></i>' +
            '</span>';
    }
    else if (superstar['faceOfTheCompanyCounter'] > 0) {
        fotcHtml = '<span class="light-grey margin-left-5 help-text" title="Face of the Company progress in months">' +
            '<i class="fa fa-star medium-blue"></i> ' +
            String(parseInt(superstar['faceOfTheCompanyCounter'])) +
            '/6' +
            '</span>';
    }

    // Add teams and factions
    if (superstar['teams'] && superstar['teams'].length > 0) {
        teamsHtml = Array.from(superstar['teams'], function(team) {return team + ' (Team)'});
        teamsHtml = commaSeparate(teamsHtml, '&');
    }
    if (superstar['factions'] && superstar['factions'].length > 0) {
        factionsHtml = Array.from(superstar['factions'], function(faction) {return faction + ' (Faction)'});
        factionsHtml = commaSeparate(factionsHtml, '&');
    }

    // Add manager details
    if (globalUser.paid) {
        if (superstar['managerNames'] && superstar['managerNames'].length > 0) {
            managerHtml = '{0} <span class="light-grey">(Manager)</span>'.format(superstar['managerNames'])
        }
        if (superstar['managedTalentNames'] && superstar['managedTalentNames'].length > 0) {
            managedTalentHtml = 'Managing {0}'.format(commaSeparate(superstar['managedTalentNames']));
        }
        if (!managedTalentHtml && superstar['fullTimeManager']) {
            fullTimeManagerHtml = 'Full-time Manager'
        }
    }

    // Popularity
    let popularityHtml = superstar['popularity'];

    // Change charisma/workrate class if hot
    let charismaClass = 'charisma-purple';
    let workrateClass = 'workrate-blue';
    if (superstar['hot']) {
        charismaClass = 'hot-color';
        workrateClass = 'hot-color';
    }

    // Charisma
    let charismaHtml = getTalentInformationCharismaHtml(superstar, charismaClass);

    // Workrate
    let workrateHtml = getTalentInformationWorkrateHtml(superstar, workrateClass);

    // Winning/Losing Streak
    let winLossHtml = '';
    if (superstar['wins'] !== undefined) {
        winLossHtml = getTalentInformationWinLossHtml(superstar);
    }

    // Traits
    let superstarTraitsHtml = '';
    if (superstar['traits'].length > 0) {
        let superstarTraitsHtmlArray = [];
        // Show traits with help text
        superstar['traits'].forEach(function(superstarTrait) {
            let traitHtml = '<span class="superstar-trait-color">' + getSuperstarTraitHelpHtml(superstarTrait) + '</span>';
            superstarTraitsHtmlArray.push(traitHtml)
        });
        superstarTraitsHtml = '<span class="light-grey">' + superstarTraitsHtmlArray.join(', ') + '</span>'
    }

    // Contract months remaining
    let contractMonthsRemainingHtml = '';
    if (superstar['contractMonthsRemaining']) {
        let contractMonthsRemainingWord = getMonthsWord(superstar['contractMonthsRemaining']);
        contractMonthsRemainingHtml = '<span class="puke-green">{0} {1} to leave</span>'.format(superstar['contractMonthsRemaining'], contractMonthsRemainingWord);
    }

    // One match appearance
    let oneMatchAppearanceHtml = '';
    if (superstar['activeEffect'] === 'one_match_appearance') {
        oneMatchAppearanceHtml = 'One Match Appearance'
    }

    // Partner superstars
    let partnersHtml = '';
    if (showTeamSuperstars && superstar['teamSuperstars'] && superstar['teamSuperstars'].length > 0) {
        partnersHtml = 'Partners: ' + commaSeparate(superstar['teamSuperstars'], '&')
    }

    // Brand name
    let brandNameHtml = '';
    if (superstar['brandName']) {
        brandNameHtml = superstar['brandName'];
    }

    // Company name
    let companyNameHtml = '';
    if (superstar['companyName']) {
        companyNameHtml = superstar['companyName'];
    }

    // Join info
    let info = [companyNameHtml, brandNameHtml, championshipHtml, injuredHtml, suspendedHtml, unavailableHtml,
        appearancesHtml, oneMatchAppearanceHtml, unhappyHtml, contractMonthsRemainingHtml, managerHtml, managedTalentHtml,
        fullTimeManagerHtml, superstarTraitsHtml, cyborgHtml, retiredHtml, hofHtml, teamsHtml, factionsHtml, partnersHtml];
    info = $.grep(info, Boolean).join(" | ");
    if (info) {
        info = '<div class="font-bold medium-grey display-block margin-top-2 superstar-info-information">' + info + '</div>';
    }
    else {
        info = ''
    }

    // Alignment
    let alignmentHtml = getTalentInformationAlignmentHtml(superstar);

    // Gimmick
    let gimmickHtml = '';
    if (superstar['gimmick']) {
        let gimmickEffectiveness = '';
        if (superstar['gimmick']['effectiveness']) {
            gimmickEffectiveness = '<span class="light-grey margin-left-8">(' + superstar['gimmick']['effectiveness'] + '%)</span>';
        }
        gimmickHtml = '<span class="character-label margin-left-8">' + superstar['gimmick']['name'] + gimmickEffectiveness + '</span>';
    }

    // Hot/stale
    let hotOrStaleIcon = '';
    let hotStaleText;
    let overnessClass = '';
    if (superstar['hot']) {
        overnessClass = 'hot-color';
        hotOrStaleIcon = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5">';
        hotStaleText = 'Being Over boosts a Superstar\'s Attributes (Workrate, Charisma), their Popularity ' +
            'changes, the changes in their Gimmick Effectiveness ' +
            ' and the chance to have Hot Matches, Segments and Feuds.';
    }
    else if (superstar['stale']) {
        overnessClass = 'stale-color';
        hotOrStaleIcon = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5">';
        hotStaleText = 'Becoming Stale lowers the ratings of a Superstar\'s Segments, ' +
            ' their Popularity gains and the chance to have Hot Matches, Segments and Feuds.';
    }

    // Overness
    let overnessHtml;
    if (superstar['hot'] || superstar['stale']) {
        overnessHtml =
            '<span class="help-text ' + overnessClass + '" title="' + hotStaleText + '">' +
            Math.round(superstar['overness']) + '%' + hotOrStaleIcon +
            '</span>';
    }
    else {
        overnessHtml =
            '<span class="help-text" title="' + getOvernessLevelText(superstar['overness']) + '">' +
            Math.round(superstar['overness']) + '%' +
            '</span>';
    }

    // Morale
    let moraleHtml = getTalentInformationMoraleHtml(superstar);

    // Fatigue
    let fatigueHtml = getTalentInformationFatigueHtml(superstar);

    // Show graphic
    if (inMatch) {
        const $matchSuperstarInformation = $('.match-superstar-information');
        let infoClass = 'superstar-info-match-container';
        // Add match element
        if ($matchSuperstarInformation.length < 1) {
            $('.match-buttons-container').after('<div class="match-superstar-information information-box"></div>')
        }
        // Select match element
        let elementToAddTo = $matchSuperstarInformation;
        $bookingTalentInfo.hide();

        elementToAddTo.html(
            '<div class="' + infoClass + '">' +
            '<div class="font-bold display-block margin-bottom-5">' + superstar['name'] + gimmickHtml + '</div>' +
            '<div class="superstar-info-column-left">' +
                '<div class="display-block medium-grey font-bold">' +
                '<span class="grey margin-right-5">Pop.</span>' +
                popularityHtml +
                fotcHtml +
                '</div>' +
                '<div class="display-block medium-grey font-bold">' +
                '<span class="grey margin-right-5">Age.</span>' +
                superstar['age'] +
                '</div>' +
                '<div class="display-block medium-grey font-bold">' +
                '<span class="grey margin-right-5">Aln.</span>' +
                alignmentHtml +
                '</div>' +
                winLossHtml +
                fatigueHtml +
            '</div>' +
            '<div class="superstar-info-column-right">' +
                '<div class="display-block grey font-bold">' +
                workrateHtml +
                '</div>' +
                '<div class="display-block grey font-bold">' +
                charismaHtml +
                '</div>' +
                '<div class="display-block medium-grey font-bold">' +
                '<span class="grey margin-right-5 width-32px display-inline-block">Ovr.</span>' +
                '<span class="margin-left-4">' +
                overnessHtml +
                '</span>' +
                '</div>' +
                '<div class="display-block medium-grey font-bold">' +
                '<span class="grey margin-right-5 width-32px display-inline-block">Mor.</span>' +
                '<span class="margin-left-4">' +
                moraleHtml +
                '</span>' +
                '</div>' +
            '</div>' +
            '<div class="clear"></div>' +
            info +
            '</div>'
        );
    }
    else {
        let viewDetailsButton = '';
        if (!showViewDetailsButton) {
            viewDetailsButton = '<button type="button" class="button retro-button grey-button-background condensed remove-outline no-select ' +
                'view-roster-member-details-button margin-top-8" data-type="superstar" data-uid="' + superstar['uid'] + '">View Details</button>';
        }
        const superstarInfoHtml =
            '<div class="superstar-information-container">' +
            '<div class="superstar-column-left">' +
            '<div class="font-bold display-block margin-bottom-5">' + superstar['name'] + gimmickHtml + '</div>' +
            '<div class="superstar-info-column-left">' +
                '<div class="display-block medium-grey font-bold superstar-info-popularity">' +
                '<span class="grey margin-right-5">Pop.</span>' +
                popularityHtml +
                fotcHtml +
                '</div>' +
                '<div class="display-block medium-grey font-bold">' +
                '<span class="grey margin-right-5">Age</span>' +
                '<span class="margin-left-5">' + superstar['age'] + '</span>' +
                '</div>' +
                '<div class="display-block medium-grey font-bold">' +
                '<span class="grey margin-right-5">Aln.</span>' +
                alignmentHtml +
                '</div>' +
                winLossHtml +
                fatigueHtml +
            '</div>' +
            '<div class="superstar-info-column-right">' +
                '<div class="display-block grey font-bold superstar-info-workrate">' +
                workrateHtml +
                '</div>' +
                '<div class="display-block grey font-bold superstar-info-charisma">' +
                charismaHtml +
                '</div>' +
                '<div class="display-block medium-grey font-bold">' +
                '<span class="grey margin-right-5 width-32px display-inline-block">Ovr.</span>' +
                '<span class="margin-left-4">' +
                overnessHtml +
                '</span>' +
                '</div>' +
                '<div class="display-block medium-grey font-bold">' +
                '<span class="grey margin-right-5 width-32px display-inline-block">Mor.</span>' +
                '<span class="margin-left-4">' +
                moraleHtml +
                '</span>' +
                '</div>' +
            '</div>' +
            '<div class="clear"></div>' +
            info +
            '</div>' +
            '<div class="superstar-column-right">' +
                '<div class="superstar-info-graphic"></div>' +
                '<div class="margin-top-3 text-center">' +
                    '<button type="button" class="button retro-button grey-button-background ' +
                                'condensed remove-outline attire-select-button no-select selected">A</button>\n' +
                    '<button type="button" class="button retro-button grey-button-background ' +
                                'condensed remove-outline attire-select-button no-select">B</button>\n' +
                    '<button type="button" class="button retro-button grey-button-background ' +
                                'condensed remove-outline attire-select-button no-select">C</button>' +
                '</div>' +
            '</div>' +
            '<div class="clear"></div>' +
            viewDetailsButton +
            '</div>';

        $bookingTalentInfo.html(superstarInfoHtml);
        $bookingTalentInfo.show();
        $('#booking-container').show();

        // Show graphic
        let el = $bookingTalentInfo.find('.superstar-info-graphic');
        showTalentInformationGraphic([superstar['graphic']], el, null);
        $('.superstar-information-container').scrollTop(0);
    }
    $("#booking-championship-info").hide();
}

function showTagteamInformation(tagTeam, inMatch) {
    if (typeof(inMatch) === 'undefined') inMatch = false;

    const $bookingTalentInfo = $('#booking-talent-info');

    // Add championships
    let championshipHtml = '';
    if (tagTeam['championships']) {
        tagTeam['championships'].forEach(function (championship, i) {
            championshipHtml += getTalentInformationChampionshipHtml(championship, tagTeam, i, inMatch);
        })
    }

    // Popularity
    let popularityHtml = tagTeam['popularity'];

    // Charisma
    let charismaHtml = getTalentInformationCharismaHtml(tagTeam, 'charisma-purple');

    // Workrate
    let workrateHtml = getTalentInformationWorkrateHtml(tagTeam, 'workrate-blue');

    // Alignment
    let alignmentHtml = getTalentInformationAlignmentHtml(tagTeam);

    // Overness
    let overnessHtml =
        '<span class="help-text" title="' + getOvernessLevelText(tagTeam['overness']) + '">' +
        Math.round(tagTeam['overness']) + '%' +
        '</span>';

    // Show appearances left
    let appearancesHtml = '';
    if (tagTeam['appearances'] !== null && tagTeam['appearances'] !== undefined) {
        let appearancesMonthWord = (tagTeam['appearances'] === 1) ? 'appearance' : 'appearances';
        appearancesHtml = tagTeam['appearances'] + ' ' + appearancesMonthWord + ' left';
    }

    // Unhappy
    let unhappyHtml = '';
    if (tagTeam['unhappy']) {
        unhappyHtml = '<span class="puke-green">Unhappy</span>';
    }

    // Winning/Losing Streak
    let winLossHtml = '';
    if (tagTeam['wins'] !== undefined) {
        winLossHtml = getTalentInformationWinLossHtml(tagTeam);
    }

    // Superstars
    let tagTeamSuperstars = commaSeparate(tagTeam['superstars']);

    // Traits
    let traitsHtml = '';
    if (tagTeam['traits'].length > 0) {
        let traitsHtmlArray = [];
        // Show traits with help text
        tagTeam['traits'].forEach(function(traitData) {
            let traitHtml = '<span class="superstar-trait-color">' + getSuperstarTraitHelpHtml(traitData['name']) +
                '<span class="margin-left-5 light-grey">(' + traitData['superstar'] + ')</span>' +
                '</span>';
            traitsHtmlArray.push(traitHtml)
        });
        traitsHtml = '<span class="light-grey">' + traitsHtmlArray.join(', ') + '</span>'
    }

    // Morale
    let moraleHtml = getTalentInformationMoraleHtml(tagTeam);

    // Fatigue
    let fatigueHtml = getTalentInformationFatigueHtml(tagTeam);

    // Manager details
    let managerHtml = '';
    if (globalUser.paid) {
        if (tagTeam['managerNames'] && tagTeam['managerNames'].length > 0) {
            let managerWord = (tagTeam['managerNames'].length === 1) ? 'Manager' : 'Managers';
            managerHtml = '{0} <span class="light-grey">({1})</span>'.format(commaSeparate(tagTeam['managerNames']), managerWord)
        }
    }

    // Brand name
    let brandNameHtml = '';
    if (tagTeam['brandName']) {
        brandNameHtml = tagTeam['brandName'];
    }

    // Join second line info together
    let info = [brandNameHtml, championshipHtml, tagTeamSuperstars, appearancesHtml, unhappyHtml, managerHtml,
        traitsHtml];
    info = $.grep(info, Boolean).join(" | ");

    if (inMatch) {
        const $matchSuperstarInformation = $('.match-superstar-information');
        // Add match element
        if ($matchSuperstarInformation.length < 1) {
            $('.match-buttons-container').after('<div class="match-superstar-information information-box"></div>')
        }
        $matchSuperstarInformation.html(
            '<div class="superstar-info-match-container">' +

                '<div class="font-bold display-block margin-bottom-5">' + tagTeam['name'] + '</div>' +
                '<div class="superstar-info-column-left">' +
                    '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5">Pop.</span>' +
                        popularityHtml +
                    '</div>' +
                    '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5">Age.</span>' +
                        tagTeam['age'] +
                    '</div>' +
                    '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5">Aln.</span>' +
                        alignmentHtml +
                    '</div>' +
                    winLossHtml +
                    fatigueHtml +
                '</div>' +
                '<div class="superstar-info-column-right">' +
                    '<div class="display-block grey font-bold">' +
                        workrateHtml +
                    '</div>' +
                    '<div class="display-block grey font-bold">' +
                        charismaHtml +
                    '</div>' +
                    '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5 width-32px display-inline-block">Ovr.</span>' +
                        '<span class="margin-left-4">' +
                        overnessHtml +
                        '</span>' +
                    '</div>' +
                    '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5 width-32px display-inline-block">Mor.</span>' +
                        '<span class="margin-left-4">' +
                        moraleHtml +
                        '</span>' +
                    '</div>' +
                '</div>' +
                '<div class="clear"></div>' +
                '<div class="font-bold medium-grey display-block margin-top-2 superstar-info-information">' + info + '</div>' +

            '</div>'
        )
    }
    else {
        const tagTeamInfoHtml =
            '<div class="superstar-information-container">' +
                '<div class="superstar-column-left">' +
                    '<div class="font-bold display-block margin-bottom-5">' + tagTeam['name'] + '</div>' +
                    '<div class="superstar-info-column-left">' +
                        '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5">Pop.</span>' +
                        popularityHtml +
                        '</div>' +
                        '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5">Age.</span>' +
                        tagTeam['age'] +
                        '</div>' +
                        '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5">Aln.</span>' +
                        alignmentHtml +
                        '</div>' +
                        winLossHtml +
                        fatigueHtml +
                    '</div>' +
                    '<div class="superstar-info-column-right">' +
                        '<div class="display-block grey font-bold">' +
                        workrateHtml +
                        '</div>' +
                        '<div class="display-block grey font-bold">' +
                        charismaHtml +
                        '</div>' +
                        '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5 width-32px display-inline-block">Ovr.</span>' +
                        '<span class="margin-left-4">' +
                        overnessHtml +
                        '</span>' +
                        '</div>' +
                        '<div class="display-block medium-grey font-bold">' +
                        '<span class="grey margin-right-5 width-32px display-inline-block">Mor.</span>' +
                        '<span class="margin-left-4">' +
                        moraleHtml +
                        '</span>' +
                        '</div>' +
                    '</div>' +
                    '<div class="clear"></div>' +
                '</div>' +

                '<div class="superstar-column-right">' +
                    '<div class="superstar-info-graphic"></div>' +
                '</div>' +

                '<div class="clear"></div>' +

                '<div class="font-bold medium-grey display-block margin-top-2 superstar-info-information">' + info + '</div>' +
                '<button type="button" class="button retro-button grey-button-background condensed remove-outline no-select ' +
                'view-roster-member-details-button margin-top-8" data-type="tagTeam" data-uid="' + tagTeam['uid'] + '">View Details</button>' +

            '</div>';

        $bookingTalentInfo.html(tagTeamInfoHtml);
        $bookingTalentInfo.show();
        $('#booking-container').show();

        // Show graphic
        let el = $bookingTalentInfo.find('.superstar-info-graphic');
        showTalentInformationGraphic(tagTeam['graphics'], el, {'type': 'tag', 'largerTag': tagTeam['graphics'].length});
    }
    $("#booking-championship-info").hide();
}

function showFactionInformation(faction) {

    const $bookingTalentInfo = $('#booking-talent-info');

    let factionSuperstarsHtml = getFactionSuperstarsHtml(faction['superstars'], false, true);

    let factionHtml =
        '<div class="superstar-information-container">' +
            '<div class="font-bold display-block margin-bottom-2">' + faction['name'] +
            '<span class="float-right light-grey">' +
                faction['reputationData']['reputation'] + ' REP' +
            '</span>' +
            '</div>' +
            '<div class="faction-info-graphic-container margin-bottom-10"></div>' +
            '<div class="font-bold medium-grey display-block superstar-info-information">' + factionSuperstarsHtml + '</div>' +
            '<button type="button" class="button retro-button grey-button-background condensed remove-outline no-select ' +
            'view-roster-member-details-button margin-top-8" data-type="faction" data-uid="' + faction['uid'] + '">View Details</button>' +
        '</div>';

    $bookingTalentInfo.html(factionHtml);
    $bookingTalentInfo.show();
    $('#booking-container').show();

    // Show graphic
    let el = $bookingTalentInfo.find('.faction-info-graphic-container');
    let matchData = {'type': 'singles', 'largerTag': faction['graphic'].length, 'factionGraphic': true};
    if (faction['graphic'].length > 10) {
        matchData = {'type': 'singles'}
    }
    showFactionInformationGraphic(faction['graphic'], el, matchData);

    $("#booking-championship-info").hide();
}

function showChampionshipInformation(championship) {

    // Get full name
    let name = getChampionshipDisplayName(championship);
    if (championship['event']) {
        name += ' (' + championship['event'] + ')'
    }
    $(".championship-name").text(name);

    // Brand name
    let brandNameHtml = '';
    if (championship['brandName']) {
        brandNameHtml = championship['brandName'];
    }

    // Gimmick restriction
    let gimmickRestrictionHtml = '';
    if (championship['gimmickRestriction']) {
        gimmickRestrictionHtml = getChampionshipGimmickRestrictionText(championship['gimmickRestriction']);
    }

    // Join info
    let info = [brandNameHtml, championship['rank'], gimmickRestrictionHtml];
    info = $.grep(info, Boolean).join(" | ");
    $(".championship-info").html(info);

    // Show graphic
    if (championship['graphic']) {
        let el = $('#booking-championship-info-graphic');
        showChampionshipInformationGraphic([championship['graphic']], el);
    }
    else {
        $('#booking-championship-info-graphic').html('<div class="empty-championship-graphic">' +
            '<div class="text-center vertical-center">No graphic</div>' +
            '</div>');
    }

    $("#booking-talent-info").hide();
    $("#booking-championship-info").show();
}

function getTalentInformationChampionshipHtml(championship, talent, index, inMatch) {
    let championshipHtml = '';

    // Get name
    let name;
    if (talent['championships'].length > 3) {
        name = championship['name']
    }
    else {
        name = getChampionshipDisplayName(championship, true)
    }

    // Get prestige
    let prestigeIcon = '<span class="margin-left-5">' +
        getChampionshipPrestigeIconHtml(championship['prestige']) +
        '</span>';

    // Get reign length
    let reignLength = '';
    if (championship['reignLength'] !== undefined) {
        let monthsWord = (championship['reignLength'] === 1) ? 'Month' : 'Months';
        reignLength = '<span class="light-grey margin-left-5"> {0} {1}</span>'.format(championship['reignLength'], monthsWord);
    }

    // Add separator and margin if more than 1 championship
    let separatorHtml = '';
    let marginClass = '';
    if (index > 0) {
        marginClass = 'margin-left-5 ';
        separatorHtml = '<span class="margin-left-5">|</span>';
    }

    // Add html
    championshipHtml +=
        separatorHtml + '<span class="' + marginClass + 'gold">' +
            name + prestigeIcon + reignLength +
        '</span>';

    // Add cashin button
    if (championship['championshipContract'] && !inMatch) {
        championshipHtml += '<button type="button" id="championship-contract-cashin-show" ' +
            'class="button retro-button condensed gold-button-background margin-left-5 no-margin-bottom help-text" ' +
            'data-uid="' + championship['championshipUid'] + '" ' +
            'title="Cash in this contract for the championship at the upcoming event. You can also cash it ' +
            'in during a championship match (a cash in button will appear during championship matches)">' +
            'Cash In' +
            '</button>';
    }

    return championshipHtml;
}

function getTalentInformationAlignmentHtml(talent) {
    let alignment = talent['alignment'];
    let alignmentClass;
    switch (talent['alignment']) {
        case 'heel':
            alignmentClass = 'alignment-heel';
            break;
        case 'face':
            alignmentClass = 'alignment-face';
            break;
        default:
            alignmentClass = 'alignment-neutral';
            alignment = 'Neutral';
    }
   return '<span class="margin-left-5 ' + alignmentClass + '">' + toTitleCase(alignment) + '</span>';
}

function getTalentInformationWinLossHtml(talent) {
    let winningLosingStreaksData = ' <span class="help-text" title="Win/Loss Streaks">({0}-{1})</span>'.format(talent['winsCounter'], talent['lossesCounter']);
    let winningLosingData = '{0}-{1}'.format(talent['wins'], talent['losses']);
    return '<div class="display-block medium-grey font-bold">' +
        '<span class="grey margin-right-10">W/L</span>' +
        winningLosingData + winningLosingStreaksData +
        '</div>';
}

function getTalentInformationMoraleHtml(talent) {
     return '<span class="help-text ' + getRosterMemberMoraleClass(talent['morale']) +
        '" title="' + getRosterMemberMoraleText(talent['morale']) + '">' +
        talent['morale'] + '%' +
        '</span>';
}

function getTalentInformationWorkrateHtml(talent, workrateClass) {
    let workrateStars = getStarRatingHtml(talent['workrate'], workrateClass, 3);
    return '<span class="grey">Wor.</span>' +
        '<span class="margin-left-5 font-1p125em ' + workrateClass + '" role="text" aria-label="' +
        talent['workrate'] + ' star workrate' + '">' +
        workrateStars +
        '</span>';
}

function getTalentInformationCharismaHtml(talent, charismaClass) {
    let charismaStars = getStarRatingHtml(talent['charisma'], charismaClass, 3);
    return '<span class="grey">Cha.</span>' +
        '<span class="margin-left-5 font-1p125em ' + charismaClass + '" role="text" aria-label="' +
        talent['charisma'] + ' star charisma' + '">' +
        charismaStars +
        '</span>';
}

function getTalentInformationFatigueHtml(talent) {
    return '<div class="display-block medium-grey font-bold">' +
        '<span class="grey margin-right-5">Fat.</span>' +
        '<span class="margin-left-6 ' + getRosterMemberFatigueClass(talent['fatigue']) + ' help-text" ' +
        'title="Fatigue affects the chance of getting injured">' +
        talent['fatigue'] + '%' +
        '</span>' +
        '</div>'
}

function showGetFeudsForBookingData({data, matchType, $el} = {}) {
    let html = '';
    if (data['feuds'].length > 0) {
        let currentFeuds = data['feuds'].filter(function (feud) {
            return feud['started']
        });
        let potentialFeuds = data['feuds'].filter(function (feud) {
            return !feud['started']
        });

        // Current feuds
        if (currentFeuds.length > 0) {
            let marginBottomClass = '';
            if (potentialFeuds.length > 0) {
                marginBottomClass = ' margin-bottom-10';
            }
            html += '<div class="current-feuds-items' + marginBottomClass + '"><span class="display-block margin-left-2 ' +
                'font-bold margin-bottom-2 medium-grey">Current Feuds</span>';
            currentFeuds.forEach(function (feud) {
                html += getFeudBookingHtml(feud)
            });
            if (currentFeuds.length <= 0) {
                html += '<span class="display-block grey ' +
                    'font-bold font-0p925em">No Current Feuds</span>';
            }
            html += '</div>';
        }

        // Potential feuds
        if (potentialFeuds.length > 0) {
            html += '<div class="potential-feuds-items"><span class="display-block margin-left-2 ' +
                'font-bold margin-bottom-2 medium-grey">Potential Feuds</span>';
            potentialFeuds.forEach(function (feud) {
                html += getFeudBookingHtml(feud)
            });
            if (potentialFeuds.length <= 0) {
                html += '<span class="display-block grey ' +
                    'font-bold font-0p925em">No Potential Feuds</span>';
            }
            html += '</div>';
        }

        $el.html(html).show();
        $el.scrollTop(0);

        disableTutorialPointerEvents(globals.currentTutorialStep);

        // Tutorial action check
        if (matchType === 'singles') {
            setTimeout(function () {
                checkTutorialStepAction('click_book_singles_feud_button')
            }, 100);
        }
    } else {
        if (matchType === 'segment') {
            html += '<span class="display-block grey ' +
                'font-bold font-0p925em margin-left-2">No Feuds present</span>';
            $el.html(html).show();
        } else {
            $el.html(html).hide();
        }
    }
}

function getFeudBookingHtml(feud) {
    // Get participant names
    let participantNames = feud['participants'].join(' vs ');

    // Get potential display
    let potential = '';
    if (!feud['started']) {
        potential = '<div class="potential-feud-red">Potential</div>';
    }

    // Get hype class
    let hypeClass = 'faded-red-light';
    if (feud['hot']) {
        hypeClass = 'hot-color'
    }
    if (feud['stale']) {
        hypeClass = 'stale-color'
    }

    // Get months passed
    let duration = '';
    if (feud['monthsElapsed'] !== undefined) {
        duration = feud['monthsElapsed'] + ' ' + getMonthsWord(feud['monthsElapsed']) + ' long'
    }

    // Get staleness data
    let stalenessCheck = '';
    if (feud['staleLength']) {
        stalenessCheck =
            '<span class="display-block light-grey help-text" ' +
            'title="Monthly Event Matches add +1, Weekly Show Matches add ' +
            '+0.5 and Segments add +0.25 to the Feud\'s Staleness Check.">' + feud['stalenessCounter'] + ' / ' +
            '<span class="stale-color">' + feud['staleLength'] + '</span>' +
            '<span class="margin-left-5">Staleness</span>' +
            '</span>';
    }

    return '<div class="feud-container item-container compact font-bold" data-uid="' + feud['uid'] + '" tabindex="0">' +
            '<div class="margin-bottom-5">' +
                getShortenedName(feud['name'], 19) +
                '<span class="float-right ' + hypeClass + '">' +
                '<i class="fa fa-bolt margin-right-5"></i>' + Math.round(feud['hype']) +
                '</span>' +
            '</div>' +
            '<div class="grey feud-participants line-height-1p4">' + participantNames + '</div>' +
            '<div>' +
                stalenessCheck +
            '</div>' +
            '<div class="light-grey">' +
                duration +
            '</div>' +
            potential +
        '</div>';
}

function getSegmentBookingMenuHtml() {
    let factionsOptionHtml = '';
        if (globalUser.paid) {
            factionsOptionHtml = '<button type="button" class="book-segment-option button retro-button condensed grey-button-background">Factions</button>'
        }
    return '<div class="book-segment-options">' +
        '<button type="button" class="book-segment-option button retro-button condensed grey-button-background selected margin-right-5">Feuds</button>' +
        '<button type="button" class="book-segment-option button retro-button condensed grey-button-background margin-right-5">Singles</button>' +
        '<button type="button" class="book-segment-option button retro-button condensed grey-button-background margin-right-5">Tag</button>' +
        factionsOptionHtml +
        '</div>';
}

function getSegmentItemMenuHtml() {
    let factionsFilterHtml = '';
    if (globalUser.paid) {
        factionsFilterHtml = '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="faction"> ' +
            'Faction' +
            '</button> ';
    }
    let managersFilterHtml = '';
    if (globalUser.paid) {
        managersFilterHtml = '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="manager"> ' +
            'Manager' +
            '</button> ';
    }
    let brandsFilterHtml = '';
    if (globalUser.paid) {
        brandsFilterHtml = '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="brand"> ' +
            'Brand' +
            '</button> ';
    }
    let customSegmentMenuButton = '<button type="button" class="button retro-button condensed purple-button-background' +
        ' add-custom-segment-segments-menu-button">' +
        '<i class="fa fa-plus-circle"></i> Custom' +
        '</button> ';
    let segmentSortHtml = '<select title="Segment sort" name="segment-sort" class="styled-select segment-sort remove-outline">' +
            '<option value="default-order" selected>Default</option>' +
            '<option value="participants">Part.</option>' +
            '<option value="hype-boost">Hype</option>' +
            '<option value="popularity-boost">Pop.</option>' +
            '<option value="entertainment">Ent.</option>' +
            '<option value="action">Act.</option>' +
            '<option value="difficulty">Diff.</option>' +
            '</select> ' +
            '<div class="font-bold dark-grey margin-left-3 display-inline-block segment-sort-order ' +
            'help-text" title="Reverse sort order">' +
            '<i class="fa fa-sort"></i>' +
            '</div>';

    return '<div class="display-inline-block">' +
            '<div>' +
            '<input type="text" name="segment-search" placeholder="Search" autocomplete="off" ' +
            'class="styled-input segment-search-input remove-outline margin-bottom-5"> ' +
            '</div>' +
            '<div>' +
                segmentSortHtml +
            '</div>' +
        '</div>' +

        '<div class="filter-segment-items-options float-right display-inline-block">' +

            '<div class="text-right margin-right-7"> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background selected">' +
                    'All' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="feud">' +
                    'Feud' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="repeatable"> ' +
                    'Repeatable' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="production">' +
                    'Production' +
                '</button> ' +
                customSegmentMenuButton +
                factionsFilterHtml +
                managersFilterHtml +
                '<button type="button"" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="available"> ' +
                    'Available' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="alignment">' +
                    'Alignment' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="title"> ' +
                    'Title ' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="special"> ' +
                    'Special' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="custom"> ' +
                    'Custom' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="silly"> ' +
                    'Silly ' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="team"> ' +
                    'Team' +
                '</button> ' +
               brandsFilterHtml +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="retired"> ' +
                    'Retired' +
                '</button> ' +
                '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="locked"> ' +
                    'Locked ' +
                '</button> ' +
            '</div> ' +
        '</div>' +
        '<div class="clear"></div>';
}

function showGetCompanyProducersData({data} = {}) {
    let parent = $('#add-segment-producer-container');
    let producerSelect = parent.find('.add-segment-producer-select');
    let producerOptions = '';
    data['producers'].forEach(function (producer) {
        producerOptions += '<option value="' + producer['uid'] + '">' + producer['name'] + ' (Lvl ' + producer['level'] + ')</option>'
    });
    if (data['producers'].length <= 0) {
        producerOptions += '<option disabled selected value>No Producers Available</option>'
    }
    producerSelect.html(producerOptions);
    parent.show();
}

function runSegmentSearch() {

    let segmentItemsContainer = $('#segment-items-container');
    let segmentElements = segmentItemsContainer.find('.item-container');
    let searchTerm = $(".segment-search-input").val();

    // Deselect add custom segment container
    segmentItemsContainer.show();
    $('.add-custom-segment-container').hide();
    $('.add-custom-segment-segments-menu-button').removeClass('selected');

    // Run search
    if (searchTerm.length > 0) {
        let searchResults = runFuseElementsSearch(segmentElements, searchTerm, ['dataset.name',
            'dataset.requirement', 'dataset.consequence']);
        segmentElements.hide();

        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function (e) {
                $(e).show()
            });
            $('.no-segment-search-results').hide();
        }
        else {
            if ($('.no-segment-search-results').length > 0) {
                $('.no-segment-search-results').show()
            }
            else {
                segmentItemsContainer.append('<div class="no-segment-search-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
        }
    }
    else {
        segmentElements.show();
    }

    // Reset filters
    $('.filter-segment-items-option').removeClass('selected');

    segmentItemsContainer.scrollTop(0);
}

function applySegmentSort(value) {
    let segmentItemsContainer = $('#segment-items-container');
    let availableSegmentElements = segmentItemsContainer.find('.item-container:not(.locked)');
    let unavailableSegmentElements = segmentItemsContainer.find('.item-container.locked');

    // Get sort function and default sorting
    let sortClass = '';
    let sortFunction;
    if (value) {
        if (['hype-boost', 'popularity-boost', 'action', 'entertainment'].indexOf(value) >= 0) {
            sortFunction = function (a, b) {
                return (parseFloat($(b).attr('data-' + value)) - parseFloat($(a).attr('data-' + value))
                    || $(b).text().localeCompare($(a).text())
                );
            };
            sortClass = 'fa-sort-down'
        }
        else {
            sortFunction = function (a, b) {
                return (parseFloat($(a).attr('data-' + value)) - parseFloat($(b).attr('data-' + value))
                    || $(a).text().localeCompare($(b).text())
                );
            };
            sortClass = 'fa-sort-up';
        }
    }

    availableSegmentElements.sort(sortFunction);
    unavailableSegmentElements.sort(sortFunction);

    // Add sorted elements
    availableSegmentElements.toArray().forEach(function (e) {
        segmentItemsContainer.append(e);
    });
    unavailableSegmentElements.toArray().forEach(function (e) {
        segmentItemsContainer.append(e);
    });

    // Select default sort order
    if (sortClass) {
        let sortOrderElement = $('.segment-sort-order');
        let sortOrderIcon = sortOrderElement.find('i');
        sortOrderIcon.removeClass('fa-sort fa-sort-up fa-sort-down').addClass(sortClass);
        sortOrderElement.addClass('cursor-pointer');
    }

    segmentItemsContainer.scrollTop(0);
}

function runCustomPackagePreviewAnimation(name, startText, timer) {
    // Reset
    $('.custom-package-start-text-preview').text('').addClass('medium-dark-grey').removeClass('light-grey');
    $('.custom-package-action-text-preview').text('');
    $('.custom-package-name-preview').text('');

    // Generate text
    let actionTextInputs = $('.custom-package-action-text').filter(function () {
        return !!this.value;
    });
    let actionText = $(getRandomChoice(actionTextInputs)).val();
    let dataType = getRandomChoice(['he', 'she', 'tag']);
    startText = parseCustomPackageText(startText, dataType);
    actionText = parseCustomPackageText(actionText, dataType);

    $('.custom-package-name-preview').text(name);
    $('.custom-package-start-text-preview').text(startText).hide().fadeIn(500);
    timer = setTimeout(function () {
        $('.custom-package-action-text-preview').text(actionText).hide().fadeIn(500);
        $('.custom-package-start-text-preview').removeClass('medium-dark-grey').addClass('light-grey');
    }, 2200);
    return timer;
}

function parseCustomPackageText(text, dataType) {
    if (typeof(dataType) === 'undefined') dataType = 'he';
    if (dataType === 'he') {
        text = replaceAll(text, '{name}', 'Jimmy Boblsed');
        text = replaceAll(text, '{objective}', 'him');
        text = replaceAll(text, '{possessive}', 'his');
        text = replaceAll(text, '{pronoun}', 'he');
    }
    else if (dataType === 'she') {
        text = replaceAll(text, '{name}', 'Hoffing Holly');
        text = replaceAll(text, '{objective}', 'her');
        text = replaceAll(text, '{possessive}', 'her');
        text = replaceAll(text, '{pronoun}', 'she');
    }
    else if (dataType === 'tag') {
        text = replaceAll(text, '{name}', 'The Ugly Duo');
        text = replaceAll(text, '{objective}', 'them');
        text = replaceAll(text, '{possessive}', 'their');
        text = replaceAll(text, '{pronoun}', 'they');
    }
    return applySentenceCase(text);
}

function applySuperstarSort(value) {
    // Get containers
    let resultsContainer = $('#all-superstars');
    let rankContainers = $('#main-eventers, #upper-midcarders, #lower-midcarders, #jabroni');
    let retiredContainer = $('#retired');
    let notAvailableContainer = $('#not-available');
    let managersContainer = $('#managers');
    let allSuperstarsContainer = resultsContainer.add(rankContainers);

    // Sort search/filter results
    let superstarElements = resultsContainer.find('.superstar-select');
    // If viewing all superstars, sort all
    if (rankContainers.is(":visible")) {
        superstarElements = allSuperstarsContainer.find('.superstar-select');
    }
    let retiredElements = retiredContainer.find('.superstar-select');
    let notAvailableElements = notAvailableContainer.find('.superstar-select');
    let managerElements = managersContainer.find('.superstar-select');

    // Get sort function and default sorting
    let sortClass = '';
    let sortFunction;
    if (value === 'age') {
        sortFunction = function (a, b) {
            return (parseFloat($(a).attr('data-age')) - parseFloat($(b).attr('data-age'))
                || $(a).text().localeCompare($(b).text())
            );
        };
        sortClass = 'fa-sort-down';
    }
    else if (value === 'name') {
        sortFunction = function (a, b) {
            return $(a).text().localeCompare($(b).text());
        };
        sortClass = 'fa-sort-down';
    }
    else if (['workrate', 'charisma', 'overness'].indexOf(value) >= 0) {
        let dataName = value;
        sortFunction = function (a, b) {
            return (parseFloat($(b).attr('data-' + dataName)) - parseFloat($(a).attr('data-' + dataName))
                || $(a).text().localeCompare($(b).text())
            );
        };
        sortClass = 'fa-sort-up';
    }
    else if (['pop', 'morale'].indexOf(value) >= 0) {
        let dataName = (value === 'pop') ? 'popularity' : value;
        sortFunction = function (a, b) {
            return (parseFloat($(b).attr('data-' + dataName)) - parseFloat($(a).attr('data-' + dataName)));
        };
        sortClass = 'fa-sort-up';
    }
    else if (value === 'fatigue') {
        sortFunction = function (a, b) {
            return (parseFloat($(a).attr('data-fatigue')) - parseFloat($(b).attr('data-fatigue')));
        };
        sortClass = 'fa-sort-down';
    }

    superstarElements.sort(sortFunction);
    retiredElements.sort(sortFunction);
    notAvailableElements.sort(sortFunction);
    managerElements.sort(sortFunction);

    // Add sorted elements to results, hide ranks
    superstarElements.toArray().forEach(function (e) {
        resultsContainer.append(e);
    });
    retiredElements.toArray().forEach(function (e) {
        retiredContainer.append(e);
    });
    notAvailableElements.toArray().forEach(function (e) {
        notAvailableContainer.append(e);
    });
    managerElements.toArray().forEach(function (e) {
        managersContainer.append(e);
    });
    resultsContainer.show();
    rankContainers.hide();

    // Select default sort order
    if (sortClass) {
        let sortOrderElement = $('.superstar-sort-order');
        let sortOrderIcon = sortOrderElement.find('i');
        sortOrderIcon.removeClass('fa-sort fa-sort-up fa-sort-down').addClass(sortClass);
        sortOrderElement.addClass('cursor-pointer');
    }

    $('#booking-talent-container').scrollTop(0);
}

function applyTeamSort(value) {

    // Get containers
    let teamContainers = $('#tag-teams, #trios, #factions');

    // Sort search/filter results
    let sortedElements = teamContainers.find('.superstar-select');

    let sortClass = '';
    if (value === 'age') {
        sortedElements.sort(function (a, b) {
            return (parseFloat($(a).attr('data-age')) - parseFloat($(b).attr('data-age'))
                || $(a).text().localeCompare($(b).text())
            );
        });
        sortClass = 'fa-sort-down';
    }
    else if (value === 'name') {
        sortedElements.sort(function (a, b) {
            return $(a).text().localeCompare($(b).text());
        });
        sortClass = 'fa-sort-down';
    }
    else if (['workrate', 'charisma', 'overness'].indexOf(value) >= 0) {
        let dataName = value;
        sortedElements.sort(function (a, b) {
            return (parseFloat($(b).attr('data-' + dataName)) - parseFloat($(a).attr('data-' + dataName))
                || $(a).text().localeCompare($(b).text())
            );
        });
        sortClass = 'fa-sort-up';
    }
    else if (['pop', 'morale'].indexOf(value) >= 0) {
        let dataName = (value === 'pop') ? 'popularity' : value;
        sortedElements.sort(function (a, b) {
            return (parseFloat($(b).attr('data-' + dataName)) - parseFloat($(a).attr('data-' + dataName)));
        });
        sortClass = 'fa-sort-up';
    }
    else if (value === 'fatigue') {
        sortedElements.sort(function (a, b) {
            return (parseFloat($(a).attr('data-fatigue')) - parseFloat($(b).attr('data-fatigue')));
        });
        sortClass = 'fa-sort-down';
    }

    // Add teams to containers
    sortedElements.toArray().forEach(function (e) {
        let elementContainer = getRosterElementContainer($(e));
        elementContainer.append(e);
    });

    // Select default sort order
    if (sortClass) {
        let sortOrderElement = $('.superstar-sort-order');
        let sortOrderIcon = sortOrderElement.find('i');
        sortOrderIcon.removeClass('fa-sort fa-sort-up fa-sort-down').addClass(sortClass);
        sortOrderElement.addClass('cursor-pointer');
    }

    $('#booking-talent-container').scrollTop(0);
}

function getRosterElementContainer(element) {
    if (element.attr('data-type') === 'tag-team') {
        return $('#tag-teams')
    }
    else if (element.attr('data-type') === 'trio') {
        return $('#trios')
    }
    else if (element.attr('data-type') === 'faction') {
        return $('#factions')
    }
    else {
        let popularity = element.attr('data-popularity');
        if (popularity >= 800) {
            return $('#main-eventers')
        }
        else if (popularity >= 600) {
            return $('#upper-midcarders')
        }
        else if (popularity >= 400) {
            return $('#lower-midcarders')
        }
        else {
            return $('#jabroni')
        }
    }
}

function runSuperstarSearch() {

    let resultsContainer = $('#all-superstars');
    let rankContainers = $('#main-eventers, #upper-midcarders, #lower-midcarders, #jabroni');
    let allSuperstarsContainer = resultsContainer.add(rankContainers);
    let superstarElements = allSuperstarsContainer.find('.superstar-select');
    let searchTerm = $(".superstar-search-input").val();

    // Reset superstars to ranks, sorted
    superstarElements.sort(function (a, b) {
        return (parseFloat($(a).attr('data-default-order')) - parseFloat($(b).attr('data-default-order')));
    });
    superstarElements.toArray().forEach(function (e) {
        let elementContainer = getRosterElementContainer($(e));
        elementContainer.append(e);
    });

    // Show not available, retired, managers
    let notAvailableSelector = $('#not-available');
    let notAvailableElements = notAvailableSelector.find('.superstar-select');
    notAvailableElements.show();

    let retiredSelector = $('#retired');
    let retiredElements = retiredSelector.find('.superstar-select');
    retiredElements.show();

    let managersSelector = $('#managers');
    let managersElements = managersSelector.find('.superstar-select');
    managersElements.show();

    // Show headers if elements present
    if (notAvailableElements.length > 0) {
        notAvailableSelector.show()
    } else {
        notAvailableSelector.hide()
    }
    if (retiredElements.length > 0) {
        retiredSelector.show()
    } else {
        retiredSelector.hide()
    }
    if (managersElements.length > 0) {
        managersSelector.show()
    } else {
        managersSelector.hide()
    }

    // Run search
    if (searchTerm.length > 0) {
        let searchResults = runFuseElementsSearch(superstarElements, searchTerm, ['textContent']);
        // Show results if found
        if (searchResults.length > 0) {
            // Sort superstars by pop and add superstars to results, hide ranks
            searchResults.sort(function (a, b) {
                return (parseFloat($(a).attr('data-default-order')) - parseFloat($(b).attr('data-default-order')));
            });
            searchResults.forEach(function (e) {
                resultsContainer.append(e);
            });
            $('.no-superstar-search-results').hide();
        }
        else {
            if ($('.no-superstar-search-results').length > 0) {
                $('.no-superstar-search-results').show()
            }
            else {
                resultsContainer.append('<div class="no-superstar-search-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
        }
        resultsContainer.show();
        rankContainers.hide();

        // Filter results in not available, retired and managers
        let filteredNotAvailable = runFuseElementsSearch(notAvailableElements.toArray(), searchTerm, ['textContent']);
        let filteredRetired = runFuseElementsSearch(retiredElements.toArray(), searchTerm, ['textContent']);
        let filteredManagers = runFuseElementsSearch(managersElements.toArray(), searchTerm, ['textContent']);
        notAvailableElements.hide();
        retiredElements.hide();
        managersElements.hide();
        filteredNotAvailable.concat(filteredManagers, filteredRetired).forEach(function (e) {
            $(e).show()
        });
        // Show headers if any found
        if (filteredNotAvailable.length > 0) {
            notAvailableSelector.show()
        } else {
            notAvailableSelector.hide()
        }
        if (filteredRetired.length > 0) {
            retiredSelector.show()
        } else {
            retiredSelector.hide()
        }
        if (filteredManagers.length > 0) {
            managersSelector.show()
        } else {
            managersSelector.hide()
        }

        $('.superstar-sort-order').addClass('cursor-pointer');
    }
    else {
        // Show ranks if empty search term
        resultsContainer.hide();
        rankContainers.show();

        $('.superstar-sort-order').removeClass('cursor-pointer');
    }

    // Set sort select to popularity
    $('.superstar-sort').val('pop');
    let sortClass = (resultsContainer.is(":visible")) ? ('fa-sort-up') : 'fa-sort';
    $('.superstar-sort-order i').removeClass('fa-sort fa-sort-up fa-sort-down').addClass(sortClass);

    // Reset filters
    $('.superstar-filter').removeClass('selected');

    $('#booking-talent-container').scrollTop(0);
}

function runTeamSearch() {

    let tempContainer = $('#all-teams');
    let teamContainers = $('#tag-teams, #trios, #factions');
    let allTeamsContainer = tempContainer.add(teamContainers);
    let teamElements = allTeamsContainer.find('.superstar-select');
    let searchTerm = $(".superstar-search-input").val();

    // Move all teams to temp container
    teamElements.toArray().forEach(function (e) {
        tempContainer.append(e);
    });

    // Run search
    let sortClass;
    if (searchTerm.length > 0) {
        let searchResults = runFuseElementsSearch(teamElements, searchTerm, ['textContent']);
        if (searchResults.length > 0) {
            // Add search results to team containers
            searchResults.sort(function (a, b) {
                return (parseFloat($(a).attr('data-default-order')) - parseFloat($(b).attr('data-default-order')));
            });
            searchResults.forEach(function (e) {
                let elementContainer = getRosterElementContainer($(e));
                elementContainer.append(e);
            });
        }
        // Show no results found for tag teams, trios and factions
        if ($('#tag-teams').find('.superstar-select').length <= 0) {
            if ($('.no-tag-team-search-results').length > 0) {
                $('.no-tag-team-search-results').show()
            }
            else {
                $('#tag-teams').append('<div class="no-tag-team-search-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
            $('#tag-teams').find('.none-team-text').hide();
        }
        else {
            $('.no-tag-team-search-results').hide();
            $('#tag-teams').find('.none-team-text').show();
        }

        if ($('#trios').find('.superstar-select').length <= 0) {
            if ($('.no-trios-search-results').length > 0) {
                $('.no-trios-search-results').show()
            }
            else {
                $('#trios').append('<div class="no-trios-search-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
            $('#trios').find('.none-team-text').hide();
        }
        else {
            $('.no-trios-search-results').hide();
            $('#trios').find('.none-team-text').show();
        }

        if ($('#factions').find('.superstar-select').length <= 0) {
            if ($('.no-factions-search-results').length > 0) {
                $('.no-factions-search-results').show()
            }
            else {
                $('#factions').append('<div class="no-factions-search-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
            $('#factions').find('.none-team-text').hide();
        }
        else {
            $('.no-factions-search-results').hide();
            $('#factions').find('.none-team-text').show();
        }

        sortClass = 'fa-sort-up';
        $('.superstar-sort-order').addClass('cursor-pointer');
    }
    else {
        // Show all teams
        teamElements.sort(function (a, b) {
            return (parseFloat($(a).attr('data-default-order')) - parseFloat($(b).attr('data-default-order')));
        });
        teamElements.toArray().forEach(function (e) {
            let elementContainer = getRosterElementContainer($(e));
            elementContainer.append(e);
        });
        $('.no-tag-team-search-results').hide();
        $('.no-trios-search-results').hide();
        $('.no-factions-search-results').hide();
        $('.none-team-text').show();

        sortClass = 'fa-sort';
        $('.superstar-sort-order').removeClass('cursor-pointer');
    }

    // Set sort select to popularity
    $('.superstar-sort').val('pop');
    $('.superstar-sort-order i').removeClass('fa-sort fa-sort-up fa-sort-down').addClass(sortClass);

    // Reset filters
    $('.superstar-filter').removeClass('selected');

    $('#booking-talent-container').scrollTop(0);
}

function applySuperstarFilter(filterName, filterBrandName) {
    let resultsContainer = $('#all-superstars');
    let rankContainers = $('#main-eventers, #upper-midcarders, #lower-midcarders, #jabroni');
    let allSuperstarsContainer = resultsContainer.add(rankContainers);
    let superstarElements = allSuperstarsContainer.find('.superstar-select');

    // Reset superstars to ranks, sorted
    superstarElements.sort(function (a, b) {
        return (parseFloat($(a).attr('data-default-order')) - parseFloat($(b).attr('data-default-order')));
    });
    superstarElements.toArray().forEach(function (e) {
        let elementContainer = getRosterElementContainer($(e));
        elementContainer.append(e);
    });

    // Show not available, retired and managers
    let notAvailableSelector = $('#not-available');
    let notAvailableElements = notAvailableSelector.find('.superstar-select');
    notAvailableElements.show();

    let retiredSelector = $('#retired');
    let retiredElements = retiredSelector.find('.superstar-select');
    retiredElements.show();

    let managersSelector = $('#managers');
    let managersElements = managersSelector.find('.superstar-select');
    managersElements.show();

    // Show headers if elements present
    if (notAvailableElements.length > 0) {
        notAvailableSelector.show()
    } else {
        notAvailableSelector.hide()
    }
    if (retiredElements.length > 0) {
        retiredSelector.show()
    } else {
        retiredSelector.hide()
    }
    if (managersElements.length > 0) {
        managersSelector.show()
    } else {
        managersSelector.hide()
    }

    // Apply filter
    if (filterName) {
        let filterResults = getTalentFilterResults(superstarElements.toArray(), filterName, filterBrandName);
        // Show results if found
        if (filterResults.length > 0) {
            // Add superstars to results, hide ranks, sort by pop
            filterResults.sort(function (a, b) {
                return (parseFloat($(a).attr('data-default-order')) - parseFloat($(b).attr('data-default-order')));
            });
            filterResults.forEach(function (e) {
                resultsContainer.append(e);
            });
            $('.no-superstar-search-results').hide();
        }
        else {
            if ($('.no-superstar-search-results').length > 0) {
                $('.no-superstar-search-results').show()
            }
            else {
                resultsContainer.append('<div class="no-superstar-search-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
        }
        resultsContainer.show();
        rankContainers.hide();

        // Filter results in not available, retired and managers
        let filteredNotAvailable = getTalentFilterResults(notAvailableElements.toArray(), filterName, filterBrandName);
        let filteredRetired = getTalentFilterResults(retiredElements.toArray(), filterName, filterBrandName);
        let filteredManagers = getTalentFilterResults(managersElements.toArray(), filterName, filterBrandName);
        notAvailableElements.hide();
        retiredElements.hide();
        managersElements.hide();
        filteredNotAvailable.concat(filteredManagers, filteredRetired).forEach(function (e) {
            $(e).show()
        });
        // Show headers if any found
        if (filteredNotAvailable.length > 0) {
            notAvailableSelector.show()
        } else {
            notAvailableSelector.hide()
        }
        if (filteredRetired.length > 0) {
            retiredSelector.show()
        } else {
            retiredSelector.hide()
        }
        if (filteredManagers.length > 0) {
            managersSelector.show()
        } else {
            managersSelector.hide()
        }

        $('.superstar-sort-order').addClass('cursor-pointer');
    }
    else {
        // Show ranks if no filter
        resultsContainer.hide();
        rankContainers.show();

        $('.superstar-sort-order').removeClass('cursor-pointer');
    }

    // Set sort select to popularity
    $('.superstar-sort').val('pop');
    let sortClass = (resultsContainer.is(":visible")) ? ('fa-sort-up') : 'fa-sort';
    $('.superstar-sort-order i').removeClass('fa-sort fa-sort-up fa-sort-down').addClass(sortClass);

    // Reset search
    $(".superstar-search-input").val('');

    $('#booking-talent-container').scrollTop(0);
}

function applyTeamFilter(filterName, filterBrandName) {

    let tempContainer = $('#all-teams');
    let teamContainers = $('#tag-teams, #trios, #factions');
    let allTeamsContainer = tempContainer.add(teamContainers);
    let teamElements = allTeamsContainer.find('.superstar-select');

    // Move all teams to temp container
    teamElements.toArray().forEach(function (e) {
        tempContainer.append(e);
    });

    // Show not available
    let notAvailableSelector = $('#not-available');
    let notAvailableElements = notAvailableSelector.find('.superstar-select');
    notAvailableElements.show();

    // Show header if elements present
    if (notAvailableElements.length > 0) {
        notAvailableSelector.show()
    }
    else {
        notAvailableSelector.hide()
    }

    // Apply filter
    let sortClass;
    if (filterName) {
        let filterResults = getTalentFilterResults(teamElements.toArray(), filterName, filterBrandName);
        if (filterResults.length > 0) {
            // Add search results to team containers
            filterResults.sort(function (a, b) {
                return (parseFloat($(a).attr('data-default-order')) - parseFloat($(b).attr('data-default-order')));
            });
            filterResults.forEach(function (e) {
                let elementContainer = getRosterElementContainer($(e));
                elementContainer.append(e);
            });
        }
        // Show no results found for tag teams and trios
        if ($('#tag-teams').find('.superstar-select').length <= 0) {
            if ($('.no-tag-team-search-results').length > 0) {
                $('.no-tag-team-search-results').show();
            }
            else {
                $('#tag-teams').append('<div class="no-tag-team-search-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
            $('#tag-teams').find('.none-team-text').hide();
        }
        else {
            $('.no-tag-team-search-results').hide();
            $('#tag-teams').find('.none-team-text').show();
        }

        if ($('#trios').find('.superstar-select').length <= 0) {
            if ($('.no-trios-search-results').length > 0) {
                $('.no-trios-search-results').show();
            }
            else {
                $('#trios').append('<div class="no-trios-search-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
            $('#trios').find('.none-team-text').hide();
        }
        else {
            $('.no-trios-search-results').hide();
            $('#trios').find('.none-team-text').show();
        }

        if ($('#factions').find('.superstar-select').length <= 0) {
            if ($('.no-factions-search-results').length > 0) {
                $('.no-factions-search-results').show();
            }
            else {
                $('#factions').append('<div class="no-factions-search-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
            $('#factions').find('.none-team-text').hide();
        }
        else {
            $('.no-factions-search-results').hide();
            $('#factions').find('.none-team-text').show();
        }

        sortClass = 'fa-sort-up';

        // Filter results in not available
        let filteredNotAvailable = getTalentFilterResults(notAvailableElements.toArray(), filterName, filterBrandName);
        notAvailableElements.hide();
        filteredNotAvailable.forEach(function (e) {
            $(e).show()
        });
        // Show headers if any found
        if (filteredNotAvailable.length > 0) {
            notAvailableSelector.show()
        } else {
            notAvailableSelector.hide()
        }

        $('.superstar-sort-order').addClass('cursor-pointer');
    }
    else {
        // Show all teams
        teamElements.sort(function (a, b) {
            return (parseFloat($(a).attr('data-default-order')) - parseFloat($(b).attr('data-default-order')));
        });
        teamElements.toArray().forEach(function (e) {
            let elementContainer = getRosterElementContainer($(e));
            elementContainer.append(e);
        });
        $('.no-tag-team-search-results').hide();
        $('.no-trios-search-results').hide();
        $('.no-factions-search-results').hide();
        $('.none-team-text').show();
        sortClass = 'fa-sort';
        $('.superstar-sort-order').removeClass('cursor-pointer');
    }

    // Set sort select to popularity
    $('.superstar-sort').val('pop');
    $('.superstar-sort-order i').removeClass('fa-sort fa-sort-up fa-sort-down').addClass(sortClass);

    // Reset search
    $(".superstar-search-input").val('');

    $('#booking-talent-container').scrollTop(0);
}

function getTalentFilterResults(rosterElement, filterName, filterBrandName) {
    let elements;
    if (filterName === 'champion') {
        elements = rosterElement.filter(function (e) {
            return $(e).hasClass('champion');
        });
    }
    else if (filterName === 'part-time') {
        elements = rosterElement.filter(function (e) {
            return $(e).hasClass('part-timer');
        });
    }
    else if (filterName === 'unhappy') {
        elements = rosterElement.filter(function (e) {
            return $(e).hasClass('unhappy');
        });
    }
    else if (filterName === 'injured') {
        elements = rosterElement.filter(function (e) {
            return $(e).hasClass('injured');
        });
    }
    else if (filterName === 'he') {
        elements = rosterElement.filter(function (e) {
            return $(e).attr('data-pronoun') === 'he';
        });
    }
    else if (filterName === 'she') {
        elements = rosterElement.filter(function (e) {
            return $(e).attr('data-pronoun') === 'she';
        });
    }
    else if (filterName === 'they') {
        elements = rosterElement.filter(function (e) {
            return $(e).attr('data-pronoun') === 'they';
        });
    }
    else if (filterName === 'face') {
        elements = rosterElement.filter(function (e) {
            return $(e).attr('data-alignment') === 'face';
        });
    }
    else if (filterName === 'heel') {
        elements = rosterElement.filter(function (e) {
            return $(e).attr('data-alignment') === 'heel';
        });
    }
    else if (filterName === 'neutral') {
        elements = rosterElement.filter(function (e) {
            return $(e).attr('data-alignment') === 'null' || $(e).attr('data-alignment') === '';
        });
    }
    else if (filterName === 'no-brand') {
        elements = rosterElement.filter(function (e) {
            return $(e).attr('data-brand-name') === 'null';
        });
    }
    else if (filterName === 'custom-brand') {
        elements = rosterElement.filter(function (e) {
            return $(e).attr('data-brand-name') === filterBrandName;
        });
    }
    else if (filterName === 'not-booked') {
        elements = rosterElement.filter(function (e) {
            return !$(e).hasClass('booked');
        });
    }
    return elements;
}

async function showCreateCustomProductionPackageData({data} = {}) {
    if (!data['error']) {
        notie.alert({
            type: 4,
            text: '<span class="faded-purple">' + data['name'] + '</span> added!',
            stay: true
        });

        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        let scrollFunction = function () {
            // Scroll to this segment item
            let $container = $('#segment-items-container'),
                $scrollTo = $('.segment-item-container').filter(function () {
                    return $(this).find('.segment-item-name').text() === data['name']
                });
            $container.scrollTop(
                $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
            );
            // Highlight segment item
            setTimeout(function () {
                $scrollTo.addClass("flash-border-red");
            }, 0);
            setTimeout(function () {
                $scrollTo.removeClass("flash-border-red");
            }, 1500);
        };

        // Reload segment items, pass scrollFunction as callback
        await makeGameRequest(getAvailableSegmentItems, {}, showGetAvailableSegmentItemsData,
            {callbackFunction: scrollFunction}, false, true);
    }
    else {
        if (data['error'] === 'level') {
            notie.alert({
                type: 3, text: "You need to have an Advanced (Level 3) Production Facility and a " +
                    "Level 3 Producer to create a Custom Package."
            });
        } else if (data['error'] === 'points') {
            notie.alert({
                type: 3, text: 'You do not have enough Creative Points to add a Custom Package'
            });
        } else if (data['error'] === 'name-exists') {
            notie.alert({
                type: 3, text: 'A Custom Package with that name already exists'
            });
        }
    }
}

async function showManagerSegmentInputs(segmentElement, participantElement) {
    let managerUid = parseInt(participantElement.attr('data-uid'));
    let segmentConsequence = segmentElement.attr('data-consequence');
    let managingMultipleTalent = participantElement.attr('data-managing-multiple-talent');

    // Remove manager input container
    segmentElement.find('.segment-item-manager-inputs').fadeOut('fast').remove();

    // Add manager input container
    segmentElement.append('<div class="segment-item-manager-inputs light-grey margin-top-5"></div>');
    segmentElement.find('.segment-item-manager-inputs').hide();

    // Add managed talent select input if managing multiple talent
    if (['boost-managed-talent', 'remove-managed-talent'].indexOf(segmentConsequence) >= 0 && managingMultipleTalent) {
        await makeGameRequest(getManagedTalentForManager, {managerUid}, showGetManagedTalentForManagerData,
            {segmentElement}, false, true);
    }
    // Add manager select input
    if (['add-manager'].indexOf(segmentConsequence) >= 0) {
        await makeGameRequest(getAddManagerRelationshipData, {checkBrandExclusivity: true},
            showGetAddManagerRelationshipsSelectionsData, {segmentElement}, false, true);
    }
}

function showGetManagedTalentForManagerData({data, segmentElement} = {}) {
    // Add talent select if more than 1 managed talent
    if (data['managedTalent'].length > 1) {

        // Add options
        let optionsHtml = '<option disabled selected value>Select Talent</option>';
        data['managedTalent'].forEach(function (managedTalent) {
            optionsHtml += '<option value="' + managedTalent['uid'] + '">' + managedTalent['name'] + '</option>'
        });

        // Add talent input html to end of segment item
        let talentInputsHtml =
            '<div class="margin-bottom-6 margin-top-8">' +
            '<div class="display-block margin-bottom-2 font-13px">Talent</div>' +
            '<select name="select-managed-talent" class="select-managed-talent styled-select">' + optionsHtml + '</select>' +
            '</div>';

        segmentElement.find('.segment-item-manager-inputs').append(talentInputsHtml);
        segmentElement.find('.segment-item-manager-inputs').fadeIn('fast');
    }
}

function showGetAddManagerRelationshipsSelectionsData({data, segmentElement} = {}) {
    // Put full time managers and superstars into optgroups
    let optionsHtml = '';
    optionsHtml += '<option selected disabled value>Select Manager</option>';
    let fullTimeManagersOptions = '';
    let superstarsOptions = '';
    data['managerSelections'].forEach(function (manager) {
        let managerOptionHtml = '<option value="' + manager['uid'] + '">' + manager['name'] + '</option>';
        if (manager['fullTimeManager']) {
            fullTimeManagersOptions += managerOptionHtml
        }
        else {
            superstarsOptions += managerOptionHtml
        }
    });
    optionsHtml += '<optgroup label="Full-time Managers">' + fullTimeManagersOptions + '</optgroup>';
    optionsHtml += '<optgroup label="Superstars">' + superstarsOptions + '</optgroup>';

    // Add manager input html to end of segment item
    let managerInputsHtml =
        '<div class="margin-bottom-6 margin-top-8">' +
        '<div class="display-block margin-bottom-2 font-13px">Manager</div>' +
        '<select name="select-manager" class="select-manager styled-select">' + optionsHtml + '</select>' +
        '</div>';

    segmentElement.find('.segment-item-manager-inputs').append(managerInputsHtml);
    segmentElement.find('.segment-item-manager-inputs').fadeIn('fast');
}

async function showBrandSegmentInputs(segmentElement) {
    let segmentConsequence = segmentElement.attr('data-consequence');

    // Remove brand input container
    segmentElement.find('.segment-item-brand-inputs').fadeOut('fast').remove();

    // Add brand input container
    segmentElement.append('<div class="segment-item-brand-inputs light-grey margin-top-5"></div>');
    segmentElement.find('.segment-item-brand-inputs').hide();

    // Add brand select input
    if (['draft-talent-to-brand'].indexOf(segmentConsequence) >= 0) {
        await makeGameRequest(getBrandsDataForSegment, {},
            showGetBrandsDataForSegmentData, {segmentElement}, false, true);
    }
}

function showGetBrandsDataForSegmentData({data, segmentElement} = {}) {
    // Add brand options
    let brandOptionsHtml = '<option selected disabled value>Select Brand</option>';
    data['brands'].forEach(function (brand) {
        brandOptionsHtml += '<option value="' + brand['uid'] + '">' + brand['name'] + '</option>'
    });

    // Add talent options
    let talentOptionsHtml = '<option selected disabled value>Select Talent</option>';
    data['talent'].forEach(function (talent) {
        talentOptionsHtml += '<option value="' + talent['uid'] + '" data-type="' + talent['type'] + '">' + talent['name'] + '</option>'
    });

    // Add brand input html to end of segment item
    let brandInputsHtml =
        '<div class="margin-bottom-6 margin-top-8">' +
        '<div class="display-block margin-bottom-2 font-13px">Brand</div>' +
        '<select name="select-brand" class="select-brand styled-select">' + brandOptionsHtml + '</select>' +
        '</div>' +
        '<div class="margin-bottom-6">' +
            '<div class="display-block margin-bottom-2 font-13px">Talent</div>' +
            '<select name="select-brand-talent" class="select-brand-talent styled-select">' + talentOptionsHtml + '</select>' +
        '</div>';

    segmentElement.find('.segment-item-brand-inputs').append(brandInputsHtml);
    segmentElement.find('.segment-item-brand-inputs').fadeIn('fast');
}

async function showOtherSegmentInputs(segmentElement, participantElement) {
    let segmentConsequence = segmentElement.attr('data-consequence');
    let participantUid = parseInt(participantElement.attr('data-uid'));
    let participantType = participantElement.attr('data-type');

    // Reset other inputs container
    segmentElement.find('.segment-item-other-inputs').fadeOut('fast').remove();
    segmentElement.append('<div class="segment-item-other-inputs light-grey margin-top-5"></div>');
    segmentElement.find('.segment-item-other-inputs').hide();

    // Add months select
    if (['loser-unavailable', 'make-unavailable'].indexOf(segmentConsequence) >= 0) {
        let inputHtml =
            '<div class="margin-bottom-6 margin-top-8">' +
                '<div class="display-block margin-bottom-2 font-13px">Months Unavailable</div>' +
                '<select name="segment-item-unavailable-months" class="segment-item-input styled-select">' +
                '<option>2</option>' +
                '<option selected>3</option>' +
                '<option>4</option>' +
                '<option>5</option>' +
                '<option>6</option>' +
                '</select>' +
            '</div>';

        segmentElement.find('.segment-item-other-inputs').append(inputHtml);
        segmentElement.find('.segment-item-other-inputs').fadeIn('fast');
    }
    // Add name input
    else if (['create-team', 'create-trio-of-heels', 'remove-tag-team-and-create-tag-team', 'create-tag-team-and-blowoff',
        'unify-titles', 'split-title'].indexOf(segmentConsequence) >= 0) {
        let nameWord = 'Name';
        let helpClass = '';
        let titleAttribute = '';
        if (['create-team', 'create-trio-of-heels', 'remove-tag-team-and-create-tag-team',
            'create-tag-team-and-blowoff'].indexOf(segmentConsequence) >= 0) {
            nameWord = 'New Team Name'
        }
        if (['unify-titles', 'split-title'].indexOf(segmentConsequence) >= 0) {
            nameWord = 'New Title Name';
            helpClass = ' help-text';
            titleAttribute = ' title="Enter the name of the championship e.g \'World\' without the word \'Championship\' or \'Title\'."'
        }

        let inputHtml =
           '<div class="margin-bottom-8 margin-top-8">' +
            '<div class="display-block margin-bottom-2 font-13px">' + nameWord + '</div>' +
            '<input type="text" name="segment-item-object-name" class="segment-item-input styled-input' +
            helpClass + '"' + titleAttribute + '>' +
            '</div>';

        segmentElement.find('.segment-item-other-inputs').append(inputHtml);
        segmentElement.find('.segment-item-other-inputs').fadeIn('fast');
    }
    // Add competitor select
    else if (segmentElement.attr('data-name') === 'Slander Competitor') {
        await makeGameRequest(getSegmentInputsData, {inputType: 'competitors'}, showGetSegmentInputsData,
            {segmentElement}, false, true);
    }
    // Add feud select
    else if (segmentElement.attr('data-requirement') === 'feud-present') {
        await makeGameRequest(getSegmentInputsData, {participantUid: participantUid, participantType: participantType,
                inputType: 'participant-feuds'}, showGetSegmentInputsData, {segmentElement}, false, true);
    }
    // Add championship select
    else if (['vacate-title', 'award-title'].indexOf(segmentConsequence) >= 0) {
        let inputType;
        if (segmentConsequence === 'award-title') {
            inputType = 'vacant-championships'
        }
        else if (segmentConsequence === 'vacate-title') {
            inputType = 'participant-championships'
        }
        await makeGameRequest(getSegmentInputsData, {participantUid: participantUid, participantType: participantType,
            inputType: inputType}, showGetSegmentInputsData, {segmentElement}, false, true);
    }
    // Add segment/match select
    else if (segmentConsequence === 'boost-popularity') {
        await makeGameRequest(getSegmentInputsData, {inputType: 'segments-and-matches'}, showGetSegmentInputsData,
            {segmentElement}, false, true);
    }
}

function showGetSegmentInputsData({data, segmentElement} = {}) {
    if (data['competitors'] && data['competitors'].length > 0) {
        // Add options
        let optionsHtml = '';
        data['competitors'].forEach(function (competitor) {
            optionsHtml += '<option value="' + competitor['uid'] + '">' + competitor['name'] + '</option>'
        });

        let inputHtml =
            '<div class="margin-bottom-6 margin-top-8">' +
            '<div class="display-block margin-bottom-2 font-13px">Competitor</div>' +
            '<select name="segment-item-competitor" class="segment-item-input styled-select">' +
            optionsHtml +
            '</select>' +
            '</div>';

        segmentElement.find('.segment-item-other-inputs').append(inputHtml);
        segmentElement.find('.segment-item-other-inputs').fadeIn('fast');
    }
    if (data['feuds'] && data['feuds'].length > 0) {
        let optionsHtml = '';
        data['feuds'].forEach(function (feud) {
            optionsHtml += '<option value="' + feud['uid'] + '">' + feud['opponents'] +
                ' - ' + feud['name'] + '</option>'
        });

        let inputHtml =
            '<div class="margin-bottom-6 margin-top-8">' +
            '<div class="display-block margin-bottom-2 font-13px">Feud</div>' +
            '<select name="segment-item-feud" class="segment-item-input styled-select">' +
            optionsHtml +
            '</select>' +
            '</div>';

        segmentElement.find('.segment-item-other-inputs').append(inputHtml);
        segmentElement.find('.segment-item-other-inputs').fadeIn('fast');
    }
    if (data['championships'] && data['championships'].length > 0) {
        let optionsHtml = '';
        data['championships'].forEach(function (championship) {
            optionsHtml += '<option value="' + championship['uid'] + '">' + championship['name'] + '</option>'
        });

        let inputHtml =
            '<div class="margin-bottom-6 margin-top-8">' +
            '<div class="display-block margin-bottom-2 font-13px">Championship</div>' +
            '<select name="segment-item-championship" class="segment-item-input styled-select">' +
            optionsHtml +
            '</select>' +
            '</div>';

        segmentElement.find('.segment-item-other-inputs').append(inputHtml);
        segmentElement.find('.segment-item-other-inputs').fadeIn('fast');
    }
    if (data['segmentsAndMatches'] && data['segmentsAndMatches'].length > 0) {
        let optionsHtml = '';
        data['segmentsAndMatches'].forEach(function (object) {
            optionsHtml += '<option value="' + object['uid'] + '" data-type="' + object['type'] + '">' + object['name'] + '</option>'
        });

        let inputHtml =
            '<div class="margin-bottom-6 margin-top-8">' +
            '<div class="display-block margin-bottom-2 font-13px">Match Or Segment</div>' +
            '<select name="segment-item-match-or-segment" class="segment-item-input styled-select">' +
            optionsHtml +
            '</select>' +
            '</div>';

        segmentElement.find('.segment-item-other-inputs').append(inputHtml);
        segmentElement.find('.segment-item-other-inputs').fadeIn('fast');
    }
}

async function showFactionSegmentInputs(segmentElement, participantElement) {
    let factionUid = parseInt(participantElement.attr('data-uid'));
    let segmentConsequence = segmentElement.attr('data-consequence');

    // Remove faction input
    segmentElement.find('.segment-item-faction-inputs').fadeOut('fast').remove();

    // Add faction input container
    segmentElement.append('<div class="segment-item-faction-inputs light-grey margin-top-5"></div>');
    segmentElement.find('.segment-item-faction-inputs').hide();

    // Add faction superstar select input
    if (['remove-faction-members', 'add-faction-members', 'add-faction-leader', 'change-faction-leader',
        'kick-out-faction-leader-and-change-leader', 'leave-faction-and-join-other-faction',
        'split-faction'].indexOf(segmentConsequence) >= 0) {
        // Get function and data key
        let getFunction;
        let dataKey;
        let checkBrandExclusivity;
        let excludeFactionSuperstars;
        if (['remove-faction-members', 'change-faction-leader',
            'kick-out-faction-leader-and-change-leader', 'leave-faction-and-join-other-faction',
            'split-faction'].indexOf(segmentConsequence) >= 0) {
            getFunction = getFactionSuperstarsRequest;
            dataKey = 'factionSuperstars';
        } else if (segmentConsequence === 'add-faction-members') {
            getFunction = getSuperstarsAvailableForFaction;
            checkBrandExclusivity = true;
            dataKey = 'availableSuperstars';
        } else if (segmentConsequence === 'add-faction-leader') {
            getFunction = getSuperstarsAvailableForFaction;
            checkBrandExclusivity = true;
            excludeFactionSuperstars = true;
            dataKey = 'availableSuperstars';
        }
        await makeGameRequest(getFunction, {factionUid, checkBrandExclusivity: checkBrandExclusivity,
                excludeFactionSuperstars: excludeFactionSuperstars}, showGetFactionSuperstarsData,
            {segmentElement, dataKey, segmentConsequence}, false, true);
    }

    // Add faction select input
    if (['leave-faction-and-join-other-faction', 'merge-factions'].indexOf(segmentConsequence) >= 0) {
        await makeGameRequest(getCompanyFactionsForSelection, {}, showGetCompanyFactionsForSelectionData,
            {segmentElement}, false, true);
    }

    // Add faction name input
    if (['merge-factions', 'split-faction'].indexOf(segmentConsequence) >= 0) {
        // Add faction input html to end of segment item
        let factionInputsHtml =
            '<div class="margin-bottom-6 margin-top-8">' +
            '<div class="display-block margin-bottom-2 font-13px">Faction Name</div>' +
            '<input type="text" name="segment-item-faction-name" class="segment-item-faction-name styled-input">' +
            '</div>';
        segmentElement.find('.segment-item-faction-inputs').append(factionInputsHtml);
        segmentElement.find('.segment-item-faction-inputs').fadeIn('fast');
    }

    // Add faction inputs
    if (segmentConsequence === 'create-faction') {
        // Add faction name input
        let factionNameInputHtml =
            '<div class="margin-bottom-8 margin-top-8">' +
            '<div class="display-block margin-bottom-2 font-13px">Faction Name</div>' +
            '<input type="text" name="segment-item-faction-name" class="segment-item-faction-name styled-input">' +
            '</div>';
        segmentElement.find('.segment-item-faction-inputs').append(factionNameInputHtml);

        // Add faction member select inputs
        await makeGameRequest(getSuperstarsAvailableForFaction, {checkBrandExclusivity: true},
            showGetSuperstarsAvailableForFactionData, {segmentElement}, false, true);
    }
}

function showGetFactionSuperstarsData({data, segmentElement, dataKey, segmentConsequence} = {}) {
    // Add options
    let optionsHtml = '<option disabled selected value>Select Member</option>';
    data[dataKey].forEach(function (factionSuperstar) {
        optionsHtml += '<option value="' + factionSuperstar['uid'] + '">' + factionSuperstar['name'] + '</option>'
    });

    // Don't show add select button if selecting faction leader
    let addFactionMemberSelectButton = '<button type="button" class="add-faction-member-select-button button retro-button ' +
        'font-bold styled-select-button">' +
        '<i class="fa fa-plus"></i>' +
        '</button>';
    if (['change-faction-leader', 'kick-out-faction-leader-and-change-leader',
        'add-faction-leader'].indexOf(segmentConsequence) >= 0) {
        addFactionMemberSelectButton = '';
    }

    // Add faction input html to end of segment item
    let factionInputsHtml =
        '<div class="margin-bottom-6">' +
        '<div class="display-block margin-bottom-2 font-13px">Select Member(s) For Consequence</div>' +
        '<select name="select-faction-member" class="select-faction-member styled-select">' + optionsHtml + '</select>' +
        '</div>' +
        '<div>' +
        addFactionMemberSelectButton +
        '</div>';
    segmentElement.find('.segment-item-faction-inputs').prepend(factionInputsHtml);
    segmentElement.find('.segment-item-faction-inputs').fadeIn('fast');
}

function showGetCompanyFactionsForSelectionData({data, segmentElement} = {}) {
    // Add options
    let optionsHtml = '';
    data['factions'].forEach(function (faction) {
        optionsHtml += '<option value="' + faction['uid'] + '">' + faction['name'] + '</option>'
    });

    // Add faction input html to end of segment item
    let factionInputsHtml =
        '<div class="margin-bottom-6 margin-top-8">' +
        '<div class="display-block margin-bottom-2 font-13px">Select Faction For Consequence</div>' +
        '<select name="select-faction" class="select-faction styled-select">' + optionsHtml + '</select>' +
        '</div>';
    segmentElement.find('.segment-item-faction-inputs').append(factionInputsHtml);
    segmentElement.find('.segment-item-faction-inputs').fadeIn('fast');
}

function showGetSuperstarsAvailableForFactionData({data, segmentElement} = {}) {
    // Add options
    let optionsHtml = '';
    data['availableSuperstars'].forEach(function (factionSuperstar) {
        optionsHtml += '<option value="' + factionSuperstar['uid'] + '">' + factionSuperstar['name'] + '</option>'
    });

    // Add faction member and leader selects
    let factionSelectsHtml =
        '<div class="margin-bottom-6">' +
            '<div class="display-block margin-bottom-2 font-13px">Select Faction Members</div>' +
            '<select name="select-faction-member" class="select-faction-member styled-select">' + optionsHtml + '</select>' +
        '</div>' +
        '<div class="margin-bottom-6">' +
            '<select name="select-faction-member" class="select-faction-member styled-select">' + optionsHtml + '</select>' +
        '</div>' +
        '<div>' +
        '<button type="button" class="add-faction-member-select-button button retro-button font-bold styled-select-button">' +
        '<i class="fa fa-plus"></i>' +
        '</button>' +
        '</div>' +
        '<div class="margin-top-8">' +
            '<div class="display-block margin-bottom-2 font-13px">Select Faction Leader</div>' +
            '<select name="select-faction-leader" class="select-faction-leader styled-select"></select>' +
        '</div>';
    segmentElement.find('.segment-item-faction-inputs').append(factionSelectsHtml);
    segmentElement.find('.segment-item-faction-inputs').fadeIn('fast');

    // Select second option for second faction member select
    segmentElement.find('.select-faction-member').eq(1).find(":selected").next().prop('selected', true);

    updateFactionLeaderSelect(segmentElement);
}

function showGetBookingSelectionInformationData({data} = {}) {
    let parent = $('#booking-talent-container');

    if (data['feudsData']) {
        data['feudsData'].forEach(function (feud) {

            let feudHype;
            let feudBorderClass;
            // Potential feud
            if (!feud['started'] && !feud['ended']) {
                feudBorderClass = 'potential-feud';
                feudHype = '<span class="margin-left-8 potential-feud-red superstar-select-feud-details">' +
                    '<i class="fa fa-bolt margin-right-5"></i>' + Math.round(feud['hype']) + '</span>';
            }
            // Previous feud. Don't add border, add positive or negative hype boost indication
            else if (feud['previousFeudBoost'] !== undefined) {
                if (feud['previousFeudBoost'] > 0) {
                    feudHype = '<span class="margin-left-8 hot-color superstar-select-feud-details">' +
                        '<i class="fa fa-bolt margin-right-5"></i><i class="fa fa-angle-double-up marign-left-5"></i></span>';
                    feudBorderClass = '';
                } else {
                    feudHype = '<span class="margin-left-8 stale-color superstar-select-feud-details">' +
                        '<i class="fa fa-bolt margin-right-5"></i><i class="fa fa-angle-double-down marign-left-5"></i></span>';
                    feudBorderClass = '';
                }
            }
            // Current feud
            else {
                feudBorderClass = 'current-feud';
                feudHype = '<span class="margin-left-8 faded-red-light superstar-select-feud-details">' +
                    '<i class="fa fa-bolt margin-right-5"></i>' + Math.round(feud['hype']) + '</span>';
            }

            feud['participants'].forEach(function (participant) {
                let elementsFound = parent.find('.superstar-select:not(.selected)')
                    .filter(function () {
                        return $(this).data("name") === participant;
                    });
                elementsFound.addClass(feudBorderClass);
                elementsFound.append(feudHype);
            });
        });
    }

    if (data['partnerSuperstars']) {
        data['partnerSuperstars'].forEach(function (participant) {
            let elementsFound = parent.find('.superstar-select:not(.selected)')
                .filter(function () {
                    return $(this).data("name") === participant;
                });
            elementsFound.addClass('partner-superstar');
        });
    }
}

function showGetFeudSegmentsInformationData({data} = {}) {
    data['feudSegmentNames'].forEach(function (segmentItem) {
        let alreadyHeld = '<div class="dark-grey segment-booking-already-held">Already Held</div>';
        let element = $('.segment-item-name').filter(function () {
            return $(this).text() === segmentItem;
        });
        let segmentItemContainer = element.closest('.segment-item-container');
        segmentItemContainer.find('.column-right.segment-item-information').children('div').append(alreadyHeld);
        segmentItemContainer.addClass('already-held');
    });

    data['unavailableSegments'].forEach(function (segmentItem) {
        let alreadyHeld = '<div class="dark-grey segment-booking-unavailable">Unavailable</div>';
        let element = $('.segment-item-name').filter(function () {
            return $(this).text() === segmentItem;
        });
        let segmentItemContainer = element.closest('.segment-item-container');
        segmentItemContainer.find('.column-right.segment-item-information').children('div').append(alreadyHeld);
        segmentItemContainer.addClass('unavailable');
    });

    // If 'available' segment filter selected, get available segments again (as they are changed by feud selection)
    if ($('.filter-segment-items-option[data-value="available"].selected').length > 0) {
        showAvailableSegmentItems()
    }
}

function showAvailableSegmentItems() {
    let segmentItemsContainer = $('#segment-items-container');
    let segmentElements = segmentItemsContainer.find('.item-container');
    segmentElements.each(function (i, e) {
        if ($(e).hasClass('unavailable') || $(e).hasClass('locked')) {
            $(e).hide();
        }
        else {
            $(e).show();
        }
    });
}

function showBookSegmentData({data} = {}) {
    if (!data['error']) {
        let notieText = '';

        segmentParticipants = [];

        // Show consequence applied to
        if (data['segment']['consequenceAppliedTo'] && data['segment']['participants'].length > 2) {
            let consequenceText = '<span class="display-block"><span class="faded-red-light">' +
                toTitleCase(data['segment']['consequence'].replace(/-/g, ' ')) + '</span> Consequence applied to ' +
                data['segment']['consequenceAppliedTo'] + '</span>';
            notieText += '<span class="display-block">Segment Added' + consequenceText + '</span>';
        } else {
            notieText += '<span class="display-block">Segment Added</span>';
        }

        // Reset segment containers
        let selected = $('.segment-item-container.selected');
        $('.segment-participants').text('No participants selected');
        $('.segment-item-selected').text('No Segment Item selected');
        $('.segment-participants').removeClass('faded-red-light');
        $('.segment-item-selected').removeClass('faded-purple');
        selected.removeClass('selected');
        $('.segment-search-input').val('');
        $(".feud-container").show().removeClass('selected');

        // Reset singles/tag
        $('#booking-talent-container.segments-selection .superstar-select.selected').removeClass('selected');

        // Remove already held indication
        $('.segment-booking-already-held').remove();
        $('.segment-item-container.already-held').removeClass('already-held');

        // Remove unavailable indication
        $('.segment-booking-unavailable').remove();
        $('.segment-item-container.unavailable').removeClass('unavailable');

        // Remove faction/manager/brand/other inputs
        selected.find('.segment-item-faction-inputs').remove();
        selected.find('.segment-item-manager-inputs').remove();
        selected.find('.segment-item-brand-inputs').remove();
        selected.find('.segment-item-other-inputs').remove();

        // Uncheck 'Add Producer Focus', hide producer select
        $('#booking-container').find('input[value="add_segment_producer_focus"]').prop('checked', false);
        $('#booking-container').find('.add-segment-producer-select').hide();

        // Add segment to event card
        let index;
        if ($("#matches").text() === 'No matches or segments booked') {
            index = 0
        }
        let segmentHtml = getEventCardSegmentHtml(data['segment'], index);
        $('#matches').append(segmentHtml);

        // Update match limits
        let matchLimitsHtml = getMatchLimitsHtml();
        $('#match-limits').html(matchLimitsHtml);

        // Show notifications
        if (notieText) {
            notie.alert({type: 4, text: notieText});
        }

        // Tutorial action check
        if (data['nextTutorialState']) {
            globals.game.tutorialState = data['nextTutorialState']
        }

        // Tutorial action check
        checkTutorialStepAction('add_segment');
    } else {
        if (data['error'] === 'match-and-segment-limit') {
            notie.alert({
                type: 3,
                text: "You can't book more than " + data['limit'] + " Matches/Segments at this Event"
            });
        } else if (data['error'] === 'monthly-event-segment-limit') {
            notie.alert({
                type: 3,
                text: "You can't book more than " + data['limit'] + " Segments at Monthly Events"
            });
        } else if (data['error'] === 'max-participants') {
            let participantsText = 'Participant';
            if (data['maxParticipants'] !== 1) {
                participantsText = 'Participants'
            }
            let errorText = "You can't book more than " + data['maxParticipants'] + " " + participantsText + " in this Segment";
            if (data['maxParticipants'] === 0) {
                errorText += ". Try unselecting Participants in the booking section."
            }
            notie.alert({
                type: 3,
                text: errorText
            });
        } else if (data['error'] === 'min-participants') {
            let participantsText = 'Participant';
            if (data['minParticipants'] !== 1) {
                participantsText = 'Participants'
            }
            notie.alert({
                type: 3,
                text: "You need at least " + data['minParticipants'] + " " + participantsText + " in this Segment"
            });
        } else if (data['error'] === 'max-segments') {
            notie.alert({
                type: 3,
                text: "You can't book a Roster Member in more than 2 Segments at this Event"
            });
        } else if (data['error'] === 'feud-only') {
            notie.alert({
                type: 3,
                text: "This Segment can only be used with an existing Feud"
            });
        } else if (data['error'] === 'production-packages-only') {
            notie.alert({
                type: 3,
                text: "You can only book Production Segments at this Event"
            });
        } else if (data['error'] === 'already-used') {
            let monthsWord = getMonthsWord(data['monthsToReuse']);
            notie.alert({
                type: 3,
                text: "Special Segments can only be used once every 3 years. This segment can be re-used in {0} {1}.".format(data['monthsToReuse'], monthsWord)
            });
        } else if (data['error'] === 'special-segments-not-paid') {
            notie.alert({
                type: 3,
                text: "Special Segments can only be used in JoW Paid"
            });
        } else if (data['error'] === 'producer-focus-not-paid') {
            notie.alert({
                type: 3,
                text: "Producers can only be assigned to Segments in JoW Paid."
            });
        } else if (data['error'] === 'locked-segment-item') {
            notie.alert({
                type: 3,
                text: "This Segment is locked"
            });
        } else if (data['error'] === 'superstars-only') {
            notie.alert({
                type: 3,
                text: "Special Segments can only be used on singles Superstars"
            });
        } else if (data['error'] === 'retired') {
            notie.alert({
                type: 3,
                text: "Retired Superstars can only be booked in Legends, Retired and Manager Segments or " +
                    "as part of a Faction"
            });
        } else if (data['error'] === 'manager') {
            notie.alert({
                type: 3,
                text: "Managers cannot be added to Teams"
            });
        } else if (data['error'] === 'superstar-not-available') {
            notie.alert({
                type: 3,
                text: data['superstarName'] + " is not available to be booked at this Event"
            });
        } else if (data['error'] === 'requirement-fail') {
            let participantsType = $('.book-segment-option.selected').text();
            let participantName = (participantsType !== 'Feuds') ? participantsType : '';
            let errorText;
            if (data['alreadyHeld']) {
                errorText = "This Segment has already been held before";
            } else {
                switch (data['requirement']) {
                    case 'title-feud':
                        errorText = "Participants need to be involved in a Title Feud (New Challenger, Better Champion etc)";
                        break;
                    case 'team-superstars':
                        errorText = "All Participants need to be Singles Superstars and be in a Team together";
                        break;
                    case 'champion':
                        if (participantName === 'Factions') {
                            errorText = 'This segment can only be used with Superstars and Teams';
                        }
                        else {
                            errorText = "Participant needs to be a " + participantName + " champion";
                        }
                        break;
                    case 'new-champion':
                        if (participantName === 'Factions') {
                            errorText = 'This segment can only be used with Superstars and Teams';
                        }
                        else {
                            errorText = "Participant needs to have won a " + participantName + " championship in the last 2 months";
                        }
                        break;
                    case 'previous-feuds':
                        errorText = "Participants need to be involved in one or more previous Feuds";
                        break;
                    case 'new-talent':
                        errorText = "A participant who is a recent signing, callup, trade or custom Superstar needs to be present";
                        break;
                    case 'contract-and-champion':
                        if (participantName === 'Factions') {
                            errorText = 'This segment can only be used with Superstars and Teams';
                        }
                        else {
                            errorText = "One Participant needs to hold a cash-in contract and another needs to be a " +
                                participantName + " champion";
                        }
                        break;
                    case 'legend':
                        errorText = "One Participant needs to be a retired Hall of Famer";
                        break;
                    case 'vacant-title':
                        if (participantName === 'Factions') {
                            errorText = 'This segment can only be used with Superstars and Teams';
                        }
                        else {
                            errorText = "A Vacant " + participantName + " Title needs to be present and not booked in a Match";
                        }
                        break;
                    case 'heel':
                        errorText = "Participant needs to have 'Heel' Alignment";
                        break;
                    case 'face':
                        errorText = "Participant needs to have 'Face' Alignment";
                        break;
                    case 'neutral':
                        errorText = "Participant needs to have 'Neutral' Alignment";
                        break;
                    case 'face-vs-heel':
                        errorText = "One Participant needs to have 'Face' Alignment and the other needs to have 'Heel' Alignment";
                        break;
                    case 'face-vs-face':
                        errorText = "Both Participants need to have 'Face' Alignment";
                        break;
                    case 'face-team-superstars':
                        errorText = "All Participants need to have 'Face' Alignment and be in a Team together";
                        break;
                    case 'heel-team-superstars':
                        errorText = "All Participants need to have 'Heel' Alignment and be in a Team together";
                        break;
                    case 'face-vs-face-past-feud':
                        errorText = "Both Participants need to have 'Face' Alignment and have been in a past Feud against each other";
                        break;
                    case 'face-vs-heel-past-feud':
                        errorText = "Participants need to be a 'Heel' and a 'Face' that have been in a past Feud against each other";
                        break;
                    case 'level-1-producer':
                        errorText = "You need to have a Level 1 Producer available on your Staff";
                        if (!globals.game['paid']) {
                            errorText += ' (JoW Paid)'
                        }
                        break;
                    case 'level-2-producer':
                        errorText = "You need to have a Level 2 Producer available on your Staff";
                        break;
                    case 'level-3-producer':
                        errorText = "You need to have a Level 3 Producer available on your Staff";
                        break;
                    case 'new-talent-and-level-2-producer':
                        errorText = "Participant needs to be a recent signing, callup, trade or custom Superstar that hasn\'t had a " +
                            "Debut Segment and you need to have a Level 2 Producer available on your Staff";
                        break;
                    case 'returning-talent-and-level-2-producer':
                        errorText = "Participant needs to be injured, up to 3 months away from their return and you " +
                            "need to have a Level 2 Producer available on your Staff";
                        break;
                    case 'retiring-talent-and-level-3-producer':
                        errorText = "Participant needs to be over 45 years old and you " +
                            "need to have a Level 3 Producer available on your Staff";
                        break;
                    case 'buyout-offer-accepted':
                        errorText = "You need to make an offer to buyout a Competitor and have it accepted";
                        break;
                    case 'champion-and-level-2-producer':
                        if (participantName === 'Factions') {
                            errorText = 'This segment can only be used with Superstars and Teams';
                        }
                        else {
                            errorText = "Participant needs to be a " + participantName + " champion and you need to have a Level 2 " +
                                "Producer available on your Staff";
                        }
                        break;
                    case 'silver-champion':
                        if (participantName === 'Factions') {
                            errorText = 'This segment can only be used with Superstars and Teams';
                        }
                        else {
                            errorText = "Participant needs to hold a " + participantName + " championship with Silver Prestige or higher";
                        }
                        break;
                    case 'gold-champion':
                        if (participantName === 'Factions') {
                            errorText = 'This segment can only be used with Superstars and Teams';
                        }
                        else {
                            errorText = "Participant needs to hold a " + participantName + " championship with Gold Prestige or higher and a Graphic added";
                        }
                        break;
                    case 'obsidian-champion':
                        if (participantName === 'Factions') {
                            errorText = 'This segment can only be used with Superstars and Teams';
                        }
                        else {
                            errorText = "Participant needs to hold a " + participantName + " championship with Obsidian Prestige or higher";
                        }
                        break;
                    case 'retirement':
                        errorText = "Participant needs to have retired in the last 2 months";
                        break;
                    case 'losing-streak':
                        errorText = "Participant needs to have a Losing Streak of 5 Matches or more";
                        break;
                    case 'legend-and-over-superstar':
                        errorText = "One Participant needs to be a retired Hall of Famer and another needs to " +
                            "be an Over Superstar";
                        break;
                    case 'legend-and-heel':
                        errorText = "One Participant needs to be a retired Hall of Famer and another needs " +
                            "to have 'Heel' Alignment";
                        break;
                    case 'face-of-the-company':
                        errorText = "Participant needs to be a Face of the Company";
                        break;
                    case 'wrestler-of-the-year-award':
                        errorText = "Participant needs to have won a Wrestler of the Year Award in the last 2 months";
                        break;
                    case 'company-of-the-year-award':
                        errorText = "Your Company needs to have won a Company of the Year Award in the last 2 months";
                        break;
                    case 'award-winner':
                        errorText = "One Participant needs to have won a Year-End Award (not bad awards) in the last 2 months";
                        break;
                    case 'inflicted-injury':
                        errorText = "Participant needs to have injured another Superstar in the last 1 month";
                        break;
                    case 'not-done-yet-potential-feud':
                        errorText = "Participant needs to have retired another Superstar in the last 2 months";
                        break;
                    case 'shocking-heel-turn':
                        errorText = "Participant needs to have turned Heel in a Shocking Turn (Main Eventer turns against someone in a Segment after a year or more of being Heel or Face) in the last 2 months";
                        break;
                    case 'shocking-face-turn':
                        errorText = "Participant needs to have turned Face in a Shocking Turn (Main Eventer turns against someone in a Segment after a year or more of being Heel or Face) in the last 2 months";
                        break;
                    case 'new-gimmick-and-level-1-producer':
                        errorText = "Participant needs to have a new Gimmick and you " +
                            "need to have a Level 1 Producer available on your Staff";
                        break;
                    case 'singles-superstars':
                        errorText = "Participants need to be singles Superstars not in a Team";
                        break;
                    case 'retiring':
                        errorText = "A participant over 45 years old needs to be present";
                        break;
                    case 'injured-partner-and-singles-superstar':
                        errorText = "One participant needs to have an injured tag partner and another needs " +
                            "to be a singles Superstar not in a Team";
                        break;
                    case 'heels-vs-face-singles':
                        errorText = "One participant needs to be have 'Face' alignment and the others need to have 'Heel' alignment. Participants need to be singles Superstars not in a Team.";
                        break;
                    case 'masked-talent':
                        errorText = "A participant with a mask needs to be present.";
                        break;
                    case 'no-faction-leader':
                        errorText = "The faction needs to not have a leader present.";
                        break;
                    case 'faction-leader-present':
                        errorText = "The faction needs to have a leader present.";
                        break;
                    case 'other-brand-talent':
                        errorText = "Participants need to belong to another brand. Try using the Interbrand artifact to book other brand talent.";
                        break;
                    case 'heel-vs-heel':
                        errorText = "Both Participants need to have 'Heel' Alignment";
                        break;
                    case 'returning-talent':
                        errorText = "A participant who is available to return from injury (and hasn't been used since) needs to be present";
                        break;
                    case 'double-champion':
                        if (participantName === 'Factions') {
                            errorText = 'This segment can only be used with Superstars and Teams';
                        }
                        else {
                            errorText = "Participant needs to hold two " + participantName + " championships";
                        }
                        break;
                    case 'over-talent':
                        errorText = "Participants need to be Over (80% Overness or higher)";
                        break;
                    case 'feud-present':
                        errorText = "Participant needs to be in one or more active Feuds";
                        break;
                    case 'the-grand-invitational-winner':
                        errorText = "Participant needs to have won The Grand Invitational for the company in the last 2 months";
                        break;

                    default:
                        errorText = "The participant(s) do not fulfill the requirements for this Segment"
                }
            }
            notie.alert({
                type: 3,
                text: errorText
            });
        } else if (data['error'] === 'minimum-faction-superstars') {
            notie.alert({type: 3, text: "You cannot have less than 2 members in a faction."});
        } else if (data['error'] === 'maximum-faction-superstars') {
            notie.alert({type: 3, text: `You cannot have more than ${gameLimits.maxFactionSuperstars} members in a faction.`});
        } else if (data['error'] === 'not-member-of-faction') {
            notie.alert({type: 3, text: data['errorSuperstarName'] + " is not part of this faction."});
        } else if (data['error'] === 'faction-superstar-not-found') {
            notie.alert({
                type: 3,
                text: "One of the faction superstars selected could not be found. Please try again."
            });
        } else if (data['error'] === 'already-member-of-faction') {
            notie.alert({type: 3, text: data['errorSuperstarName'] + " is already part of this faction."});
        } else if (data['error'] === 'already-in-faction') {
            notie.alert({type: 3, text: data['errorSuperstarName'] + " is already in another faction."});
        } else if (data['error'] === 'leader-superstar-not-present') {
            notie.alert({type: 3, text: "The leader needs to be a member of the faction."});
        } else if (data['error'] === 'select-non-faction-leader') {
            notie.alert({type: 3, text: 'Select a faction member who is not the leader.'});
        } else if (data['error'] === 'faction-not-found') {
            notie.alert({type: 3, text: "That faction could not be found. Please try again."});
        } else if (data['error'] === 'selected-existing-faction') {
            notie.alert({type: 3, text: "Select a faction different from the selected faction."});
        } else if (data['error'] === 'selected-disbanded-faction') {
            notie.alert({type: 3, text: "Select a faction that hasn't been disbanded."});
        } else if (data['error'] === 'faction-name-not-entered') {
            notie.alert({type: 3, text: "Enter a name for the created faction."});
        } else if (data['error'] === 'faction-already-present') {
            notie.alert({type: 3, text: "A faction with that name already exists."});
        } else if (data['error'] === 'team-already-present') {
            notie.alert({type: 3, text: "A team with that name already exists."});
        } else if (data['error'] === 'faction-superstar-not-available') {
            notie.alert({type: 3, text: data['errorSuperstarName'] + " is not available to be booked."});
        } else if (data['error'] === 'not-enough-available-faction-superstars') {
            notie.alert({type: 3, text: "At least 2 members of a faction need to be available"});
        } else if (data['error'] === 'factions-only') {
            notie.alert({type: 3, text: "You can only select Factions for this Segment"});
        } else if (data['error'] === 'disbanded-faction') {
            notie.alert({type: 3, text: "You can only select Factions for this Segment"});
        } else if (data['error'] === 'factions-paid-only') {
            notie.alert({type: 3, text: "Faction Segments are only available in JoW Paid"});
        } else if (data['error'] === 'managers-paid-only') {
            notie.alert({type: 3, text: "Manager Segments are only available in JoW Paid"});
        } else if (data['error'] === 'brands-paid-only') {
            notie.alert({type: 3, text: "Brand Segments are only available in JoW Paid"});
        } else if (data['error'] === 'no-women-allowed') {
            notie.alert({type: 3, text: "Women are not allowed to be booked at this event"});
        } else if (data['error'] === 'no-men-allowed') {
            notie.alert({type: 3, text: "Men are not allowed to be booked at this event"});
        } else if (data['error'] === 'no-managed-talent') {
            notie.alert({type: 3, text: "Participant needs to be managing available talent."});
        } else if (data['error'] === 'manager-not-found') {
            notie.alert({type: 3, text: "The selected manager could not be found. Please try again."});
        } else if (data['error'] === 'maximum-superstars') {
            notie.alert({type: 3, text: "A manager cannot manage more than 15 superstars."});
        } else if (data['error'] === 'manager-present') {
            notie.alert({type: 3, text: "{0} already has a manager present.".format(data['superstarName'])});
        } else if (data['error'] === 'no-manager-present') {
            notie.alert({type: 3, text: "Participant needs to have a manager present."});
        } else if (data['error'] === 'managing-self') {
            notie.alert({type: 3, text: "Superstars cannot manage themselves."});
        } else if (data['error'] === 'managing-full-time-manager') {
            notie.alert({type: 3, text: "Full-time managers cannot be managed."});
        } else if (data['error'] === 'brand-not-found') {
            notie.alert({type: 3, text: "The selected brand could not be found. Please try again."});
        } else if (data['error'] === 'talent-not-found') {
            notie.alert({type: 3, text: "The selected talent could not be found. Please try again."});
        } else if (data['error'] === 'already-on-brand') {
            notie.alert({type: 3, text: "The selected talent is already part of the selected brand."});
        } else if (data['error'] === 'already-on-brand') {
            notie.alert({type: 3, text: "The selected talent is already part of the selected brand."});
        } else if (data['error'] === 'championship-already-present') {
            notie.alert({
                type: 3,
                text: "A championship with that name already exists. Leave the field blank to keep the current name."
            });
        } else if (data['error'] === 'producer-task-present') {
            notie.alert({
                type: 3,
                text: '{0} is already working on another task. Please cancel that task or select another Producer.'.format(data['producer'])
            });
        }
    }

    // Remove highlighted feuding members
    $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
    $('.superstar-select-feud-details').remove();
}

function showDeleteSegmentData({data, $segmentElement} = {}) {
    if (!data['error']) {
        $segmentElement.fadeOut(300).promise().done(function () {
            hideEventCardContent($('#event-card'));

            // Move main event label
            let mainEventLabel = $segmentElement.find('.main-event-label');
            if (mainEventLabel.length > 0) {
                mainEventLabel.prependTo($segmentElement.last().next().find('.event-match-column-left'))
            }

            $segmentElement.remove();

            // Reset match limits
            if ($("#matches").text() === '') {
                $("#matches").html('<span class="font-bold display-block light-grey margin-bottom-10 margin-top-10 event-match-empty">' +
                    'No matches or segments booked' + '</span>');
            }
            let matchLimitsHtml = getMatchLimitsHtml();
            $('#match-limits').html(matchLimitsHtml);
        });
    } else {
        if (data['error'] === 'pow-cannot-delete') {
            notie.alert({
                type: 3,
                text: "\"We need a welcome promo, and who better to deliver it than me?\" - Hank Hughes"
            });
        }
    }
}

function showGetAddProducersData({data, segmentUid} = {}) {
    let parent = $('#segment-add-producer-container');
    hideEventCardContent($('#event-card'));
    parent.data('segment-uid', segmentUid);

    // Populate producer select
    let producerSelect = parent.find('.segment-add-producer-select');
    let producerOptions = '';
    data['producers'].forEach(function (producer) {
        producerOptions += '<option value="' + producer['uid'] + '">' + producer['name'] + ' (Lvl ' + producer['level'] + ')</option>'
    });
    if (data['producers'].length <= 0) {
        producerOptions += '<option disabled selected value>No Producers Available</option>'
    }
    producerSelect.html(producerOptions);

    parent.hide().fadeIn('fast');
    parent[0].scrollIntoView();
}

function showAddProducerToSegmentData({data, segmentUid} = {}) {
   if (!data['error']) {
        let segmentHtml = getEventCardSegmentHtml(data['segment']);
        let segmentDiv = $('.event-match[data-uid="' + segmentUid + '"]');
        segmentDiv.replaceWith(segmentHtml);

        notie.alert({type: 4, text: '<div class="display-block">Producer added</div>', stay: false});

        setTimeout(function () {
            $('#segment-add-producer-container').fadeOut('fast');
        }, 600);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'segment-not-found') {
            notie.alert({type: 3, text: 'The Segment could not found. Please try again.'});
        }
        if (data['error'] === 'producer-not-found') {
            notie.alert({type: 3, text: 'That Producer could not found. Please try again.'});
        }
        if (data['error'] === 'producer-task-present') {
            notie.alert({type: 3, text: '{0} is already working on another task. Please cancel that task or select another Producer.'.format(data['producer'])});
        }
        if (data['error'] === 'not-paid') {
            notie.alert({type: 3, text: 'Producers can only be assigned to Segments in JoW Paid.'});
        }
    }
}

function showRemoveProduceFromSegmentData({data, segmentUid} = {}) {
   if (!data['error']) {
        let segmentHtml = getEventCardSegmentHtml(data['segment']);
        let segmentDiv = $('.event-match[data-uid="' + segmentUid + '"]');
        segmentDiv.replaceWith(segmentHtml);

        hideEventCardContent($('#event-card'));
        notie.alert({type: 4, text: '<div class="display-block">Producer removed</div>', stay: false});
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'segment-not-found') {
            notie.alert({type: 3, text: 'The Segment could not found. Please try again.', stay: true});
        }
        else if (data['error'] === 'no-producer-assigned') {
            notie.alert({type: 3, text: 'That Segment does not have a Producer assigned to it.', stay: true});
        }
    }
}

async function showDeleteMatchData({data, $matchElement} = {}) {
    if (!data['error']) {
        $matchElement.fadeOut(300).promise().done(async function () {
            hideEventCardContent($('#event-card'));

            // Move main event label
            let mainEventLabel = $matchElement.find('.main-event-label');
            if (mainEventLabel.length > 0) {
                mainEventLabel.prependTo($matchElement.last().next().find('.event-match-column-left'))
            }

            $matchElement.remove();

            // Remove deleted potential feuds
            removeDeletedPotentialFeuds(data['deletedPotentialFeudUids']);

            // Remove unbooked superstars
            processUnbookedMatchSuperstars(data['unbookedMatchSuperstarsUids']);

            // Update points
            let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
            $(".points-number").html(pointsHtml);

            // Reset match limits
            if ($("#matches").text() === '') {
                $("#matches").html('<span class="font-bold display-block light-grey margin-bottom-10 margin-top-10 event-match-empty">' +
                    'No matches or segments booked' + '</span>');
            }
            let matchLimitsHtml = getMatchLimitsHtml();
            $('#match-limits').html(matchLimitsHtml);

            if (data['weeklyShowDeleted']) {
                await loadHomePage(await getCurrentGame());
            }
        });
    }
    else {
        if (data['error'] === 'pow-cannot-delete') {
            notie.alert({type: 3, text: "\"That's my match! You know how hard I worked on it? No, it stays on the card.\" - Hank Hughes"});
        }
        else if (data['error'] === 'match-not-found') {
            notie.alert({type: 3, text: 'Match not found. Please try again.'});
        }
    }
}

function updateMatchParticipantsText() {

    // If singles tag selected, use its function
    let tagMatchOptionSelected = $(".tag-match-options .selected").text();
    let singlesTag = ['2v2', '3v3', '4v4', '5v5', '1v2', '1v3', '2v3', '?v?'].indexOf(tagMatchOptionSelected) > -1;
    if (singlesTag) {
        updateSinglesTagMatchParticipantsText();
        return false;
    }
    let tournament = $('#add-tournament-menu-button').hasClass('selected');

    if (selectedParticipants.length > 0) {
        // Get participants names
        let participantsNames;
        if (tournament) {
            participantsNames = selectedParticipants.join(', ');
        }
        else {
            participantsNames = selectedParticipants.join(' vs ');
        }

        // Get match type text
        let matchTypeText;
        let tagMatchOptionSelected = $('.tag-match-options .selected').text();
        let participantName = $('#book-singles-menu-button').hasClass('selected') ? 'Person' : 'Team';
        switch (selectedParticipants.length) {
            case 1:
                matchTypeText = '';
                break;
            case 2:
                matchTypeText = tagMatchOptionSelected;
                break;
            case 3:
                matchTypeText = 'Triple Threat {0}'.format(tagMatchOptionSelected);
                break;
            case 4:
                matchTypeText = 'Fatal 4 Way {0}'.format(tagMatchOptionSelected);
                break;
            case 5:
                matchTypeText = '5 Way {0}'.format(tagMatchOptionSelected);
                break;
            case 6:
                matchTypeText = '6 Way {0}'.format(tagMatchOptionSelected);
                break;
            case 7:
                matchTypeText = '7 Way {0}'.format(tagMatchOptionSelected);
                break;
            case 8:
                matchTypeText = '8 Way {0}'.format(tagMatchOptionSelected);
                break;
            case 9:
                matchTypeText = '9 Way {0}'.format(tagMatchOptionSelected);
                break;
            case 10:
                matchTypeText = '10 Way {0}'.format(tagMatchOptionSelected);
                break;
            default:
                matchTypeText = selectedParticipants.length + ' ' + participantName;
        }
        if (tournament) {
            matchTypeText = selectedParticipants.length + ' ' + participantName;
        }

        // Get match participants text
        let matchParticipantsText;
        let suffix = tournament ? 'Tournament' : 'Match';
        let selectedGimmickMatchName = selectedGimmickMatch ? selectedGimmickMatch.attr('data-name') : null;
        if (selectedGimmickMatchName) {
            if (matchTypeText) {
                matchParticipantsText = "{0} ({1} {2} {3})".format(participantsNames, matchTypeText,
                    selectedGimmickMatchName, suffix);
            }
            else {
                matchParticipantsText = "{0} ({1} {2})".format(participantsNames, selectedGimmickMatchName, suffix);
            }
        }
        else {
            if (matchTypeText) {
                matchParticipantsText = "{0} ({1} {2})".format(participantsNames, matchTypeText, suffix);
            }
            else {
                matchParticipantsText = "{0}".format(participantsNames);
            }
        }

        // Get 'add' button (if multi person selected) and tournament size confirm
        let tournamentSizeConfirm = '';
        let addButton = '';
        if ($("#multi-match-button").hasClass('selected')) {
            if (selectedParticipants.length > 1 && !tournament) {
                addButton = '<button type="button" id="add-match-button" ' +
                    'class="button retro-button blue-button-background condensed display-block margin-top-5">' +
                    'Book' +
                    '</button>';
            }
            else {
                let tournamentType = $('#tournament-type').val();
                if (tournamentType === 'elimination') {
                    // Check for full length of tournament participants
                    if (isPowerOfTwo(selectedParticipants.length) && selectedParticipants.length > 2) {
                        tournamentSizeConfirm = '<span><i class="fa fa-check light-green margin-left-5 ' +
                            'font-1p25em top-1px flash-color-green"></i></span>';
                    }
                }
                else if (tournamentType === 'round-robin') {
                    // Check for minimum group participants
                    let groups = $('#number-of-groups').val();
                    if (selectedParticipants.length >= (groups * 4) && selectedParticipants.length % groups === 0
                        && selectedParticipants.length % 2 === 0) {
                        tournamentSizeConfirm = '<span><i class="fa fa-check light-green margin-left-5 ' +
                            'font-1p25em top-1px flash-color-green"></i></span>';
                    }
                }
            }
        }

        // Show match participants text
        $("#multi-match-info").remove();
        $(".match-participants-container").html('<div class="font-bold" id="multi-match-info">' +
            matchParticipantsText + tournamentSizeConfirm + addButton +
            '</div>');

        // Show tournament participants
        if (tournament) {
            $('.tournament-participants-selected').text(selectedParticipants.length)
        }
    }
    else {
        $("#multi-match-info").remove();
        $('.match-participants-container').text('No participants selected');
    }
}

async function processMatchParticipantSelection(name, $el, participantType, uid, tournament) {

    // Unselect if already selected
    if ($el.hasClass("selected")) {
        let itemIndex = selectedParticipants.indexOf(name);
        selectedParticipants.splice(itemIndex, 1);
        selectedElements.splice(itemIndex, 1);
    }

    // Check for multi person participant limit
    let multiPerson = $("#multi-match-button").hasClass('selected');
    if (multiPerson && selectedParticipants.length >= 10 &&
        $(selectedGimmickMatch).attr('data-auto-picker') !== 'true' && !tournament) {
        playSoundEffect('error');
        notie.alert({type: 3, text: "You can't select more than 10 Participants"});
        return false;
    }

    // Select participant
    if (!$el.hasClass("selected")) {
        selectedParticipants.push(name);
        selectedElements.push($el);
    }
    $el.toggleClass("selected");

    // Update participants text
    updateMatchParticipantsText();

    // Check to add match if multi person not selected or open challenge
    let matchParticipantsRequired = 2;
    if (selectedGimmickMatch && selectedGimmickMatch.attr('data-consequence') === 'random-opponent') {
        matchParticipantsRequired = 1
    }
    let addMatchCalled = false;  // helps not run booking selection info if add match has error, since $el will still have selected class
    if (!multiPerson || matchParticipantsRequired === 1) {
        if (selectedParticipants.length === matchParticipantsRequired) {
            await callAddMatch();
            addMatchCalled = true;
        }
    }

    // Show information for selected participant (feuds, teams/factions)
    $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
    $('.superstar-select-feud-details').remove();
    if (selectedParticipants.length > 0 && $el.hasClass('selected') && !addMatchCalled) {
        await makeGameRequest(getBookingSelectionInformation, {uid, participantType},
            showGetBookingSelectionInformationData, {}, false, true, false);
    }
}

async function processSinglesTagMatchParticipantSelection(name, $el, participantType, uid) {
    // Add and remove superstars
    if (jQuery.inArray(name, selectedParticipants) === -1) {

        // Get maximum superstars
        let maximumSuperstars;
        if (handicapSize) {
            maximumSuperstars = handicapSize.reduce(function(acc, val) { return acc + val; }, 0)
        }
        else {
            maximumSuperstars = tagTeamSize * 10;
        }

        // Add superstar
        if (selectedParticipants.length < maximumSuperstars) {
            selectedParticipants.push(name);
            selectedElements.push($el);
            $el.toggleClass("selected");
        }
        // Error
        else {
            if (handicapSize) {
                notie.alert({type: 3, text: 'You can\'t select more than ' + maximumSuperstars + ' Superstars in this Match' });
            }
            else {
                notie.alert({type: 3, text: 'You can\'t select more than 10 Teams'});
            }
        }

    }
    // Remove superstar
    else {
        let itemIndex = selectedParticipants.indexOf(name);
        selectedParticipants.splice(itemIndex, 1);
        selectedElements.splice(itemIndex, 1);
        $el.removeClass('selected');
    }

    // Format teams
    teams = [];

    // If handicap match, get two teams using handicap size
    if (handicapSize) {
        let teamA = selectedParticipants.slice(0, handicapSize[0]);
        let teamB = selectedParticipants.slice(handicapSize[0], handicapSize[0] + handicapSize[1]);
        teams.push(teamA);
        if (teamB.length > 0) {
            teams.push(teamB)
        }
    }
    // Otherwise split teams into chunks of superstars
    else {
        let i, j, chunk = tagTeamSize;
        for (i = 0, j = selectedParticipants.length; i < j; i += chunk) {
            let team = selectedParticipants.slice(i, i + chunk);
            teams.push(team);
        }
    }

    // Update participants text
    updateSinglesTagMatchParticipantsText();

    // Show information for selected superstar (feuds, teams/factions)
    $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
    $('.superstar-select-feud-details').remove();
    if (selectedParticipants.length > 0 && $el.hasClass('selected')) {
        await makeGameRequest(getBookingSelectionInformation, {uid, participantType},
            showGetBookingSelectionInformationData, {}, false, true);
    }
}

function updateSinglesTagMatchParticipantsText() {
    // Show if more than 1 participant selected
    if (selectedParticipants.length > 0) {

        // Get participants names
        let participantsNames = [];
        teams.forEach(function (team) {
            participantsNames.push(commaSeparate(team));
        });
        participantsNames = participantsNames.join(' vs ');

        // Get match type text
        let matchTypeText;
        if (handicapSize) {
            matchTypeText = '{0}v{1} '.format(handicapSize[0], handicapSize[1])
        }
        else {
            matchTypeText = tagTeamSize * 2 + ' Person ';
            if (tagTeamSize === 2) {
                matchTypeText = '';
                // Add normal text for 2v2 tag match
                if (selectedParticipants.length > 4) {
                    switch (selectedParticipants.length / 2) {
                        case 3:
                            matchTypeText = 'Triple Threat ';
                            break;
                        case 4:
                            matchTypeText = 'Fatal 4 Way ';
                            break;
                        case 5:
                            matchTypeText = '5 Way ';
                            break;
                        case 6:
                            matchTypeText = '6 Way ';
                            break;
                        case 7:
                            matchTypeText = '7 Way ';
                            break;
                        case 8:
                            matchTypeText = '8 Way ';
                            break;
                        case 9:
                            matchTypeText = '9 Way ';
                            break;
                        case 10:
                            matchTypeText = '10 Way ';
                            break;
                    }
                }
            }
        }

        // Get match participants text
        let matchParticipantsText;
        let selectedGimmickMatchName = selectedGimmickMatch ? selectedGimmickMatch.attr('data-name') : null;
        if (selectedGimmickMatchName) {
            matchParticipantsText = "{0} ({1}Tag {2} Match)".format(participantsNames, matchTypeText, selectedGimmickMatchName);
        }
        else {
            matchParticipantsText = "{0} ({1}Tag Match)".format(participantsNames, matchTypeText);
        }

        // Check for full length of larger tag
        let tagTeamSizeConfirm = '';
        if (handicapSize) {
            let maximumSuperstars = handicapSize.reduce(function(acc, val) { return acc + val; }, 0);
            if ((selectedParticipants.length === maximumSuperstars)) {
                tagTeamSizeConfirm = '<span><i class="fa fa-check light-green margin-left-5 ' +
                    'font-1p25em top-1px flash-color-green"></i></span>';
            }

        }
        else {
            if ((selectedParticipants.length % tagTeamSize === 0 && selectedParticipants.length > tagTeamSize)) {
                tagTeamSizeConfirm = '<span><i class="fa fa-check light-green margin-left-5 ' +
                    'font-1p25em top-1px flash-color-green"></i></span>';
            }
        }

        // Get 'add' button
        let addButton = '';
        if (selectedParticipants.length > 1) {
            addButton = '<button type="button" id="add-match-button" ' +
                'class="button retro-button blue-button-background condensed display-block margin-top-5">' +
                'Book' +
                '</button>';
        }

        // Show match participants text
        $("#multi-match-info").remove();
        $(".match-participants-container").html('<div class="font-bold"  id="multi-match-info">' +
            matchParticipantsText + tagTeamSizeConfirm + addButton +
            '</div>');
    }
    else {
        $("#multi-match-info").remove();
        $('.match-participants-container').text('No participants selected');
    }
}

async function callAddMatch() {
    // Get match type
    let matchType = $('#book-singles-menu-button').hasClass('selected') ? 'singles' : 'tag';
    let tagMatchOptionSelected = $(".tag-match-options .selected").text();
    let singlesTag = ['2v2', '3v3', '4v4', '5v5', '1v2', '1v3', '2v3', '?v?'].indexOf(tagMatchOptionSelected) > -1;

    // If larger tag / handicap match, check if correct number of superstars selected
    if (singlesTag) {
        if (handicapSize) {
            // Check if correct number of superstars selected for handicap match
            let size = handicapSize.reduce(function (acc, val) {
                return acc + val;
            }, 0);
            if ((selectedParticipants.length !== size)) {
                notie.alert({type: 3, text: 'You need to select ' + size + ' Superstars for this Match'});
                return false;
            }
        }
        else {
            // Check if superstars are a multiple of and greater than team size
            let size = parseInt(tagTeamSize);
            if ((selectedParticipants.length % size !== 0 || selectedParticipants.length <= size)) {
                notie.alert({type: 3, text: 'You need to add ' + size + ' Superstars for each Team in this Match'});
                return false;
            }
        }
    }

    // Validate event selected for gimmick match with match contract
    if (selectedGimmickMatch && selectedGimmickMatch.find('#match_event').length > 0 &&
        !selectedGimmickMatch.attr('data-event-uid')) {
        notie.alert({type: 3, text: "Select an event for this match contract to be held at"});
        selectedGimmickMatch[0].scrollIntoView();
        selectedGimmickMatch.find('#match_event').addClass('highlight');
        return false;
    }

    // Get gimmick match options
    let matchEventUid;
    let gimmickMatchObject = false;
    let fallGimmickNames = [];
    let refereeUid;
    if (selectedGimmickMatch) {
        matchEventUid = parseInt(selectedGimmickMatch.attr('data-event-uid'));
        gimmickMatchObject = selectedGimmickMatch.find('.gimmick-match-generate-object-button').length > 0;
        fallGimmickNames = Array.from(selectedGimmickMatch.find('.match-fall-select'), function (x) {
            return $(x).val();
        });
        refereeUid = parseInt(selectedGimmickMatch.find('.match-referee-select').val());
    }

    // Get participants data
    let participantsData = [];
    selectedElements.forEach(function(selection) {
        let $selectionElement = $(selection);
        participantsData.push({'name': $selectionElement.attr('data-name'), 'type': $selectionElement.attr('data-type'),
            'uid': parseInt($selectionElement.attr('data-uid'))})
    });

    // Get selected championship and gimmick match
    let selectedChampionshipUid = selectedChampionship ? parseInt(selectedChampionship.attr('data-uid')) : null;
    let selectedGimmickMatchUid = selectedGimmickMatch ? parseInt(selectedGimmickMatch.attr('data-uid')) : null;
    let selectedGimmickMatchName = selectedGimmickMatch ? selectedGimmickMatch.attr('data-name') : null;

    // Reset search, scroll to selected element
    if ($('.superstar-search-input').val()) {
        $('.superstar-search-input').val('').trigger('input');
        let $container = $('#booking-talent-container'),
            $scrollTo = selectedElements[0];
        $container.scrollTop($scrollTo.offset().top - $container.offset().top + $container.scrollTop());
    }

    await makeGameRequest(addMatch, {participantsData, selectedGimmickMatchUid, selectedGimmickMatchName,
        selectedChampionshipUid, matchEventUid, gimmickMatchObject, fallGimmickNames, refereeUid, tagTeamSize,
        handicapSize, singlesTag, matchType, tagMatchOptionSelected}, showAddMatchData, {matchType, singlesTag}, false);
}

function showAddMatchData({data, matchType, singlesTag} = {}) {
    if (!data['error']) {
        // Add match to event card
        let matchHtml = getEventCardMatchHtml(data['match']);
        $('#matches').append(matchHtml);

        // Remove selected title
        if (selectedChampionship) {
            selectedChampionship.fadeOut();
        }

        // Lower opacity of selected elements
        if (matchType === 'singles' || singlesTag) {
            selectedElements.forEach(function (x) {
                $(x).addClass("booked");
            });
        }

        // Reset event card
        $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
        hideEventCardContent($('#event-card'));

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Show alignment boost
        let notieText = '<span class="display-block">Match Added ' + '</span>';
        if (data['alignmentBoost']) {
            let alignmentBoost = data['alignmentBoost'];
            if (alignmentBoost < 0) {
                alignmentBoost =
                    '<span class="display-block red">- ' + (alignmentBoost * -1) + ' Alignment Boost' + '</span>';
            }
            else {
                alignmentBoost =
                    '<span class="display-block green">+ ' + alignmentBoost + ' Alignment Boost' + '</span>';
            }
            notieText += alignmentBoost;
        }

        // Show gimmick restriction applied for championships
        if (data['gimmickRestrictedChampionships']) {
            data['gimmickRestrictedChampionships'].forEach(function (championship) {
                let gimmickRestrictedChampionshipText = getChampionshipGimmickRestrictionInfoHtml(championship);
                notieText += gimmickRestrictedChampionshipText;
            });
        }

        // Show notifications
        if (notieText) {
            $('.notie-textbox-inner').text('');
            notie.alert({type: 4, text: notieText, stay: false, prepend: true});
        }

        // Update match limits
        let matchLimitsHtml = getMatchLimitsHtml();
        $('#match-limits').html(matchLimitsHtml);

        // Tutorial action check
        if (data['nextTutorialState']) {
            globals.game.tutorialState = data['nextTutorialState']
        }
        if (matchType === 'singles') {
            checkTutorialStepAction('add_singles_match')
        }
        else {
            checkTutorialStepAction('add_tag_team_match');
        }
    }
    else {
        if (data['error'] === 'same') {
            notie.alert({type: 3, text: "Participants can't face themselves"});
        }
        else if (data['error'] === 'points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to add that gimmick match"});
        }
        else if (data['error'] === 'match-and-segment-limit') {
            notie.alert({
                type: 3,
                text: "You can't book more than " + data['limit'] + " matches/segments at this event"
            });
        }
        else if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: "One of the participants selected could not be found. Please try again."});
        }
        else if (data['error'] === 'championship-not-found') {
            notie.alert({type: 3, text: "The selected championship could not be found. Please try again."});
        }
        else if (data['error'] === 'gimmick-match-not-found') {
            notie.alert({type: 3, text: "The selected gimmick match could not be found. Please try again."});
        }
        else if (data['error'] === 'match-contract-exists') {
            notie.alert({
                type: 3,
                text: "A match contract with that name already exists. You can book another one after using it."
            });
        }
        else if (data['error'] === 'cashin-contract-exists') {
            notie.alert({
                type: 3,
                text: "A cash-in contract with that name already exists. You can book another one after using it."
            });
        }
        else if (data['error'] === '2/3-falls-one-on-one') {
            notie.alert({type: 3, text: " Falls can only be used in one on one matches"});
        }
        else if (data['error'] === 'graphics-not-present') {
            notie.alert({type: 3, text: "This match requires graphics to be present for all participants"});
        }
        else if (data['error'] === 'hair-not-present') {
            notie.alert({type: 3, text: "This match requires hair to be present for all participants"});
        }
        else if (data['error'] === 'hair-present') {
            notie.alert({type: 3, text: "This match requires hair to not be present for all participants"});
        }
        else if (data['error'] === 'mask-not-present') {
            notie.alert({type: 3, text: "This match requires a mask to be present for all participants"});
        }
        else if (data['error'] === 'mask-and-hair-not-present') {
            notie.alert({type: 3, text: "This match requires one participant with a mask and one with hair present"});
        }
        else if (data['error'] === 'no-women-allowed') {
            notie.alert({type: 3, text: "Women are not allowed to be booked at this event"});
        }
        else if (data['error'] === 'no-men-allowed') {
            notie.alert({type: 3, text: "Men are not allowed to be booked at this event"});
        }
        else if (data['error'] === 'production-packages-only') {
            notie.alert({
                type: 3,
                text: "You can only book Production Segments at this Event"
            });
        }
        else if (data['error'] === 'gimmick-restriction') {
            let gimmickRestrictedChampionship = data['gimmickRestrictedChampionship'];
            let notieText = getChampionshipGimmickRestrictionInfoHtml(gimmickRestrictedChampionship);
            notie.alert({type: 3, text: notieText});
        }
        else if (data['error'] === 'olympus-mons-already-booked') {
            notie.alert({type: 3, text: "Only one Olympus Mons match can be booked at the event"});
        }
        else if (data['error'] === 'femme-fatale-men') {
            notie.alert({type: 3, text: "Only women can be booked in this match"});
        }
        else if (data['error'] === 'referee-in-match') {
            notie.alert({type: 3, text: "The referee cannot be part of the match"});
        }
        else if (data['error'] === 'not-available') {
            notie.alert({type: 3, text: "Team members are not available"});
        }
        else if (data['error'] === 'duplicate-superstar') {
            notie.alert({type: 3, text: data['duplicateSuperstar'] + ' was booked more than once in the Match'});
        }
        else if (data['error'] === 'max-team-size') {
            notie.alert({
                type: 3,
                text: "You can't book a team of more than " + data['maxTeamSize'] + " superstars"
            });
        }
    }

    // Unselect selected elements
    selectedElements.forEach(function (x) {
        $(x).toggleClass('selected');
    });

    // Unselect selected championship
    if (selectedChampionship) {
        selectedChampionship.removeClass('selected');
    }

    // Reset selections
    selectedParticipants = [];
    selectedElements = [];
    selectedGimmickMatch = '';
    selectedChampionship = '';

    // Reset ui
    $('.match-participants-container').text('No participants selected');
    $("#multi-match-info").remove();
    $(".feud-container").show().removeClass('selected');
    $(".book-match-feuds-container").scrollTop($(".book-match-feuds-container").data('scrollTop'));
    $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
    $('.superstar-select-feud-details').remove();
    $("#show-gimmick-matches-button").removeClass('selected').find('.fa')
        .removeClass('fa-minus-circle').addClass('fa-plus-circle');
    $('#select-gimmick-match-container').hide();
}

function getAutoPickerHtml() {
    let autoPickPronounFilter = '';
    let autoPickBookedFilter = '';
    let singlesOptions = '';

    if ($('#book-singles-menu-button').hasClass('selected')) {
        autoPickPronounFilter =
            '<select name="auto-pick-pronoun-filter" id="auto-pick-pronoun-filter" class="styled-select margin-right-5">' +
            '<option value="0" selected>All Pronouns</option>' +
            '<option value="1">He</option>' +
            '<option value="2">She</option>' +
            '<option value="3">They</option>' +
            '</select>';
        autoPickBookedFilter =
            '<select name="auto-pick-booked-filter" id="auto-pick-booked-filter" class="styled-select margin-right-5">' +
            '<option value="0" selected>Not Booked</option>' +
            '<option value="1">All</option>' +
            '</select>';
        singlesOptions =
            '<option value="1">M. Event - U. Midcard</option>' +
            '<option value="2">Upper Midcard</option>' +
            '<option value="3">U. Midcard - L. Midcard</option>' +
            '<option value="4">Lower Midcard</option>';
    }

    return '<div id="auto-picker" class="font-bold margin-top-12">' +
        '<input type="number" id="auto-pick-input" class="auto-pick-input" name="auto-picker-value" value="30" min="8">' +
        '<select name="auto-pick-from" id="auto-pick-sort" class="margin-left-5 styled-select margin-right-5">' +
        '<option value="0" selected>Top</option>' +
        singlesOptions +
        '<option value="5">Bottom</option>' +
        '<option value="6">Random</option>' +
        '</select>' +
        autoPickPronounFilter +
        autoPickBookedFilter +
        '<button type="button" id="auto-pick" class="button retro-button condensed blue-button-background margin-top-7">' +
            'Auto Pick' +
        '</button>' +
        '</div>';
}

function showGetBookingGimmickMatchesData({data, scrollDiv, newDiv, eventCard} = {}) {
    data['availableGimmickMatches'].forEach(function (gimmickMatch) {
        let gimmickMatchHtml = getBookingGimmickMatchHtml(gimmickMatch, data);
        $(scrollDiv).append(gimmickMatchHtml);
    });

    // Unavailable gimmick matches
    let lockedText = 'Locked: Unlocked with Gimmick Match Prestige';
    data['unavailableGimmickMatches'].forEach(function (gimmickMatch) {

        let gimmickMatchName = gimmickMatch['name'];
        if (gimmickMatchName.length > 13) {
            gimmickMatchName = gimmickMatchName.slice(0, 13) + '.'
        }

        let unlockedBy = getGimmickMatchUnlockedBy(gimmickMatch['name']);
        let unlockText = ' (by getting Gold Prestige on ' + unlockedBy + ' Match)';

        if (!unlockedBy) {
            unlockText = '';
        }

        let gimmickDiv =
            '<div class="gimmick-match-item disabled help-text" title="' + lockedText + unlockText + '">' +
            '<span>' +
            gimmickMatchName +
            '<span class="blue float-right">' +
            '<img alt="Points"  src="static/www/static/cp_icon.png" class="margin-left-5 points-image-small"/> ' + '???' +
            '</span>' +
            '</span>' +
            '</div>';

        $(scrollDiv).append(gimmickDiv);
    });

    if (data['availableGimmickMatches'].length === 0 && data['unavailableGimmickMatches'].length === 0) {
        let div =
            '<span class="display-block medium-dark-grey ' +
            'font-bold font-0p925em">No Gimmick Matches Available</span>';

        $(scrollDiv).append(div);
    }

    // Move container to left column
    $("#select-gimmick-match-container").detach().prependTo('.game-content-left-column');

    if (eventCard) {
        hideEventCardContent($('#event-card'));

        // Move container to right column
        $("#select-gimmick-match-container").detach().appendTo('.game-content-right-column');
    }

    // Show gimmick matches
    $(newDiv).append(scrollDiv);
    $('#select-gimmick-match-container').html(newDiv).fadeIn('fast');
    $('.gimmick-matches-container-scroll').scrollTop(0);
    if (eventCard) {
        $('#select-gimmick-match-container')[0].scrollIntoView();
        // Tutorial action check
        checkTutorialStepAction('click_add_gimmick');
    }
}

function getBookingGimmickMatchHtml(gimmickMatch, data) {
    let gimmickDiv;

    // Set level
    let level;
    switch (gimmickMatch['level']) {
        case 1:
            level = '<i class="fa fa-star-o gimmick-match-level-icon bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o gimmick-match-level-icon silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o gimmick-match-level-icon gold-light"></i>';
            break;
    }

    // Set boosts
    let rating, pop, injury;
    rating = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch['ratingBoost']);
    if (gimmickMatch['ratingBoost'] < 3) {
        rating += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch['ratingBoost'])
    }
    pop = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch['popularityBoost']);
    if (gimmickMatch['popularityBoost'] < 3) {
        pop += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch['popularityBoost'])
    }
    injury = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch['injuryRate']);
    if (gimmickMatch['injuryRate'] < 3) {
        injury += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch['injuryRate'])
    }

    let fatigueHtml = '';
    if (globals.game.settings['enable_fatigue'] !== false) {
        let fatigueText = '<span class="gimmick-match-fatigue-value"><span class="margin-right-2">+</span>' +
            gimmickMatch['fatigueChange'] + '<span class="margin-left-2">%</span></span>';
        fatigueHtml = '<div class="medium-grey">' +
            '<span class="gimmick-match-label">Fatigue</span> ' + fatigueText +
            '</div>';
    }

    let specialMatchHtml = '';
    let dataConsequence = '';
    if (gimmickMatch['cashinContractName']) {
        specialMatchHtml = '<span class="display-block gold margin-top-5">' + 'Cash-in Contract' + '</span>'
    } else if (gimmickMatch['matchContractName']) {
        specialMatchHtml = '<span class="display-block gold margin-top-5">' + 'Fixed Match Contract' + '</span>'
    } else if (gimmickMatch['consequence'] === 'loser_unavailable') {
        specialMatchHtml = '<span class="display-block light-grey margin-top-5">' + 'Loser Unavailable' + '</span>'
    } else if (gimmickMatch['consequence'] === 'remove_hair') {
        specialMatchHtml = '<span class="display-block light-grey margin-top-5">' + 'Remove Hair' + '</span>'
    } else if (gimmickMatch['consequence'] === 'add_hair') {
        specialMatchHtml = '<span class="display-block light-grey margin-top-5">' + 'Add Hair' + '</span>'
    } else if (gimmickMatch['consequence'] === 'random_opponent') {
        specialMatchHtml = '<span class="display-block light-grey margin-top-5">' + 'Random Opponent' + '</span>';
        dataConsequence = ' data-consequence="random-opponent"'
    } else if (gimmickMatch['consequence'] === 'remove_mask') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Remove Mask' + '</span>'
    } else if (gimmickMatch['consequence'] === 'remove_mask_or_hair') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Remove Mask or Hair' + '</span>'
    } else if (gimmickMatch['rules'] === '2/3_falls') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Best of Three Falls' + '</span>'
    } else if (gimmickMatch['rules'] === 'special_referee') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Guest Referee' + '</span>'
    } else if (gimmickMatch['rules'] === 'elimination') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Superstar Elimination' + '</span>'
    }

    // Add description if present
    let spanHtml;
    if (gimmickMatch['description']) {
        spanHtml = '<div class="gimmick-match gimmick-match-item help-text" data-uid="' + gimmickMatch['uid'] + '" data-name="' +
            gimmickMatch['name'].replace(/"/g, "&quot;") + '" ' +
            'title="' + gimmickMatch['description'].replace(/"/g, "&quot;") + '"' + ' data-auto-picker="' +
            (gimmickMatch['rules'] === 'battle_royal') + '"' + dataConsequence + '>';
    } else {
        spanHtml = '<div class="gimmick-match gimmick-match-item" data-uid="' + gimmickMatch['uid'] + '" data-name="' +
            gimmickMatch['name'].replace(/"/g, "&quot;") + '" ' +
            'data-auto-picker="' + (gimmickMatch['rules'] === 'battle_royal') + '"' + dataConsequence + '>'
    }

    // Get progress to next level
    let progress;
    let levelXp;
    if (gimmickMatch['level'] < 3) {
        levelXp = Math.pow(gimmickMatch['level'], 2) * 50;
        progress = (gimmickMatch['xp'] / levelXp) * 100;
    } else {
        levelXp = Math.pow(2, 2) * 50;
        progress = 100;
    }
    let progressHtml =
        '<div class="margin-top-8 margin-bottom-3 item-progress-container display-inline-block">' +
        '<div class="progress-under help-text" title="' + gimmickMatch['xp'] + ' / ' + levelXp + ' XP">' +
        '<div class="progress" style="width:' + progress + '%">' + '</div>' +
        '</div>' +
        '</div>';
    let gimmickMatchName = gimmickMatch['name'];
    if (gimmickMatchName.length > 13) {
        gimmickMatchName = gimmickMatchName.slice(0, 13) + '.'
    }

    if (gimmickMatch['generateObject'] || gimmickMatch['generateLocation']) {
        let placeholder;
        if (gimmickMatch['generateObject']) {
            placeholder = 'Enter Object on the Pole'
        } else if (gimmickMatch['generateLocation']) {
            placeholder = 'Enter Location of Brawl'
        }

        gimmickDiv =
            spanHtml +
            '<span>' +
            '<span class="gimmick-match-item-name">' + gimmickMatchName + '</span>' +
            '<span class="blue float-right">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/>' + gimmickMatch['cost'] +
            '</span>' +
            '</span>' +
            '<div class="gimmick-match-details margin-top-7 display-none">' +
            '<div class="medium-grey">' +
            '<input type="text" placeholder="' + placeholder + '" id="match_object" ' +
            'class="match-name-input" maxlength="25">' +
            '</div>' +
            '<div class="medium-grey margin-bottom-8">' +
            '<button type="button" class="button retro-button condensed blue-button-background ' +
            'gimmick-match-generate-object-button" ' +
            'data-generate-object="' + gimmickMatch['generateObject'] + '" ' +
            'data-generate-location="' + gimmickMatch['generateLocation'] + '">' +
            'Generate' +
            '</button>' +
            '</div>' +
            '<div class="medium-grey">' +
            '<span class="gimmick-match-label">Rating</span> ' + rating +
            '</div>' +
            progressHtml + level +
            '</div>' +
            '</div>';
    } else {
        let specialInput = '';
        if (gimmickMatch['matchContractName']) {
            // Add select event options
            let selectOptions = '<option disabled selected value>Select Event</option>';
            data['parentEvents'].forEach(function (event) {
                selectOptions += '<option value="' + event.uid + '">' + event.name + '</option>'
            });
            specialInput = '<div class="medium-grey">' +
                '<select id="match_event" class="match-event-select help-text" ' +
                'title="Select event to hold this match contract at">' +
                selectOptions + '</select>' +
                '</div>';
        } else if (gimmickMatch['rules'] === '2/3_falls') {
            // Add select gimmick matches options
            let selectOptions = '';
            data['multipleFallsGimmickMatches'].forEach(function (g) {
                selectOptions += '<option>' + g + '</option>'
            });
            specialInput = '<div>' +
                '<select class="match-fall-select"><option disabled selected value>Select First Fall</option>' +
                selectOptions + '</select>' +
                '</div>' +
                '<div>' +
                '<select class="match-fall-select"><option disabled selected value>Select Second Fall</option>' +
                selectOptions + '</select>' +
                '</div>' +
                '<div>' +
                '<select class="match-fall-select"><option disabled selected value>Select Third Fall</option>' +
                selectOptions + '</select>' +
                '</div>';
        } else if (gimmickMatch['rules'] === 'special_referee') {
            // Add select gimmick matches options
            let selectOptions = '';
            data['specialRefereeSuperstars'].forEach(function (y) {
                selectOptions += '<option value="' + y['uid'] + '">' + y['name'] + '</option>'
            });
            specialInput = '<div>' +
                '<select class="match-referee-select"><option disabled selected value>Select Referee</option>' +
                selectOptions + '</select>' +
                '</div>';
        }

        gimmickDiv = spanHtml +
            '<span>' +
            '<span class="gimmick-match-item-name">' + gimmickMatchName + '</span>' +
            '<span class="blue float-right">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/>' + gimmickMatch['cost'] +
            '</span>' +
            '</span>' +
            '<div class="gimmick-match-details margin-top-7 display-none">' +
            specialInput +
            '<div class="medium-grey">' +
            '<span class="gimmick-match-label">Rating</span> ' + rating +
            '</div>' +
            '<div class="medium-grey">' +
            '<span class="gimmick-match-label">Pop.</span> ' + pop +
            '</div>' +
            '<div class="medium-grey">' +
            '<span class="gimmick-match-label">Injury</span> ' + injury +
            '</div>' +
            fatigueHtml +
            specialMatchHtml +
            progressHtml + level +
            '</div>' +
            '</div>';
    }

    return gimmickDiv;
}

function showGenerateGimmickMatchData({data, element, type} = {}) {
    // Add object name to input
    element.parent().prev().find('.match-name-input').val(data);

    let gimmickDiv = element.closest('.gimmick-match');
    let object;
    if (type === 'object') {
        object = data + ' on a Pole';
    }
    else if (type === 'location') {
        object = data + ' Brawl'
    }
    gimmickDiv.attr('data-name', object);

    // Update match participants text
    updateMatchParticipantsText();

    $('.gimmick-match-generate-object-button').data('previous-name', data);
}

function showAddGimmickMatchToMatchData({data, parent} = {}) {
    if (!data['error']) {
        hideEventCardContent($('#event-card'));

        // Reset
        selectedGimmickMatch = '';

        // Update match
        let matchIndex = $('.event-match').index(parent);
        let matchHtml = getEventCardMatchHtml(data['match'], matchIndex);
        parent.replaceWith(matchHtml);

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        let notieText = 'Gimmick Match added';
        notie.alert({type: 4, text: notieText});

        // Tutorial action check
        if (data['nextTutorialState']) {
            globals.game.tutorialState = data['nextTutorialState']
        }

        // Tutorial action check
        checkTutorialStepAction('add_gimmick_to_match');
    } else {
        if (data['error'] === 'points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to add that Gimmick Match"
            });
        } else if (data['error'] === 'match-contract-exists') {
            notie.alert({
                type: 3,
                text: "A Match Contract with that name already exists. You can book another one after using it."
            });
        } else if (data['error'] === 'cashin-contract-exists') {
            notie.alert({
                type: 3,
                text: "A cash-in contract with that name already exists. You can book another one after using it."
            });
        } else if (data['error'] === '2/3-falls-one-on-one') {
            notie.alert({type: 3, text: " Falls can only be used in one on one matches"});
        } else if (data['error'] === 'graphics-not-present') {
            notie.alert({type: 3, text: "This match requires graphics to be present for all participants"});
        } else if (data['error'] === 'hair-not-present') {
            notie.alert({type: 3, text: "This match requires hair to be present for all participants"});
        } else if (data['error'] === 'hair-present') {
            notie.alert({type: 3, text: "This match requires hair to not be present for all participants"});
        } else if (data['error'] === 'mask-not-present') {
            notie.alert({type: 3, text: "This match requires a mask to be present for all participants"});
        } else if (data['error'] === 'mask-and-hair-not-present') {
            notie.alert({type: 3, text: "This match requires one participant with a mask and one with hair present"});
        } else if (data['error'] === 'olympus-mons-already-booked') {
            notie.alert({type: 3, text: "Only one Olympus Mons match can be booked at the event"});
        } else if (data['error'] === 'femme-fatale-men') {
            notie.alert({type: 3, text: "Only women can be booked in this match"});
        } else if (data['error'] === 'referee-in-match') {
            notie.alert({type: 3, text: "The referee cannot be part of the match"});
        } else if (data['error'] === 'no-participants') {
            notie.alert({type: 3, text: "This match cannot be added without participants"});
        }
    }
}

function showChangeMatchOrSegmentOrderData({data, matchOrSegmentDivIndex} = {}) {
    // Move main event label
    let mainEventLabel = $('#matches').find('.main-event-label');
    if (mainEventLabel.length > 0) {
        mainEventLabel.prependTo($('.event-match').eq(0).find('.event-match-column-left'))
    }

    // Tutorial action check
    if (data['nextTutorialState']) {
        globals.game.tutorialState = data['nextTutorialState']
    }

    // Tutorial action check
    if (matchOrSegmentDivIndex === 0) {
        checkTutorialStepAction('move_match_to_main_event');
    }
}

function showGetMatchChampionshipsForSelectionData({data, matchUid} = {}) {
    hideEventCardContent($('#event-card'));

    $('.match-championships-container').html('');
    $('#match-championships-selection-container').data('match-uid', matchUid);

    data['championships'].forEach(function (championship) {
        let selectedClass = '';
        if (championship['present']) {
            selectedClass = ' selected'
        }
        let div =
            '<div class="inner-box-item match-championships-item font-bold' + selectedClass + '" data-uid="' + championship['uid'] + '">' +
            championship['name'] +
            '</div>';
        $('.match-championships-container').append(div);
    });

    $('#match-championships-selection-container').hide().fadeIn('fast');
    $('#match-championships-selection-container')[0].scrollIntoView();
}


function showChangeMatchChampionshipsData({data, matchUid} = {}) {
    if (!data['error']) {
        hideEventCardContent($('#event-card'));

        // Get match element, replace
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $('.event-match').index(matchElement);
        let matchHtml = getEventCardMatchHtml(data['match'], matchIndex);
        matchElement.replaceWith(matchHtml);

        // Add champion labels
        addMatchChampionshipLabels(data['championships'], matchElement);

        if ($('#book-tag-team-menu-button').hasClass('selected')) {
            setTimeout(function () {
                $('.tag-match-options').find('.selected').trigger('click')
            }, 50);
        }
        else {
            setTimeout(function () {
                $('#booking-menu').find('.selected').trigger('click')
            }, 50);
        }
    } else {
        if (data['error'] === 'gimmick-restriction') {
            let gimmickRestrictedChampionship = data['gimmickRestrictedChampionship'];
            let notieText = getChampionshipGimmickRestrictionInfoHtml(gimmickRestrictedChampionship);
            notie.alert({type: 3, text: notieText});
        } else if (data['error'] === 'already-booked') {
            let championshipVerb = data['championshipTag'] ? 'are' : 'is';
            notie.alert({
                type: 3,
                text: "{0} {1} already booked in another match".format(data['championshipName'], championshipVerb)
            })
        }
    }
}

function showRemoveChampionshipFromMatchData({parent} = {}) {
    $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
    hideEventCardContent($('#event-card'));

    // Remove 'remove title' button
    parent.find('.event-card-match-remove-championship-button').remove();
    parent.find('.match-championship-name').remove();

    // Remove champion label
    addMatchChampionshipLabels([], parent);

    if ($('#book-singles-menu-button').hasClass('selected') || $('#book-tag-team-menu-button').hasClass('selected')) {
        if ($('#book-tag-team-menu-button').hasClass('selected')) {
            setTimeout(function () {
                $('.tag-match-options').find('.selected').trigger('click')
            }, 50);
        }
        else {
            setTimeout(function () {
                $('#booking-menu').find('.selected').trigger('click')
            }, 50);
        }
    }
}

function addMatchChampionshipLabels(championships, matchElement) {
    // Add champion label for each championship
    let championNames = Array.from(championships, function (championship) {
        return championship['holder'];
    });

    // Go through each match participant
    matchElement.find('.event-card-match-participant').each(function (i, el) {
        // Check if champion
        let participantDiv = $(el).find('.event-card-match-participant-name');
        let participantChampionLabelDiv = $(el).find('.event-card-champion-label');
        let participantName = participantDiv.text();
        if (championNames.indexOf(participantName) >= 0) {
            // Add champion label if not already added
            if (participantChampionLabelDiv.length <= 0) {
                participantDiv.after(
                    '<span class="light-grey margin-left-3 font-15px top--1px ' +
                    'event-card-champion-label">(c)</span>'
                )
            }
        }
        else {
            // If not champion, remove champion label
            participantChampionLabelDiv.remove();
        }
    });
}

function showGetAvailableFeudsForMatchData({data, matchUid, matchType, isSegment} = {}) {
    if (!data['error']) {
        hideEventCardContent($('#event-card'));

        const $feudItemsContainer = $('#feud-items-container');
        $feudItemsContainer.html('');
        $feudItemsContainer.attr('data-uid', matchUid);
        $feudItemsContainer.attr('data-match-type', matchType);
        $feudItemsContainer.attr('data-is-segment', isSegment);

        // Add header
        $feudItemsContainer.append(
            '<div class="margin-bottom-30">' +
            '   <span class="menu-header-color font-mukta-mahee font-1p325em">Add Feud</span>' +
            '</div>'
        );

        // Add scrollable container
        $feudItemsContainer.append(
            '<div class="feud-items-container-scroll"></div>'
        );

        // Add available and unavailable feuds
        data['availableFeudItems'].forEach(function (item) {
            let feudItemHtml = getAvailableFeudItemHtml(item, data['randomFeudName'], true);
            $('.feud-items-container-scroll').append(feudItemHtml);
        });
        data['unavailableFeudItems'].forEach(function (item) {
            let feudItemHtml = getUnavailableFeudItemHtml(item, true);
            $('.feud-items-container-scroll').append(feudItemHtml);
        });

        // Show randomize feud hint
        if (!randomizeFeudHintShown) {
            randomizeFeudHintShown = true;
            notie.alert({
                type: 4,
                text: '<span class="display-block">Click the <i class="fa fa-refresh grey"></i> button to randomize the Feud name or add your own</span>'
            });
        }

        $feudItemsContainer.hide().fadeIn('fast');
        $feudItemsContainer[0].scrollIntoView();
        $('.feud-items-container-scroll').scrollTop(0);

        // Adjust custom feud name input's width
        $('#feud-items-container .feud-item-custom-name').trigger('input');

        // Tutorial action check
        checkTutorialStepAction('click_add_feud');
    } else {
        if (data['error'] === 'match-not-found') {
            notie.alert({
                type: 3,
                text: 'Match not found. Please try again.',
                stay: true
            });
        }
        if (data['error'] === 'segment-not-found') {
            notie.alert({
                type: 3,
                text: 'Segment not found. Please try again.',
                stay: true
            });
        }
        if (data['error'] === 'superstar-and-team') {
            notie.alert({
                type: 3,
                text: 'Superstars cannot feud with teams.',
                stay: true
            });
        }
        if (data['error'] === 'temporary-team') {
            notie.alert({
                type: 3,
                text: 'Feuds cannot be created with temporary Teams.',
                stay: true
            });
        }
        if (data['error'] === 'faction-vs-non-faction') {
            notie.alert({
                type: 3,
                text: 'Factions can only feud with other factions.',
                stay: true
            });
        }
    }
}

function showAddFeudToMatchData({data, matchOrSegmentUid} = {}) {
    if (!data['error']) {
        $('#feud-items-container').html('').hide();
        $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');

        let parent = $('.event-match[data-uid="' + matchOrSegmentUid + '"]');

        // Add remove feud dropdown
        parent.find('.event-card-match-add-feud-button').replaceWith(
            '<li class="event-card-match-remove-feud-button">' +
            '<span>Remove Feud</span>' +
            '</li>'
        );

        // Add feud name to left column
        let html = '<span class="display-block margin-top-3">' + '<span class="faded-red-light match-feud-name">' +
            data['feud']['name'] + '</span>' + '</span>';
        parent.find('.event-match-column-left').append(html);

        let notieTexts = '';

        // Show consequence applied to
        if (data['consequenceAppliedTo']) {
            let consequenceHtml = '<span class="faded-red-light">{0}</span>'.format(toTitleCase(data['feud']['consequence'].replace(/-/g, ' ')));
            notieTexts += '<span class="display-block">{0} Consequence applied to {1}</span>'.format(consequenceHtml, data['consequenceAppliedTo'])
        }

        // Previous feud hype
        if (data['previousFeudBoost'] > 0) {
            notieTexts += '<span class="display-block">Feud Hype will be boosted due to a previous Feud between the Participants</span>'
        } else if (data['previousFeudBoost'] < 0) {
            notieTexts += '<span class="display-block">Feud Hype will be penalized due to a previous Feud between the Participants</span>'
        }

        if (notieTexts) {
            notie.alert({type: 4, text: notieTexts, stay: true});
        }

        // Tutorial action check
        if (data['nextTutorialState']) {
            globals.game.tutorialState = data['nextTutorialState']
        }

        // Tutorial action check
        checkTutorialStepAction('select_feud_item');
    } else {
        if (data['error'] === 'match-not-found') {
            notie.alert({type: 3, text: 'Match not found. Please try again.', stay: true});
        }
        if (data['error'] === 'segment-not-found') {
            notie.alert({type: 3, text: 'Segment not found. Please try again.', stay: true});
        }
        if (data['error'] === 'feud-item-not-found') {
            notie.alert({type: 3, text: 'The selected Feud could not be found', stay: true});
        }
    }
}

function showRemoveFeudFromMatchOrSegmentData({data, matchElement} = {}) {
    if (!data['error']) {
        $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
        hideEventCardContent($('#event-card'));

        // Add 'add feud' dropdown
        matchElement.find('.event-card-match-remove-feud-button').replaceWith(
            '<li class="event-card-match-add-feud-button">' +
            '<span>Add Feud</span>' +
            '</li>'
        );

        matchElement.find('.match-feud-name').remove();

        // Remove deleted potential feuds
        removeDeletedPotentialFeuds(data['deletedPotentialFeudUids']);
    } else {
        if (data['error'] === 'match-not-found') {
            notie.alert({
                type: 3,
                text: 'Match not found. Please try again.',
                stay: true
            });
        }
        if (data['error'] === 'segment-not-found') {
            notie.alert({
                type: 3,
                text: 'Segment not found. Please try again.',
                stay: true
            });
        }
    }
}

function showChangeFeudBlowoffData({data, $el, add = true} = {}) {
    if (add) {
        if (!data['error']) {
            $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
            hideEventCardContent($('#event-card'));

            // Update match
            let matchElement = $el.closest('.event-match');
            let matchIndex = $('.event-match').index(matchElement);
            let matchHtml = getEventCardMatchHtml(data['match'], matchIndex);
            matchElement.replaceWith(matchHtml);

            if (data['newMatch']) {
                let participantNames = data['participants'].join(' and ');
                let html =
                    '<span class="display-block">' +
                    participantNames + ' have come up with a new Gimmick Match (' +
                    '<span class="light-blue">' + data['newMatch'] + '</span>' +
                    ') to use in their Feud Blowoff.' +
                    '</span>';
                notie.alert({type: 4, text: html, stay: true, prepend: true});
            }

            if (data['points']) {
                let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
                $(".points-number").html(pointsHtml);
            }

            // Show gimmick restriction applied for championships
            let gimmickRestrictedChampionshipText = '';
            data['gimmickRestrictedChampionships'].forEach(function (championship) {
                gimmickRestrictedChampionshipText += getChampionshipGimmickRestrictionInfoHtml(championship);
            });
            if (gimmickRestrictedChampionshipText) {
                $('.notie-textbox-inner').text('');
                notie.alert({type: 4, text: gimmickRestrictedChampionshipText, stay: false, prepend: true});
            }

            // Tutorial action check
            if (data['nextTutorialState']) {
                globals.game.tutorialState = data['nextTutorialState']
            }
            checkTutorialStepAction('add_feud_blowoff');
        }
        else {
            if (data['error'] === 'match-not-found') {
                notie.alert({
                    type: 3,
                    text: 'Match not found. Please try again.',
                    stay: true
                });
            }
            if (data['error'] === 'multi-person-match') {
                notie.alert({
                    type: 3,
                    text: 'This feud can only be blown off in a one on one match.',
                    stay: true
                });
            }
            if (data['error'] === 'singles-match-blowoff') {
                notie.alert({
                    type: 3,
                    text: 'This feud can only be blown off in a singles match.',
                    stay: true
                });
            }
            if (data['error'] === 'tag-match-blowoff') {
                notie.alert({
                    type: 3,
                    text: 'This feud can only be blown off in a tag match.',
                    stay: true
                });
            }
            if (data['error'] === 'trio-match-blowoff') {
                notie.alert({
                    type: 3,
                    text: 'This feud can only be blown off in a trios match.',
                    stay: true
                });
            }
            if (data['error'] === 'faction-match-blowoff') {
                notie.alert({
                    type: 3,
                    text: 'This feud can only be blown off in a tag match.',
                    stay: true
                });
            }
            if (data['error'] === 'blowoff-set') {
                notie.alert({
                    type: 3,
                    text: 'A blowoff has already been added to this feud.',
                    stay: true
                });
            }
        }
    }
    else {
        if (!data['error']) {
            $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
            hideEventCardContent($('#event-card'));

            // Update match
            let matchElement = $el.closest('.event-match');
            let matchIndex = $('.event-match').index(matchElement);
            let matchHtml = getEventCardMatchHtml(data['match'], matchIndex);
            matchElement.replaceWith(matchHtml);
        }
        else {
            if (data['error'] === 'match-not-found') {
                notie.alert({
                    type: 3,
                    text: 'Match not found. Please try again.',
                    stay: true
                });
            }
        }
    }
}

function removeDeletedPotentialFeuds(feudUids) {
    for (const uid of feudUids) {
        let feudElement = $('.feud-container[data-uid="' + uid + '"]');
        if (feudElement.length) {
            feudElement.remove()
        }
    }
    if ($('.potential-feuds-items').children('.feud-container').length <= 0) {
        $('.potential-feuds-items').remove()
    }
}

function processUnbookedMatchSuperstars(superstarUids) {
    for (const uid of superstarUids) {
        let superstarElement = $('.superstar-select[data-type="superstar"][data-uid="' + uid + '"]');
        if (superstarElement.length) {
            superstarElement.removeClass('booked');
        }
    }
}

function processBookedMatchSuperstars(superstarUids) {
    for (const uid of superstarUids) {
        let superstarElement = $('.superstar-select[data-type="superstar"][data-uid="' + uid + '"]');
        if (superstarElement.length) {
            superstarElement.addClass('booked');
        }
    }
}

function showGetAddMatchManagerSelectionsData({data, matchUid} = {}) {
    hideEventCardContent($('#event-card'));

    $('#match-add-manager-container').data('match-uid', matchUid);

    // Populate participant select
    let participantSelect = $('#match-add-manager-container .match-add-manager-participant-select');
    let participantOptions = '';
    data['matchParticipants'].forEach(function (participant) {
        participantOptions += '<option value="' + participant['uid'] + '">' + participant['name'] + '</option>'
    });
    participantSelect.html(participantOptions);

    // Populate manager select
    let managerSelect = $('#match-add-manager-container .match-add-manager-manager-select');
    let managerOptionsHtml = '';
    let managerOptions = '';
    let partnerOptions = '';
    data['managerSelections'].forEach(function (manager) {
        let managerOptionHtml = '<option value="' + manager['uid'] + '">' + manager['name'] + '</option>';
        if (manager['partnerSuperstar']) {
            partnerOptions += managerOptionHtml
        } else {
            managerOptions += managerOptionHtml
        }
    });
    managerOptionsHtml += '<optgroup label="Partners">' + partnerOptions + '</optgroup>';
    managerOptionsHtml += '<optgroup label="Superstars">' + managerOptions + '</optgroup>';
    managerSelect.html(managerOptionsHtml);

    $('#match-add-manager-container').hide().fadeIn('fast');
    $('#match-add-manager-container')[0].scrollIntoView();
}

function showAddManagerToMatchData({data, matchUid} = {}) {
    if (!data['error']) {
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $('.event-match').index(matchElement);
        let matchHtml = getEventCardMatchHtml(data['match'], matchIndex);
        matchElement.replaceWith(matchHtml);

        notie.alert({type: 4, text: '<div class="display-block">Manager added</div>', stay: false});

        $('#match-add-manager-container').fadeOut('fast');
    } else {
        if (data['error'] === 'match-not-found') {
            notie.alert({type: 3, text: 'The Match could not found. Please try again.', stay: true});
        }
        if (data['error'] === 'participant-not-found') {
            notie.alert({type: 3, text: 'That Participant could not found. Please try again.', stay: true});
        }
        if (data['error'] === 'manager-not-found') {
            notie.alert({type: 3, text: 'That Manager could not found. Please try again.', stay: true});
        }
        if (data['error'] === 'manager-assigned') {
            notie.alert({
                type: 3,
                text: 'A Manager is already assigned to {0}. Please remove them before adding another Manager.'.format(data['participantName']),
                stay: true
            });
        }
        if (data['error'] === 'manager-in-match') {
            notie.alert({type: 3, text: '{0} is already part of the match.'.format(data['managerName']), stay: true});
        }
        if (data['error'] === 'manager-not-available') {
            notie.alert({type: 3, text: '{0} is not available to be booked.'.format(data['managerName']), stay: true});
        }
    }
}

function showGetRemoveMatchManagerSelectionsData({data, matchUid} = {}) {
    hideEventCardContent($('#event-card'));

    $('#match-remove-manager-container').data('match-uid', matchUid);

    // Populate manager select
    let managerSelect = $('#match-remove-manager-container .match-remove-manager-manager-select');
    let managerOptions = '';
    data['managerSelections'].forEach(function (manager) {
        managerOptions += '<option value="' + manager['superstarUid'] + '">' + manager['name'] + '</option>'
    });
    managerSelect.html(managerOptions);

    $('#match-remove-manager-container').hide().fadeIn('fast');
    $('#match-remove-manager-container')[0].scrollIntoView();
}

function showRemoveManagerFromMatchData({data, matchUid} = {}) {
    if (!data['error']) {
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $('.event-match').index(matchElement);
        let matchHtml = getEventCardMatchHtml(data['match'], matchIndex);
        matchElement.replaceWith(matchHtml);

        notie.alert({type: 4, text: '<div class="display-block">Manager removed</div>', stay: false});

        $('#match-remove-manager-container').fadeOut('fast');
    }
    else {
        if (data['error'] === 'match-not-found') {
            notie.alert({type: 3, text: 'The Match could not found. Please try again.', stay: true});
        }
        if (data['error'] === 'superstar-not-found') {
            notie.alert({type: 3, text: 'That Manager could not found. Please try again.', stay: true});
        }
        if (data['error'] === 'manager-not-assigned') {
            notie.alert({type: 3, text: 'That Manager is not part of the match.', stay: true});
        }
    }
}

function showTrioMembersForSelection(members, membersSelected, matchUid, teamName) {
    hideEventCardContent($('#event-card'));
    $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');

    $('.trio-members-container').html('');
    $('#trio-members-selection-container').data('match-uid', matchUid);
    $('#trio-members-selection-container').data('team-name', teamName);

    members.forEach(function (member) {
        let selectedClass = '';
        if (membersSelected.indexOf(member) >= 0) {
            selectedClass = ' selected'
        }
        let div =
            '<div class="inner-box-item trio-member font-bold' + selectedClass + '">' +
            member +
            '</div>';
        $('.trio-members-container').append(div);
    });

    $('#trio-members-selection-container').hide().fadeIn('fast');
    $('#trio-members-selection-container')[0].scrollIntoView();
}

function showFactionMembersForSelection(members, membersSelected, matchUid, teamName, teamSize) {
    hideEventCardContent($('#event-card'));
    $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');

    $('.faction-members-container').html('');
    $('#faction-members-selection-container').data('match-uid', matchUid);
    $('#faction-members-selection-container').data('team-name', teamName);
    $('#faction-members-selection-container').data('team-size', teamSize);

    members.forEach(function (member) {
        let selectedClass = '';
        if (membersSelected.indexOf(member) >= 0) {
            selectedClass = ' selected'
        }
        let div =
            '<div class="inner-box-item faction-member font-bold' + selectedClass + '">' +
            member +
            '</div>';
        $('.faction-members-container').append(div);
    });

    $('#faction-members-selection-container').hide().fadeIn('fast');
    $('#faction-members-selection-container')[0].scrollIntoView();
}

function showChangeTrioTagTeamMembersData({data, matchUid} = {}) {
    if (!data['error']) {
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $('.event-match').index(matchElement);
        let matchHtml = getEventCardMatchHtml(data['match'], matchIndex);
        matchElement.replaceWith(matchHtml);

        // Change unbooked/booked
        processUnbookedMatchSuperstars(data['unbookedMatchSuperstarsUids']);
        processBookedMatchSuperstars(data['bookedMatchSuperstarsUids']);

        // Show alignment bonus
        let notieText = '<div class="display-block">Team members changed</div>';
        if (data['alignmentBoost']) {
            let alignmentBoost = data['alignmentBoost'];
            if (alignmentBoost < 0) {
                alignmentBoost =
                    '<span class="red display-block">- ' + (alignmentBoost * -1) + ' Alignment Boost' + '</span>';
            } else {
                alignmentBoost =
                    '<span class="green display-block">+ ' + alignmentBoost + ' Alignment Boost' + '</span>';
            }
            notieText += alignmentBoost
        }
        notie.alert({type: 4, text: notieText, stay: false});

        $('#trio-members-selection-container').fadeOut('fast');
    } else {
        if (data['error'] === 'match-not-found') {
            notie.alert({type: 3, text: 'The Match could not be found. Please try again.'});
        }
        if (data['error'] === 'team-not-found') {
            notie.alert({type: 3, text: 'The Team could not be found. Please try again.'});
        }
        if (data['error'] === 'team-members-not-found') {
            notie.alert({type: 3, text: 'The selected Superstars could not be found. Please try again.'});
        }
        if (data['error'] === 'member-not-available') {
            notie.alert({type: 3, text: '{0} is not available to be booked'.format(data['memberName'])});
        } else if (data['error'] === 'no-women-allowed') {
            notie.alert({type: 3, text: "Women are not allowed to be booked at this event"});
        } else if (data['error'] === 'no-men-allowed') {
            notie.alert({type: 3, text: "Men are not allowed to be booked at this event"});
        } else if (data['error'] === 'referee-in-match') {
            notie.alert({type: 3, text: "The referee cannot be part of the match"});
        }
    }
}

function showChangeFactionTagTeamMembersData({data, matchUid} = {}) {
    if (!data['error']) {
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $('.event-match').index(matchElement);
        let matchHtml = getEventCardMatchHtml(data['match'], matchIndex);
        matchElement.replaceWith(matchHtml);

        // Change unbooked/booked
        processUnbookedMatchSuperstars(data['unbookedMatchSuperstarsUids']);
        processBookedMatchSuperstars(data['bookedMatchSuperstarsUids']);

        // Show alignment bonus
        let notieText = '<div class="display-block">Team members changed</div>';
        if (data['alignmentBoost']) {
            let alignmentBoost = data['alignmentBoost'];
            if (alignmentBoost < 0) {
                alignmentBoost =
                    '<span class="red display-block">- ' + (alignmentBoost * -1) + ' Alignment Boost' + '</span>';
            } else {
                alignmentBoost =
                    '<span class="green display-block">+ ' + alignmentBoost + ' Alignment Boost' + '</span>';
            }
            notieText += alignmentBoost
        }
        notie.alert({type: 4, text: notieText, stay: false});

        $('#faction-members-selection-container').fadeOut('fast');
    } else {
        if (data['error'] === 'match-not-found') {
            notie.alert({type: 3, text: 'The Match could not be found. Please try again.'});
        }
        if (data['error'] === 'team-not-found') {
            notie.alert({type: 3, text: 'The Team could not be found. Please try again.'});
        }
        if (data['error'] === 'team-members-not-found') {
            notie.alert({type: 3, text: 'The selected Superstars could not be found. Please try again.'});
        }
        if (data['error'] === 'member-not-available') {
            notie.alert({type: 3, text: '{0} is not available to be booked'.format(data['memberName'])});
        } else if (data['error'] === 'no-women-allowed') {
            notie.alert({type: 3, text: "Women are not allowed to be booked at this event"});
        } else if (data['error'] === 'no-men-allowed') {
            notie.alert({type: 3, text: "Men are not allowed to be booked at this event"});
        } else if (data['error'] === 'referee-in-match') {
            notie.alert({type: 3, text: "The referee cannot be part of the match"});
        }
    }
}

function showChangeSuperstarAttireData({data, $el} = {}) {
    if (!data['error']) {
        // Update current attire
        let currentAttire = String.fromCharCode(65 + data['currentAttire']);
        $el.text(currentAttire);
        notie.alert({
            type: 4, text: 'Attire changed for {0}'.format(data['name'])
        });
    }
    else {
        if (data['error'] === 'no-graphic') {
            notie.alert({
                type: 3, text: '{0} doesn\'t have a graphic added'.format(data['name'])
            });
        }
        if (data['error'] === 'no-alternate-attires') {
            notie.alert({
                type: 3, text: '{0} doesn\'t have any alternate attires added'.format(data['name'])
            });
        }
    }
}

function showViewRosterMemberDetailsData({data, uid, type} = {}) {
    if (type === 'faction') {
        showViewFactionDetailsPage(data, false, '#booking-container');
    }
    else {
        showViewRosterMemberPageData(data, uid, type, false, data['scoutLevel'], '#booking-container');
    }
}

function getSimulatorCost(style) {
    let cost;
    switch (style) {
        case 'standard':
            cost = 10;
            return cost;
        case 'long-term':
            cost = 20;
            return cost;
        case 'quality':
            cost = 15;
            return cost;
        case 'bizarro':
            cost = 5;
            return cost;
        case 'terrible':
            cost = 2;
            return cost;
    }
}

async function autoBookRequest(style, numberOption, addOption) {
    hideEventCardContent($('#event-card'));
    $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');

    let hideBooked = $('.auto-booker-hide-booked-checkbox:checked').length > 0;
    await makeGameRequest(autoBookEventRequest, {style, numberOption, addOption, hideBooked},
            showAutoBookEventData, {}, false);
}

function showAutoBookEventData({data} = {}) {
    if (!data['error']) {
        // Add matches and segments
        if (data['matchesAndSegments'].length > 0) {
            addEventCardMatchesAndSegments(data['matchesAndSegments']);
        }

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    } else {
        let error = '';
        if (data['error'] === 'points') {
            error = 'You do not have enough Creative Points to use the Auto Booker'
        }
        if (data['error'] === 'already-booked') {
            error = 'Auto Booker didn\'t find any available space at the Event'
        }
        if (data['error'] === 'pow-cannot-replace') {
            error = 'You cannot use the Auto Booker with the replace option at this Event'
        }
        notie.alert({type: 3, text: error});
    }
}

async function showRunSimulatorData({data, style, eventsToSimulate, notificationsOption, simulatorOption, totalEvents} = {}) {
    if (!data['error']) {
        await showSimulationUpdates(data, style, eventsToSimulate, notificationsOption, simulatorOption,
            totalEvents)
    }
    else {
        let error = '';
        if (data['error'] === 'points') {
            error = 'You do not have enough Creative Points to use the Simulator'
        }
        if (data['error'] === 'paid-only') {
            error = 'The Simulator can only be used with JoW Paid'
        }
        if (data['error'] === 'local-multiplayer-disabled') {
            error = 'The Simulator cannot be used in Local Multiplayer'
        }
        if (data['error'] === 'simulator') {
            error = 'There was an error simulating events.';
        }

        // Load home page if error while simulating
        if (eventsToSimulate !== totalEvents || data['error'] === 'simulator') {
            await loadHomePage(await getCurrentGame(), false);
            $('#stop-simulation-button').parent().hide();
            $('.simulation-progress-loading').hide();
            notie.alert({type: 3, text: error});
        }
        // Otherwise reload simulator page
        else {
            $('#simulation-results-container').hide();
            $('#simulator-menu-button').trigger('click');
            notie.alert({type: 3, text: error});
        }
    }
}

async function showSimulationUpdates(data, style, eventsToSimulate, notificationsOption, simulatorOption, totalEvents) {
    let progressDiv = $('#simulation-progress');
    let updatesDiv = $('#simulation-updates');
    let newsDiv = $('#simulation-news');

    // Notifications options
    let newsToShow = 2;
    let updatesToShow = 10;
    let showNewsContent = false;

    // Add updates
    updatesDiv.show();
    let awardsWon = data['updates']['awardsWon'];
    let retired = data['updates']['retired'];
    let callups = data['updates']['callups'];
    let leftCompany = data['results']['leftCompany'];
    let injuries = data['results']['injuries'];
    let available = data['results']['availableSuperstars'];
    let fotcMade = data['results']['facesOfTheCompanyMade'];
    let fotcLost = data['results']['facesOfTheCompanyLost'];
    let signings = data['results']['signings'];
    let offersAccepted = data['results']['offersAccepted'];
    let fired = data['results']['fired'];
    let hotChanges = data['results']['hotChanges'];
    let staleChanges = data['results']['staleChanges'];
    let debutedGimmicks = data['results']['debutedGimmicks'];

    if (fired) {
        fired.forEach(function (superstar) {
            let firedDiv = '<div class="simulation-update margin-bottom-8">' +
                superstar['name'] +
                '<span class="puke-green">' +
                ' was fired (due to booking consequence) from the company' +
                '</span>' +
                '</div>';
            updatesDiv.prepend(firedDiv);
            updatesDiv.children().first().hide().fadeIn();
        })
    }

    if (signings) {
        signings.forEach(function (signing) {
            let signingDiv = '<div class="simulation-update margin-bottom-8">' +
                '<span class="blue">' +
                'Signed ' +
                '</span>' +
                signing + ' to the Company' + '</div>';
            updatesDiv.prepend(signingDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    if (offersAccepted) {
        offersAccepted.forEach(function (offerAccepted) {
            let offerAcceptedDiv = '<div class="simulation-update margin-bottom-8">' +
                '<span class="blue">' +
                'Offer ' +
                '</span>for ' +
                offerAccepted['name'] + ' by ' + offerAccepted['company'] + ' was accepted' + '</div>';
            updatesDiv.prepend(offerAcceptedDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    if (injuries) {
        injuries.forEach(function (injury) {
            let injuryDiv = '<div class="simulation-update margin-bottom-8">' +
                injury['name'] +
                '<span class="dark-red">' +
                ' suffered an injury' +
                '</span>' +
                '</div>';
            updatesDiv.prepend(injuryDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    if (available) {
        available.forEach(function (superstar) {
            let availableDiv = '<div class="simulation-update margin-bottom-8">' +
                superstar['name'] + ' ready to return' + '</div>';
            updatesDiv.prepend(availableDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    if (awardsWon) {
        awardsWon.forEach(function (award) {

            let trophy = '';
            switch (award['trophy']) {
                case 'worst':
                    trophy = 'trophy_icon_trash';
                    break;
                case 'bronze':
                    trophy = 'trophy_icon_bronze';
                    break;
                case 'silver':
                    trophy = 'trophy_icon_silver';
                    break;
                case 'gold':
                    trophy = 'trophy_icon_gold';
                    break;
            }
            trophy = '<img alt="Trophy" src="static/www/static/' + trophy + '.png" class="trophy-image margin-right-8"/>';

            let awardWonDiv = '<div class="simulation-update margin-bottom-8">' +
                trophy +
                'Won the ' + award['name'] + ' Award' +
                '</div>';
            updatesDiv.prepend(awardWonDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    if (retired) {
        retired.forEach(function (superstar) {
            let hof = '';
            if (superstar['hallOfFame']) {
                hof = ' and was inducted into the ' +
                    '<span class="gold">' + 'Hall of Fame' + '</span>'
            }
            let retiredDiv = '<div class="simulation-update margin-bottom-8">' +
                superstar['name'] + ' retired from wrestling' + hof + '</div>';
            updatesDiv.prepend(retiredDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    if (callups) {
        callups.forEach(function (superstar) {
            let retiredDiv = '<div class="simulation-update margin-bottom-8">' +
                '<span class="green">' +
                'Called up ' +
                '</span>' +
                superstar + ' to the Main Roster' +
                '</div>';
            updatesDiv.prepend(retiredDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    if (fotcMade) {
        fotcMade.forEach(function (superstar) {
            let retiredDiv = '<div class="simulation-update margin-bottom-8">' +
                superstar + ' became a ' +
                '<span class="medium-blue">' +
                'Face of the Company' +
                '</span>' +
                '</div>';
            updatesDiv.prepend(retiredDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    if (fotcLost) {
        fotcLost.forEach(function (superstar) {
            let retiredDiv = '<div class="simulation-update margin-bottom-8">' +
                superstar + ' is no longer a Face of the Company' +
                '</div>';
            updatesDiv.prepend(retiredDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    if (leftCompany) {
        leftCompany.forEach(function (superstar) {
            let leftCompanyDiv = '<div class="simulation-update margin-bottom-8">' +
                superstar +
                '<span class="puke-green">' +
                ' left the company' +
                '</span>' +
                '</div>';
            updatesDiv.prepend(leftCompanyDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
    }

    hotChanges.forEach(function (hotChange) {
        let text;
        if (hotChange['status'] === 'hotStart') {
            text = hotChange['name'] + ' is starting to get <span class="hot-color">Over</span> with the Fans'
        }
        else if (hotChange['status'] === 'hotEnd') {
            text = hotChange['name'] + ' is no longer <span class="hot-color">Over</span> with the Fans'
        }
        else if (hotChange['status'] === 'hot') {
            text = hotChange['name'] + ' got <span class="hot-color hot-text">Over</span> with the Fans.'
        }
        let hotChangeDiv = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + '</div>';
        updatesDiv.prepend(hotChangeDiv);
        updatesDiv.children().first().hide().fadeIn();
    });

    staleChanges.forEach(function (staleChange) {
        let text;
        if (staleChange['status'] === 'staleStart') {
            text = staleChange['name'] + ' is starting to become <span class="stale-color">Stale</span> with the Fans'
        }
        else if (staleChange['status'] === 'staleEnd') {
            text = staleChange['name'] + ' is no longer <span class="stale-color">Stale</span> with the Fans'
        }
        else if (staleChange['status'] === 'stale') {
            text = staleChange['name'] + ' became <span class="stale-color stale-text">Stale</span> with the Fans'
        }
        let staleChangeDiv = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + '</div>';
        updatesDiv.prepend(staleChangeDiv);
        updatesDiv.children().first().hide().fadeIn();
    });

    if (notificationsOption === 'deep') {

        updatesToShow = 16;
        newsToShow = 4;
        showNewsContent = true;

        let reviewData = data['updates']['reviewData'];
        let createdTagTeams = data['updates']['createdTagTeams'];
        let disbandedTagTeams = data['updates']['disbandedTagTeams'];
        let createdTrios = data['updates']['createdTrios'];
        let createdFactions = data['updates']['createdFactions'];
        let createdChampionships = data['updates']['createdChampionships'];
        let powerupsUsed = data['updates']['powerupsUsed'];
        let releasedSuperstars = data['updates']['releasedSuperstars'];
        let managersTransitioned = data['updates']['managersTransitioned'];
        let managersAdded = data['updates']['managersAdded'];
        let managersRemoved = data['updates']['managersRemoved'];
        let brandsChanged = data['updates']['brandsChanged'];
        let streaksEnded = data['results']['streaksEnded'];

        if (createdTagTeams) {
            createdTagTeams.forEach(function (tagTeam) {
                let teamSuperstars = tagTeam['superstars'].join(' and ');
                let newTagTeamDiv = '<div class="simulation-update margin-bottom-8">' +
                    'Created a Tag Team (' + tagTeam['name'] + ') of ' + teamSuperstars +
                    '</div>';
                updatesDiv.prepend(newTagTeamDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (disbandedTagTeams) {
            disbandedTagTeams.forEach(function (tagTeam) {
                let disbandedTagTeamDiv = '<div class="simulation-update margin-bottom-8">' +
                    'Disbanded ' + tagTeam +
                    '</div>';
                updatesDiv.prepend(disbandedTagTeamDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (createdTrios) {
            createdTrios.forEach(function (trio) {
                let teamSuperstars = commaSeparate(trio['superstars']);
                let newTagTeamDiv = '<div class="simulation-update margin-bottom-8">' +
                    'Created a Trio (' + trio['name'] + ') of ' + teamSuperstars +
                    '</div>';
                updatesDiv.prepend(newTagTeamDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (createdFactions) {
            createdFactions.forEach(function (faction) {
                let factionSuperstars = commaSeparate(faction['superstars']);
                let newTagTeamDiv = '<div class="simulation-update margin-bottom-8">' +
                    'Created a Faction (' + faction['name'] + ') of ' + factionSuperstars +
                    '</div>';
                updatesDiv.prepend(newTagTeamDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (createdChampionships) {
            createdChampionships.forEach(function (championship) {
                let newChampionshipDiv = '<div class="simulation-update margin-bottom-8">' +
                    'Created the ' +
                    '<span class="gold">' + championship + ' Championship' + '</span>' +
                    '</div>';
                updatesDiv.prepend(newChampionshipDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (releasedSuperstars) {
            releasedSuperstars.forEach(function (superstar) {
                let releasedSuperstarDiv = '<div class="simulation-update margin-bottom-8">' +
                    'Released ' + superstar + ' from the company' +
                    '</div>';
                updatesDiv.prepend(releasedSuperstarDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (streaksEnded) {
            streaksEnded.forEach(function (streak) {
                let unformattedText = '{0} ended {1}\'s {2} match ' +
                    '<span class="obsidian">' +
                    'Undefeated Streak' +
                    '</span>' +
                    ' at {3}';
                let streakText = unformattedText.format(
                    streak['winner'], streak['holder'], streak['length'], streak['event']);
                let streakDiv = '<div class="simulation-update margin-bottom-8">' +
                    streakText +
                    '</div>';
                updatesDiv.prepend(streakDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (powerupsUsed) {
            powerupsUsed.forEach(function (powerup) {
                let usedOn = '';
                if (powerup['usedOn']) {
                    usedOn = ' on ' + powerup['usedOn']
                }
                let powerupUsedDiv = '<div class="simulation-update margin-bottom-8">' +
                    'Used the ' +
                    '<span class="black">' + powerup['name'] + '</span>' + ' Artifact' +
                    usedOn +
                    '</div>';
                updatesDiv.prepend(powerupUsedDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (reviewData && Object.keys(reviewData).length !== 0) {
            let reviewText = '';
            if (reviewData['punishment']) {
                reviewText = '. Lost ' +
                    '<span class="blue">' +
                    '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 ' +
                    'margin-right-5"/>' + reviewData['punishment'] +
                    '</span>' +
                    '.';
            }
            else if (reviewData['bonus']) {
                reviewText = '. Gained ' +
                    '<span class="blue">' +
                    '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 margin-right-5"/>' + reviewData['bonus'] +
                    '</span>';
                if (reviewData['newMatch']) {
                    reviewText += ' and the ' +
                        '<span class="light-blue">' + reviewData['newMatch'] + '</span>' +
                        ' Gimmick Match';
                }
                reviewText += '.';
            }
            let reviewDiv = '<div class="simulation-update margin-bottom-8">' +
                'Completed ' + reviewData['numberOfCompletedObjectives'] + '/3 Owner Goals' +
                reviewText +
                '</div>';
            updatesDiv.prepend(reviewDiv);
            updatesDiv.children().first().hide().fadeIn();
        }

        debutedGimmicks.forEach(function (debutedGimmick) {
            let text = getGimmickDebutHtml(debutedGimmick, true);
            let debutedGimmickHtml = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + '</div>';
            updatesDiv.prepend(debutedGimmickHtml);
            updatesDiv.children().first().hide().fadeIn();
        });

        if (managersTransitioned) {
            managersTransitioned.forEach(function (superstar) {
                let managerTransitionedDiv = '<div class="simulation-update margin-bottom-8">' +
                    'Transitioned ' + superstar + ' to a manager role' +
                    '</div>';
                updatesDiv.prepend(managerTransitionedDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (managersAdded) {
            managersAdded.forEach(function (managerAdded) {
                let text = '<span class="display-block">Assigned {0} to manage {1}</span>'.format(managerAdded['managerName'], commaSeparate(managerAdded['managedSuperstarsNames']));
                let managerAddedDiv = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + '</div>';
                updatesDiv.prepend(managerAddedDiv);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (managersRemoved) {
            managersRemoved.forEach(function (managerRemoved) {
                let text = '<span class="display-block">Removed {0} from managing {1}</span>'.format(managerRemoved['managerName'], commaSeparate(managerRemoved['removedSuperstarsNames']));
                let managerRemovedHtml = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + '</div>';
                updatesDiv.prepend(managerRemovedHtml);
                updatesDiv.children().first().hide().fadeIn();
            });
        }

        if (brandsChanged) {
            brandsChanged.forEach(function (brandChanged) {
                let text = '<span class="display-block">Moved {0} to {1}</span>'.format(brandChanged['superstars'], brandChanged['brand']);
                let brandChangedHtml = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + '</div>';
                updatesDiv.prepend(brandChangedHtml);
                updatesDiv.children().first().hide().fadeIn();
            });
        }
    }

    // Fade and remove old updates
    if (updatesDiv.children().length > updatesToShow) {
        let toRemove = updatesDiv.children().length - updatesToShow;
        updatesDiv.children().slice(-toRemove).remove();
    }
    if (updatesDiv.children().length > updatesToShow / 2) {
        let toFade = updatesDiv.children().length - updatesToShow / 2;
        updatesDiv.children().slice(-toFade).addClass('light-opaque');
    }

    // Add news
    let newsData = data['updates']['news'];
    if (globals.game.competitorsPresent && newsData) {
        newsDiv.show();
        let newsItems = newsData.slice(0, newsToShow / 2);
        newsItems.reverse();
        newsItems.forEach(function (news) {
            let newsHtml = getNewsHtml(news, showNewsContent, true);
            let newsItemDiv = '<div class="simulation-news-item compact">' + newsHtml + '</div>';
            newsDiv.prepend(newsItemDiv);
            newsDiv.children().first().hide().fadeIn();
        });

        // Fade and remove old news
        if (newsDiv.children().length > newsToShow) {
            let toRemove = newsDiv.children().length - newsToShow;
            newsDiv.children().slice(-toRemove).remove();
        }
        if (newsDiv.children().length > newsToShow / 2) {
            newsDiv.children().slice(-(newsToShow / 2)).addClass('light-opaque');
        }
    }
    else {
        newsDiv.hide();
    }

    eventsToSimulate--;

    // Update progress bar/current event
    let progress;
    let currentMonth = (totalEvents - eventsToSimulate);
    if (currentMonth < totalEvents) {
        progress = currentMonth / totalEvents * 100;
    }
    else {
        progress = 100;
    }

    let progressBarHtml =
        '<div class="progress-under margin-bottom-20">' +
        '<div class="progress" style="width:' + progress + '%">' + '</div>' +
        '</div>';

    let info = data['year'];
    if (data['weeklyShowName']) {
        info = `${data['weeklyShowName']} ${data['year']}`
    }

    let progressHtml =
        '<div id="simulation-progress-bar" class="margin-bottom-25">' + progressBarHtml + '</div>' +
        '<div id="simulation-progress-event">' +
        '<span class="display-block dark-grey">' + data['event'] + '</span>' +
        '<span class="display-block grey font-bold year">' + info + '</span>' +
        '</div>';

    progressDiv.html(progressHtml);

    // Update points and fans
    updateGamePointsAndFans(data['points'], data['fans']);

    // Continue simulation if there are events left to simulate and 'stop simulation' button not selected
    let stopSimulation = $('#simulation-results-container').data('stopSimulation');
    if (eventsToSimulate >= 1 && !stopSimulation) {
        setTimeout(async () => {
            await makeGameRequest(runSimulator, {style, eventsToSimulate, simulatorOption},
                showRunSimulatorData, {style, eventsToSimulate, notificationsOption, simulatorOption,
                    totalEvents}, false, true, true, false);
        }, 500);
    }
    else {
        // End simulation, load home page if game is loaded
        if ($('#game:visible').length > 0) {
            await loadHomePage(await getCurrentGame(), false);
            $('#stop-simulation-button').parent().hide();
            $('.simulation-progress-loading').hide();
            notie.alert({type: 4, text: 'Simulation Complete'});
        }
        return true;
    }
}

function showGetCompanyUniqueTournamentsData({data} = {}) {
    // Reset ui
    selectedElements.forEach(function (x) {
        $(x).toggleClass("selected");
    });
    selectedElements = [];
    selectedParticipants = [];
    selectedGimmickMatch = '';
    if (selectedChampionship) {
        selectedChampionship.removeClass('selected');
    }
    selectedChampionship = '';
    $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
    $('.superstar-select-feud-details').remove();
    $("#multi-match-info").remove();
    $('.match-participants-container').text('No participants selected');
    $("#multi-match-button").addClass('selected');
    $("#multi-match-button").find('.fa').removeClass('fa-circle-o').addClass('fa-check-circle-o');
    $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');
    $('#select-gimmick-match-container').hide();
    $('.book-match-feuds-container').hide();
    $("#show-gimmick-matches-button").hide();
    $('#add-tournament-menu-button').addClass('selected');
    hideEventCardContent($('#event-card'));

    // Add tournament booking html
    let tournamentBookingHtml = getTournamentBookingHtml(data);
    $('#add-tournament-container').html(tournamentBookingHtml).show();
}

function getTournamentBookingHtml(data) {
    // Add previous tournament select
    let previousTournamentsDiv = '';
    if (data['tournaments'].length > 0) {
        previousTournamentsDiv = '<p class="margin-bottom-10">' +
            '<select id="add-tournament-select" class="styled-select help-text" ' +
            'title="Hold a previously held Tournament, affecting its Prestige and Win Bonus">';
        previousTournamentsDiv += '<option selected value="">Select Tournament</option>';

        data['tournaments'].forEach(function (tournament) {
            let matchContractName = '';
            if (tournament['matchContractName']) {
                matchContractName = tournament['matchContractName'].replace(/"/g, "&quot;")
            }

            previousTournamentsDiv += '<option data-prestige="' + tournament['prestige'] + '" ' +
                'data-cost="' + tournament['cost'] +
                '" data-match-contract-name="' + matchContractName + '">' +
                tournament['name'] + '</option>';
        });

        previousTournamentsDiv += '</select>' +
            '<span class="display-inline add-tournament-select-prestige"></span>' +
            '</p>';
    }

    // Add round robin inputs
    let numberOfGroups =
        '<select name="number-of-groups" id="number-of-groups" class="styled-select">' +
        '<option value="1">1</option>' +
        '<option value="2" selected>2</option>' +
        '<option value="4">4</option>' +
        '</select>';
    let participantsAdvancing =
        '<select name="participants-advancing" id="participants-advancing" class="styled-select">' +
        '<option value="1" selected>1</option>' +
        '<option value="2">2</option>' +
        '</select>';

    // Add match contract inputs
    let selectOptions = '';
    data['events'].forEach(function (event) {
        selectOptions += '<option>' + event + '</option>'
    });

    let awardOptions =
        '<label class="control control--radio margin-right-10">None<input type="radio" name="radio-award-option" value="none" checked="checked"><div class="control__indicator"></div></label>' +
        '<label class="control control--radio margin-right-10">Match Contract<input type="radio" name="radio-award-option" value="match-contract"><div class="control__indicator"></div></label>';

    let matchContractEventSelect =
        '<select id="tournament-match-contract-event" class="display-block help-text styled-select" ' +
        'title="Select event to hold this match contract at">' +
        selectOptions + '</select>';
    let matchContractNameInput =
        '<input type="text" id="tournament-match-contract-name" ' +
        'name="match-contract-name" class="margin-bottom-10 display-block styled-input help-text" ' +
        'placeholder="Match Contract Name" ' +
        'title="Enter the name to give to the created match contract e.g \'Title Match\'">';

    // Add auto picker
    let autoPickPronounFilter = '';
    let autoPickBookedFilter = '';
    let singlesOptions = '';
    if ($('#book-singles-menu-button').hasClass('selected')) {
        autoPickPronounFilter =
            '<select name="auto-pick-pronoun-filter" id="auto-pick-pronoun-filter" class="styled-select">' +
            '<option value="0" selected>All Pronouns</option>' +
            '<option value="1">He</option>' +
            '<option value="2">She</option>' +
            '<option value="3">They</option>' +
            '</select>';
        autoPickBookedFilter =
            '<select name="auto-pick-booked-filter" id="auto-pick-booked-filter" class="styled-select margin-right-5">' +
            '<option value="0" selected>Not Booked</option>' +
            '<option value="1">All</option>' +
            '</select>';
        singlesOptions =
            '<option value="1">M. Event - U. Midcard</option>' +
            '<option value="2">Upper Midcard</option>' +
            '<option value="3">U. Midcard - L. Midcard</option>' +
            '<option value="4">Lower Midcard</option>';
    }

    return '<div class="add-tournament-container box margin-0-auto font-bold">' +
        '<div class="margin-bottom-10">' +
        '<span class="font-mukta-mahee font-1p325em menu-header-color">Tournament</span>' +
        '<span class="blue float-right">' +
        '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/> ' +
        '<span class="add-tournament-cost">150</span>' +
        '</span>' +
        '</div>' +
        '<div class="margin-bottom-15 line-height-1p4 font-0p825em grey-blue-dark">' +
        '<i class="fa fa-info-circle margin-right-2"></i> ' +
        'Tournament will run at this Monthly Event. Any extra preliminary Matches will be held at a newly created Weekly Show before this Event.' +
        '</div>' +
        '<div>' +
        previousTournamentsDiv +
        '<div class="margin-bottom-10">' +
        '<input type="text" id="tournament-name" placeholder="' + 'Tournament Name' + '" ' +
        'class="styled-input help-text" title="Create a new Tournament">' +
        '</div>' +
        '<div class="margin-bottom-10">' +
        '<select id="tournament-type" class="styled-select">' +
        '<option value="elimination">Elimination</option>' +
        '<option value="round-robin">Round Robin</option>' +
        '</select>' +
        '</div>' +
        '<div class="display-none round-robin-options font-0p825em">' +
        '<div class="margin-bottom-10">' +
        numberOfGroups + '<span class="number-of-groups-text"> Groups</span>' +
        '</div>' +
        '<div class="margin-bottom-10">' +
        participantsAdvancing + '<span class="participant-advancing-text"> Participant advances</span>' +
        '</div>' +
        '</div>' +
        '<div class="margin-bottom-20 font-0p825em">' +
        '<select class="styled-select margin-right-3 help-text" id="tournament-matches-at-event" ' +
        'title="The rest of the matches will be held at Weekly Shows before the event">' +
        '<option value="finals">Final</option>' +
        '<option selected value="semi-finals">Semi-Finals</option>' +
        '<option value="quarter-finals">Quarter-Finals</option>' +
        '</select> at Event' +
        '</div>' +

        '<div class="margin-bottom-20 font-0p825em">' +
        '<div class="display-block margin-bottom-5 font-1p125em help-text" ' +
        'title="Add an Award to be given to the Tournament winner. Create a Match Contract below or select ' +
        'a Vacant Championship by clicking on it.">Award</div>' +
        '<div class="margin-bottom-8 award-options">' + awardOptions + '</div>' +
        '<div class="display-none award-options-match-contract">' +
        matchContractNameInput + matchContractEventSelect +
        '</div>' +
        '</div>' +

        '<div class="margin-bottom-8 font-0p825em help-text" ' +
        'title="Select participants by clicking on them below or using the Auto Picker. You ' +
        'can only select powers of 2 e.g 4/8/16/32 etc.">' +
        '<span class="tournament-participants-selected">' +
        '0</span>' +
        ' participants selected' +
        '</div>' +

        '<div id="auto-picker" class="font-bold margin-bottom-20">' +
        '<select name="auto-pick-number" id="auto-pick-input" class="styled-select">' +
        '<option value="4">4</option>' +
        '<option value="8">8</option>' +
        '<option value="16" selected>16</option>' +
        '<option value="32">32</option>' +
        '<option value="64">64</option>' +
        '<option value="128">128</option>' +
        '</select>' +
        '<select name="auto-pick-from" id="auto-pick-sort" class="margin-left-5 styled-select margin-right-5">' +
        '<option value="0" selected>Top</option>' +
        singlesOptions +
        '<option value="5">Bottom</option>' +
        '<option value="6">Random</option>' +
        '</select>' +
        autoPickPronounFilter +
        autoPickBookedFilter +
        '<button type="button" id="auto-pick" data-type="tournament" class="button retro-button condensed blue-button-background margin-top-7">' +
            'Auto Pick' +
        '</button>' +
        '</div>' +
        '<div">' +
        '<button type="button" ' +
        'class="button retro-button blue-button-background" id="create-bracket">Create Bracket</button> ' +
        '</div>' +

        '<div class="tournament-bracket-container font-bold display-none margin-top-10"></div>' +
        '<div class="tournament-groups-container font-bold display-none margin-bottom-20 margin-top-10"></div>' +

        '</div>' +
        '</div>';
}

function setTournamentMatchesAtEvent() {
    let matchesAtEventSelect = $('#tournament-matches-at-event');
    let matchesAtEventHtml;

    if ($('#tournament-type').val() === 'elimination') {
        matchesAtEventHtml =
            '<option value="finals">Final</option>' +
            '<option selected value="semi-finals">Semi-Finals</option>' +
            '<option value="quarter-finals">Quarter-Finals</option>'
    }
    else {
        let groups = $('#number-of-groups').val();
        let participantsAdvancing = $('#participants-advancing').val();
        let totalParticipantsAdvancing = parseInt(groups) * parseInt(participantsAdvancing);

        let options = ['<option selected value="finals">Final</option>', '<option value="semi-finals">Semi-Finals</option>',
            '<option value="quarter-finals">Quarter-Finals</option>'];
        let optionsIndex = (totalParticipantsAdvancing !== 0) ? totalParticipantsAdvancing / 2 : 0;

        if (optionsIndex === 0) {
            matchesAtEventHtml = '<option selected value="0">Final Round</option>' +
                '<option value="2">Last 2 Matches</option>' +
                '<option value="4">Last 4 Matches</option>' +
                '<option value="8">Last 8 Matches</option>'
        }
        else {
            matchesAtEventHtml = options.slice(0, optionsIndex).join('');
        }
    }
    matchesAtEventSelect.html(matchesAtEventHtml);
}

function showGetTournamentDisplayData({data, participantsData, tournamentType, $el}) {
    if (!data['error']) {
        // Change create button text to 'Re-create'
        let buttonText = $el.text();
        buttonText = buttonText.replace('Create', 'Re-create');
        $el.text(buttonText);

        if (tournamentType === 'elimination') {
            // Add bracket
            let tournamentRound = 1;
            let tournamentRounds = Object.keys(data['bracket']).length;
            let bracket = data['bracket'][tournamentRound];
            let bracketDiv = getTournamentBracketHtml(bracket, tournamentRound, tournamentRounds, true);

            $('.add-tournament-container').find('.tournament-bracket-container').html(bracketDiv);
            $('.tournament-bracket-container').show();

            addTournamentParticipantsEditing('.tournament-bracket-container');
        } else if (tournamentType === 'round-robin') {
            // Add groups
            let groupsDiv = getTournamentGroupsHtml(data['table'], participantsData.length, true);
            $('.add-tournament-container').find('.tournament-groups-container').html(groupsDiv);
            $('.tournament-groups-container').show();

            addTournamentParticipantsEditing('.tournament-groups-container');
        }

        // Add create tournament button
        if (!$('#create-tournament').length) {
            let button =
                '<span class="margin-bottom-20 margin-left-5">' +
                '<button type="button" ' +
                'class="button retro-button blue-button-background" id="create-tournament">Create Tournament</button> ' +
                '</span>';
            $('.add-tournament-container').find('#create-bracket').after(button);
        }
    }
    else {
        if (data['error'] === 'participant-not-found') {
            notie.alert({type: 3, text: "One of the participants selected could not be found. Please try again."});
        }
        else if (data['error'] === 'duplicate-participant') {
            notie.alert({type: 3, text: "One of the participants was found more than once in the selections. Please try again."});
        }
    }
}

async function showCreateTournamentData({data, matchType}) {
    if (!data['error']) {
        $('#add-tournament-container').hide();
        $("#add-tournament-menu-button").toggleClass("selected");
        $('#multi-match-button').toggleClass('selected');
        $('#multi-match-button').find('.fa').removeClass('fa-check-circle-o').addClass('fa-circle-o');
        $("#show-gimmick-matches-button").show();
        $('.book-match-feuds-container').show();

        // Lower opacity of selected elements
        if (matchType === 'singles') {
            selectedElements.forEach(function (x) {
                $(x).addClass("booked");
            });
        }

        // Unselect selected elements
        selectedElements.forEach(function (x) {
            $(x).toggleClass('selected');
        });

        // Unselect selected championship
        if (selectedChampionship) {
            selectedChampionship.removeClass('selected');
        }

        // Reset selections
        selectedParticipants = [];
        selectedElements = [];
        selectedChampionship = '';

        // Reset ui
        $('.superstar-select').removeClass('current-feud potential-feud partner-superstar');
        $('.superstar-select-feud-details').remove();
        $("#multi-match-info").remove();
        $('.match-participants-container').text('No participants selected');
        $(".feud-container").show().removeClass('selected');

        // Update matches if not going to weekly show
        if (!data['weeklyShowCreated']) {
            addEventCardMatchesAndSegments(data['matchesAndSegments']);

            // Update points
            let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
            $(".points-number").html(pointsHtml);
        }

        // Remove selected title
        if (selectedChampionship) {
            selectedChampionship.fadeOut();
        }

        // Game loop if matches added to weekly show
        if (data['weeklyShowCreated']) {
            await loadHomePage(await getCurrentGame());
        }

        // Update match limits
        let matchLimitsHtml = getMatchLimitsHtml();
        $('#match-limits').html(matchLimitsHtml);
    } else {
        let error = '';
        if (data['error'] === 'non-unique-name') {
            error = 'Enter a unique name for this Tournament'
        } else if (data['error'] === 'tournament-booked') {
            error = 'You already have a tournament booked at this event'
        } else if (data['error'] === 'match-contract-exists') {
            error = "A Match Contract with that name already exists. You can book another one after using it."
        } else if (data['error'] === 'not-found') {
            error = "The selected participants could not be found. Please try again."
        } else if (data['error'] === 'duplicate-superstar') {
            error = data['duplicateSuperstar'] + ' was booked more than once in the Tournament'
        } else if (data['error'] === 'no-women-allowed') {
            error = "Women are not allowed to be booked at this event"
        } else if (data['error'] === 'no-men-allowed') {
            error = "Men are not allowed to be booked at this event"
        } else if (data['error'] === 'not-enough-points') {
            error = "You do not have enough Creative Points to add a tournament"
        }
        notie.alert({type: 3, text: error});
    }
}

export {showSuperstarInformation, showTagteamInformation}